/* tslint:disable */
/* eslint-disable */
/**
 * WorkloadsService
 * An API for managing RunAi scheduler managed workloads.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@run.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * The action to perform on the list of ids.
 * @export
 * @enum {string}
 */

export const Action = {
    Delete: 'delete',
    Suspend: 'suspend',
    Resume: 'resume'
} as const;

export type Action = typeof Action[keyof typeof Action];


/**
 * The actions support provided for the workload.
 * @export
 * @interface ActionsSupport
 */
export interface ActionsSupport {
    /**
     * 
     * @type {boolean}
     * @memberof ActionsSupport
     */
    'delete'?: boolean;
    /**
     * This permission includes resume as well as suspend.
     * @type {boolean}
     * @memberof ActionsSupport
     */
    'suspend'?: boolean;
}
/**
 * 
 * @export
 * @interface AdvancedFlatFields
 */
export interface AdvancedFlatFields {
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof AdvancedFlatFields
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof AdvancedFlatFields
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof AdvancedFlatFields
     */
    'restartPolicy'?: RestartPolicy | null;
}
/**
 * 
 * @export
 * @interface AdvancedFlatFieldsRules
 */
export interface AdvancedFlatFieldsRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AdvancedFlatFieldsRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof AdvancedFlatFieldsRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
}
/**
 * 
 * @export
 * @interface AdvancedItemizedDefaults
 */
export interface AdvancedItemizedDefaults {
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof AdvancedItemizedDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof AdvancedItemizedDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof AdvancedItemizedDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
}
/**
 * 
 * @export
 * @interface AdvancedItemizedFields
 */
export interface AdvancedItemizedFields {
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof AdvancedItemizedFields
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof AdvancedItemizedFields
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof AdvancedItemizedFields
     */
    'tolerations'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface AdvancedItemizedRules
 */
export interface AdvancedItemizedRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof AdvancedItemizedRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof AdvancedItemizedRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof AdvancedItemizedRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * 
 * @export
 * @interface AllocatedResources
 */
export interface AllocatedResources {
    /**
     * Required if and only if gpuRequestType is portion. States the number of GPUs allocated for the created workload. The default is no allocated GPUs.
     * @type {number}
     * @memberof AllocatedResources
     */
    'gpu'?: number | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof AllocatedResources
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * 
     * @type {string}
     * @memberof AllocatedResources
     */
    'gpuMemory'?: string | null;
    /**
     * States the amount of CPU cores used by the workload running.
     * @type {number}
     * @memberof AllocatedResources
     */
    'cpu'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AllocatedResources
     */
    'cpuMemory'?: string | null;
    /**
     * Set of extended resources with their quantity
     * @type {Array<WorkloadsExtendedResource>}
     * @memberof AllocatedResources
     */
    'extendedResources'?: Array<WorkloadsExtendedResource> | null;
}
/**
 * The ancestors of an org unit.
 * @export
 * @interface Ancestors
 */
export interface Ancestors {
    /**
     * 
     * @type {string}
     * @memberof Ancestors
     */
    'tenant_id': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Ancestors
     */
    'cluster_uuid'?: string | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof Ancestors
     */
    'department_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ancestors
     */
    'project_id'?: string | null;
}
/**
 * Annotation details to be populated into the container.
 * @export
 * @interface Annotation
 */
export interface Annotation {
    /**
     * The name of the annotation (mandatory)
     * @type {string}
     * @memberof Annotation
     */
    'name'?: string | null;
    /**
     * The value of the annotation.
     * @type {string}
     * @memberof Annotation
     */
    'value'?: string | null;
    /**
     * Use \'true\' in case the annotation is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Annotation
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AnnotationsDefaults
 */
export interface AnnotationsDefaults {
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof AnnotationsDefaults
     */
    'instances'?: Array<Annotation> | null;
}
/**
 * 
 * @export
 * @interface AnnotationsField
 */
export interface AnnotationsField {
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof AnnotationsField
     */
    'annotations'?: Array<Annotation> | null;
}
/**
 * 
 * @export
 * @interface AnnotationsFieldDefaults
 */
export interface AnnotationsFieldDefaults {
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof AnnotationsFieldDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
}
/**
 * 
 * @export
 * @interface AnnotationsFieldRules
 */
export interface AnnotationsFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof AnnotationsFieldRules
     */
    'annotations'?: InstancesRules | null;
}
/**
 * 
 * @export
 * @interface ArrayRules
 */
export interface ArrayRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ArrayRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether this array is mandatory. Mandatory array must include at least one item. default to false.
     * @type {boolean}
     * @memberof ArrayRules
     */
    'required'?: boolean | null;
    /**
     * Set of options that the value of each item of the array must be chosen from.
     * @type {Array<StringOption>}
     * @memberof ArrayRules
     */
    'options'?: Array<StringOption>;
    /**
     * Whether the value of the array, as a whole, is editable. default to false.
     * @type {boolean}
     * @memberof ArrayRules
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @interface AutoScaling
 */
export interface AutoScaling {
    /**
     * The percentage of metric threshold value to use for autoscaling. Defaults to 70. Applicable only with the \'throughput\' and \'concurrency\' metrics
     * @type {number}
     * @memberof AutoScaling
     */
    'metricThresholdPercentage'?: number | null;
    /**
     * The minimum number of replicas for autoscaling. Defaults to 1. Use 0 to allow scale-to-zero
     * @type {number}
     * @memberof AutoScaling
     */
    'minReplicas'?: number | null;
    /**
     * The maximum number of replicas for autoscaling. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'maxReplicas'?: number | null;
    /**
     * The number of replicas to run when initializing the workload for the first time. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'initialReplicas'?: number | null;
    /**
     * The number of replicas to run when scaling-up from zero. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'activationReplicas'?: number | null;
    /**
     * The maximum number of requests allowed to flow to a single replica at any time. 0 means no limit
     * @type {number}
     * @memberof AutoScaling
     */
    'concurrencyHardLimit'?: number | null;
    /**
     * The minimum amount of time (in seconds) that the last replica will remain active after a scale-to-zero decision. Defaults to 0. Available only if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScaling
     */
    'scaleToZeroRetentionSeconds'?: number | null;
    /**
     * The minimum amount of time (in seconds) that a replica will remain active after a scale-down decision
     * @type {number}
     * @memberof AutoScaling
     */
    'scaleDownDelaySeconds'?: number | null;
    /**
     * The maximum amount of time (in seconds) to wait for the container to become ready
     * @type {number}
     * @memberof AutoScaling
     */
    'initializationTimeoutSeconds'?: number | null;
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScaling
     */
    'metric'?: string | null;
    /**
     * The threshold to use with the specified metric for autoscaling. Mandatory if metric is specified
     * @type {number}
     * @memberof AutoScaling
     */
    'metricThreshold'?: number | null;
}
/**
 * Auto scaling common fields
 * @export
 * @interface AutoScalingCommonFields
 */
export interface AutoScalingCommonFields {
    /**
     * The percentage of metric threshold value to use for autoscaling. Defaults to 70. Applicable only with the \'throughput\' and \'concurrency\' metrics
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'metricThresholdPercentage'?: number | null;
    /**
     * The minimum number of replicas for autoscaling. Defaults to 1. Use 0 to allow scale-to-zero
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'minReplicas'?: number | null;
    /**
     * The maximum number of replicas for autoscaling. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'maxReplicas'?: number | null;
    /**
     * The number of replicas to run when initializing the workload for the first time. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'initialReplicas'?: number | null;
    /**
     * The number of replicas to run when scaling-up from zero. Defaults to minReplicas, or to 1 if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'activationReplicas'?: number | null;
    /**
     * The maximum number of requests allowed to flow to a single replica at any time. 0 means no limit
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'concurrencyHardLimit'?: number | null;
    /**
     * The minimum amount of time (in seconds) that the last replica will remain active after a scale-to-zero decision. Defaults to 0. Available only if minReplicas is set to 0
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'scaleToZeroRetentionSeconds'?: number | null;
    /**
     * The minimum amount of time (in seconds) that a replica will remain active after a scale-down decision
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'scaleDownDelaySeconds'?: number | null;
    /**
     * The maximum amount of time (in seconds) to wait for the container to become ready
     * @type {number}
     * @memberof AutoScalingCommonFields
     */
    'initializationTimeoutSeconds'?: number | null;
}
/**
 * Auto scaling metric fields
 * @export
 * @interface AutoScalingMetricFields
 */
export interface AutoScalingMetricFields {
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScalingMetricFields
     */
    'metric'?: string | null;
    /**
     * The threshold to use with the specified metric for autoscaling. Mandatory if metric is specified
     * @type {number}
     * @memberof AutoScalingMetricFields
     */
    'metricThreshold'?: number | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricOptions
 */
export interface AutoScalingMetricOptions {
    /**
     * 
     * @type {Array<AutoScalingMetricOptionsOptionsInner>}
     * @memberof AutoScalingMetricOptions
     */
    'options'?: Array<AutoScalingMetricOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricOptionsOptionsInner
 */
export interface AutoScalingMetricOptionsOptionsInner {
    /**
     * The metric to use for autoscaling. Mandatory if minReplicas < maxReplicas, except for the special case where minReplicas is set to 0 and maxReplicas is set to 1, as in this case autoscaling decisions are made according to network activity rather than metrics. Use one of the built-in metrics of \'throughput\', \'concurrency\' or \'latency\', or any other available custom metric. Only the \'throughput\' and \'concurrency\' metrics support scale-to-zero
     * @type {string}
     * @memberof AutoScalingMetricOptionsOptionsInner
     */
    'value': string | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof AutoScalingMetricOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface AutoScalingMetricRules
 */
export interface AutoScalingMetricRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof AutoScalingMetricRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof AutoScalingMetricRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof AutoScalingMetricRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<AutoScalingMetricOptionsOptionsInner>}
     * @memberof AutoScalingMetricRules
     */
    'options'?: Array<AutoScalingMetricOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface AutoScalingRules
 */
export interface AutoScalingRules {
    /**
     * 
     * @type {NumberRules}
     * @memberof AutoScalingRules
     */
    'metricThresholdPercentage'?: NumberRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'initialReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'activationReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {AutoScalingMetricRules}
     * @memberof AutoScalingRules
     */
    'metric'?: AutoScalingMetricRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'metricThreshold'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'concurrencyHardLimit'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'scaleToZeroRetentionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'scaleDownDelaySeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof AutoScalingRules
     */
    'initializationTimeoutSeconds'?: IntegerRules | null;
}
/**
 * 
 * @export
 * @interface BatchResponse
 */
export interface BatchResponse {
    /**
     * The ID of the batch operation.
     * @type {string}
     * @memberof BatchResponse
     */
    'id': string;
    /**
     * List of ids to perform the action on.
     * @type {Array<string>}
     * @memberof BatchResponse
     */
    'succeeded'?: Array<string>;
    /**
     * The IDs that failed to update.
     * @type {Array<BatchResponseFailureItem>}
     * @memberof BatchResponse
     */
    'failed'?: Array<BatchResponseFailureItem>;
}
/**
 * 
 * @export
 * @interface BatchResponseFailureItem
 */
export interface BatchResponseFailureItem {
    /**
     * 
     * @type {string}
     * @memberof BatchResponseFailureItem
     */
    'id': string;
    /**
     * The error code.
     * @type {number}
     * @memberof BatchResponseFailureItem
     */
    'code': number;
    /**
     * The error message.
     * @type {string}
     * @memberof BatchResponseFailureItem
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface BooleanRules
 */
export interface BooleanRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof BooleanRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof BooleanRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof BooleanRules
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Capability = {
    AuditControl: 'AUDIT_CONTROL',
    AuditRead: 'AUDIT_READ',
    AuditWrite: 'AUDIT_WRITE',
    BlockSuspend: 'BLOCK_SUSPEND',
    Chown: 'CHOWN',
    DacOverride: 'DAC_OVERRIDE',
    DacReadSearch: 'DAC_READ_SEARCH',
    Fowner: 'FOWNER',
    Fsetid: 'FSETID',
    IpcLock: 'IPC_LOCK',
    IpcOwner: 'IPC_OWNER',
    Kill: 'KILL',
    Lease: 'LEASE',
    LinuxImmutable: 'LINUX_IMMUTABLE',
    MacAdmin: 'MAC_ADMIN',
    MacOverride: 'MAC_OVERRIDE',
    Mknod: 'MKNOD',
    NetAdmin: 'NET_ADMIN',
    NetBindService: 'NET_BIND_SERVICE',
    NetBroadcast: 'NET_BROADCAST',
    NetRaw: 'NET_RAW',
    Setgid: 'SETGID',
    Setfcap: 'SETFCAP',
    Setpcap: 'SETPCAP',
    Setuid: 'SETUID',
    SysAdmin: 'SYS_ADMIN',
    SysBoot: 'SYS_BOOT',
    SysChroot: 'SYS_CHROOT',
    SysModule: 'SYS_MODULE',
    SysNice: 'SYS_NICE',
    SysPacct: 'SYS_PACCT',
    SysPtrace: 'SYS_PTRACE',
    SysRawio: 'SYS_RAWIO',
    SysResource: 'SYS_RESOURCE',
    SysTime: 'SYS_TIME',
    SysTtyConfig: 'SYS_TTY_CONFIG',
    Syslog: 'SYSLOG',
    WakeAlarm: 'WAKE_ALARM'
} as const;

export type Capability = typeof Capability[keyof typeof Capability];


/**
 * Claim information for the newly created PVC. The information should not be provided when attempting to use existing PVC.
 * @export
 * @interface ClaimInfo
 */
export interface ClaimInfo {
    /**
     * Requested size for the PVC. Mandatory when existingPvc is false. Recommended sizes: TB/GB/MB/TIB/GIB/MIB
     * @type {string}
     * @memberof ClaimInfo
     */
    'size'?: string | null;
    /**
     * Storage class name to associate with the PVC. This parameter may be omitted if there is a single storage class in the system, or you are using the default storage class. For more information, see [Storage class](https://kubernetes.io/docs/concepts/storage/storage-classes).
     * @type {string}
     * @memberof ClaimInfo
     */
    'storageClass'?: string | null;
    /**
     * 
     * @type {PvcAccessModes}
     * @memberof ClaimInfo
     */
    'accessModes'?: PvcAccessModes | null;
    /**
     * 
     * @type {PvcVolumeMode}
     * @memberof ClaimInfo
     */
    'volumeMode'?: PvcVolumeMode | null;
    /**
     * an optional array of key-values pairs that are written as annotations on the created PVC. the allowed attributes are determined according to the storage class configuration (see k8s-objects-tracker for further info).
     * @type {Array<PvcAddedAttrValue>}
     * @memberof ClaimInfo
     */
    'addedAttrValues'?: Array<PvcAddedAttrValue>;
}
/**
 * 
 * @export
 * @interface ClaimInfoRules
 */
export interface ClaimInfoRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ClaimInfoRules
     */
    'size'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ClaimInfoRules
     */
    'storageClass'?: StringRules | null;
    /**
     * 
     * @type {PvcAccessModesRules}
     * @memberof ClaimInfoRules
     */
    'accessModes'?: PvcAccessModesRules | null;
}
/**
 * Claim information updatable fields.
 * @export
 * @interface ClaimInfoUpdatable
 */
export interface ClaimInfoUpdatable {
    /**
     * Requested size for the PVC. Mandatory when existingPvc is false. Recommended sizes: TB/GB/MB/TIB/GIB/MIB
     * @type {string}
     * @memberof ClaimInfoUpdatable
     */
    'size'?: string | null;
    /**
     * an optional array of key-values pairs that are written as annotations on the created PVC. the allowed attributes are determined according to the storage class configuration (see k8s-objects-tracker for further info).
     * @type {Array<PvcAddedAttrValue>}
     * @memberof ClaimInfoUpdatable
     */
    'addedAttrValues'?: Array<PvcAddedAttrValue>;
}
/**
 * allow cluster to report about success/failures of sync updates
 * @export
 * @interface ClusterSyncReport
 */
export interface ClusterSyncReport {
    /**
     * 
     * @type {Array<ClusterSyncReportUpdate>}
     * @memberof ClusterSyncReport
     */
    'updates'?: Array<ClusterSyncReportUpdate>;
}
/**
 * success/failure report of a single update attempt of the cluster
 * @export
 * @interface ClusterSyncReportUpdate
 */
export interface ClusterSyncReportUpdate {
    /**
     * a unique id of the entity being updated (asset, workload, policy, etc).
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'id'?: string;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof ClusterSyncReportUpdate
     */
    'updateCount'?: number;
    /**
     * the time in which the cluster attempted the update.
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'updateAttemptTime'?: string;
    /**
     * optional failure message for the case that the update has failed. should be sent null if the update was successful.
     * @type {string}
     * @memberof ClusterSyncReportUpdate
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface CommonFlatFields
 */
export interface CommonFlatFields {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof CommonFlatFields
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof CommonFlatFields
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof CommonFlatFields
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof CommonFlatFields
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof CommonFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof CommonFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof CommonFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * 
 * @export
 * @interface CommonFlatFieldsRules
 */
export interface CommonFlatFieldsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof CommonFlatFieldsRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonFlatFieldsRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof CommonFlatFieldsRules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonFlatFieldsRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof CommonFlatFieldsRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof CommonFlatFieldsRules
     */
    'podAffinity'?: PodAffinityRules | null;
}
/**
 * 
 * @export
 * @interface CommonItemizedDefaults
 */
export interface CommonItemizedDefaults {
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof CommonItemizedDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof CommonItemizedDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof CommonItemizedDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof CommonItemizedDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
}
/**
 * 
 * @export
 * @interface CommonItemizedFields
 */
export interface CommonItemizedFields {
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof CommonItemizedFields
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof CommonItemizedFields
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof CommonItemizedFields
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof CommonItemizedFields
     */
    'tolerations'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface CommonItemizedFieldsRules
 */
export interface CommonItemizedFieldsRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof CommonItemizedFieldsRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof CommonItemizedFieldsRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof CommonItemizedFieldsRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof CommonItemizedFieldsRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * 
 * @export
 * @interface CommonSecurity
 */
export interface CommonSecurity {
    /**
     * 
     * @type {CommonSecurityFlatFields}
     * @memberof CommonSecurity
     */
    'security'?: CommonSecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface CommonSecurityFlatFields
 */
export interface CommonSecurityFlatFields {
    /**
     * 
     * @type {UidGidSource}
     * @memberof CommonSecurityFlatFields
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof CommonSecurityFlatFields
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof CommonSecurityFlatFields
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof CommonSecurityFlatFields
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof CommonSecurityFlatFields
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityFlatFields
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityFlatFields
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof CommonSecurityFlatFields
     */
    'supplementalGroups'?: string | null;
}
/**
 * 
 * @export
 * @interface CommonSecurityFlatFieldsRules
 */
export interface CommonSecurityFlatFieldsRules {
    /**
     * 
     * @type {UidGidSourceRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'uidGidSource'?: UidGidSourceRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'capabilities'?: ArrayRules | null;
    /**
     * 
     * @type {SeccompProfileTypeRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'seccompProfileType'?: SeccompProfileTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'runAsNonRoot'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'readOnlyRootFilesystem'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonSecurityFlatFieldsRules
     */
    'supplementalGroups'?: StringRules | null;
}
/**
 * Security non overrideable fields. In the context of assets,these are environment asset fields that cannot be overriden in the submit workload request.
 * @export
 * @interface CommonSecurityNonOverridable
 */
export interface CommonSecurityNonOverridable {
    /**
     * 
     * @type {UidGidSource}
     * @memberof CommonSecurityNonOverridable
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof CommonSecurityNonOverridable
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof CommonSecurityNonOverridable
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof CommonSecurityNonOverridable
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof CommonSecurityNonOverridable
     */
    'readOnlyRootFilesystem'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CommonSecurityNonOverridableRules
 */
export interface CommonSecurityNonOverridableRules {
    /**
     * 
     * @type {UidGidSourceRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'uidGidSource'?: UidGidSourceRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'capabilities'?: ArrayRules | null;
    /**
     * 
     * @type {SeccompProfileTypeRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'seccompProfileType'?: SeccompProfileTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'runAsNonRoot'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof CommonSecurityNonOverridableRules
     */
    'readOnlyRootFilesystem'?: BooleanRules | null;
}
/**
 * Security overrideable fields. In the context of assets,these are environment asset fields that can be overriden in the submit workload request.
 * @export
 * @interface CommonSecurityOverridable
 */
export interface CommonSecurityOverridable {
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityOverridable
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof CommonSecurityOverridable
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof CommonSecurityOverridable
     */
    'supplementalGroups'?: string | null;
}
/**
 * Security related fields. When used in assets context, those are environment asset fields that can be override in the submit workload request.
 * @export
 * @interface CommonSecurityOverridableRules
 */
export interface CommonSecurityOverridableRules {
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityOverridableRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof CommonSecurityOverridableRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof CommonSecurityOverridableRules
     */
    'supplementalGroups'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface CommonStorage
 */
export interface CommonStorage {
    /**
     * 
     * @type {CommonStorageFields}
     * @memberof CommonStorage
     */
    'storage'?: CommonStorageFields | null;
}
/**
 * 
 * @export
 * @interface CommonStorageFields
 */
export interface CommonStorageFields {
    /**
     * Set of data volumes to use in the workload.
     * @type {Array<DataVolumeInstance>}
     * @memberof CommonStorageFields
     */
    'dataVolume'?: Array<DataVolumeInstance> | null;
    /**
     * Set of pvc persistent volume claims to use in the workload.
     * @type {Array<PvcInstance>}
     * @memberof CommonStorageFields
     */
    'pvc'?: Array<PvcInstance> | null;
    /**
     * Set of host paths to use in the workload.
     * @type {Array<HostPathInstance>}
     * @memberof CommonStorageFields
     */
    'hostPath'?: Array<HostPathInstance> | null;
    /**
     * Set of nfs volumes to use in the workload.
     * @type {Array<NfsInstance>}
     * @memberof CommonStorageFields
     */
    'nfs'?: Array<NfsInstance> | null;
    /**
     * Set of git repositories to use in the workload.
     * @type {Array<GitInstance>}
     * @memberof CommonStorageFields
     */
    'git'?: Array<GitInstance> | null;
    /**
     * Set of config map volumes to use in the workload
     * @type {Array<ConfigMapInstance>}
     * @memberof CommonStorageFields
     */
    'configMapVolume'?: Array<ConfigMapInstance> | null;
    /**
     * Set of secret volumes to use in the workload
     * @type {Array<SecretInstance>}
     * @memberof CommonStorageFields
     */
    'secretVolume'?: Array<SecretInstance> | null;
}
/**
 * 
 * @export
 * @interface CommonStorageFieldsDefaults
 */
export interface CommonStorageFieldsDefaults {
    /**
     * 
     * @type {DataVolumesDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'dataVolume'?: DataVolumesDefaults | null;
    /**
     * 
     * @type {PvcsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'pvc'?: PvcsDefaults | null;
    /**
     * 
     * @type {HostPathsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'hostPath'?: HostPathsDefaults | null;
    /**
     * 
     * @type {NfssDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'nfs'?: NfssDefaults | null;
    /**
     * 
     * @type {GitsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'git'?: GitsDefaults | null;
    /**
     * 
     * @type {ConfigMapsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'configMapVolume'?: ConfigMapsDefaults | null;
    /**
     * 
     * @type {SecretsDefaults}
     * @memberof CommonStorageFieldsDefaults
     */
    'secretVolume'?: SecretsDefaults | null;
}
/**
 * 
 * @export
 * @interface CommonStorageFieldsRules
 */
export interface CommonStorageFieldsRules {
    /**
     * 
     * @type {DataVolumesRules}
     * @memberof CommonStorageFieldsRules
     */
    'dataVolume'?: DataVolumesRules | null;
    /**
     * 
     * @type {PvcsRules}
     * @memberof CommonStorageFieldsRules
     */
    'pvc'?: PvcsRules | null;
    /**
     * 
     * @type {HostPathsRules}
     * @memberof CommonStorageFieldsRules
     */
    'hostPath'?: HostPathsRules | null;
    /**
     * 
     * @type {NfssRules}
     * @memberof CommonStorageFieldsRules
     */
    'nfs'?: NfssRules | null;
    /**
     * 
     * @type {GitsRules}
     * @memberof CommonStorageFieldsRules
     */
    'git'?: GitsRules | null;
    /**
     * 
     * @type {ConfigMapsRules}
     * @memberof CommonStorageFieldsRules
     */
    'configMapVolume'?: ConfigMapsRules | null;
    /**
     * 
     * @type {SecretsRules}
     * @memberof CommonStorageFieldsRules
     */
    'secretVolume'?: SecretsRules | null;
}
/**
 * 
 * @export
 * @interface CompletionsField
 */
export interface CompletionsField {
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof CompletionsField
     */
    'completions'?: number | null;
}
/**
 * 
 * @export
 * @interface ComplianceIssues
 */
export interface ComplianceIssues {
    /**
     * 
     * @type {Array<ComplianceIssuesComplianceIssuesInner>}
     * @memberof ComplianceIssues
     */
    'complianceIssues'?: Array<ComplianceIssuesComplianceIssuesInner>;
}
/**
 * 
 * @export
 * @interface ComplianceIssuesComplianceIssuesInner
 */
export interface ComplianceIssuesComplianceIssuesInner {
    /**
     * 
     * @type {string}
     * @memberof ComplianceIssuesComplianceIssuesInner
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof ComplianceIssuesComplianceIssuesInner
     */
    'details': string;
}
/**
 * 
 * @export
 * @interface Compute
 */
export interface Compute {
    /**
     * 
     * @type {ComputeFields}
     * @memberof Compute
     */
    'compute'?: ComputeFields | null;
}
/**
 * 
 * @export
 * @interface ComputeDefaults
 */
export interface ComputeDefaults {
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof ComputeDefaults
     */
    'compute'?: ComputeFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface ComputeFields
 */
export interface ComputeFields {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeFields
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeFields
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeFields
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeFields
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeFields
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeFields
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeFields
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeFields
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeFields
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeFields
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeFields
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeFields
     */
    'largeShmRequest'?: boolean | null;
    /**
     * Extended resources and their quantity.
     * @type {Array<ExtendedResource>}
     * @memberof ComputeFields
     */
    'extendedResources'?: Array<ExtendedResource> | null;
}
/**
 * 
 * @export
 * @interface ComputeFieldsDefaults
 */
export interface ComputeFieldsDefaults {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeFieldsDefaults
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeFieldsDefaults
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeFieldsDefaults
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeFieldsDefaults
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeFieldsDefaults
     */
    'largeShmRequest'?: boolean | null;
    /**
     * 
     * @type {ExtendedResourcesDefaults}
     * @memberof ComputeFieldsDefaults
     */
    'extendedResources'?: ExtendedResourcesDefaults | null;
}
/**
 * 
 * @export
 * @interface ComputeFieldsRules
 */
export interface ComputeFieldsRules {
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'cpuCoreRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'cpuCoreLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'cpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'cpuMemoryLimit'?: QuantityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ComputeFieldsRules
     */
    'largeShmRequest'?: BooleanRules | null;
    /**
     * 
     * @type {GpuRequestRules}
     * @memberof ComputeFieldsRules
     */
    'gpuRequestType'?: GpuRequestRules | null;
    /**
     * 
     * @type {MigProfileRules}
     * @memberof ComputeFieldsRules
     */
    'migProfile'?: MigProfileRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ComputeFieldsRules
     */
    'gpuDevicesRequest'?: IntegerRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'gpuPortionRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFieldsRules
     */
    'gpuPortionLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'gpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFieldsRules
     */
    'gpuMemoryLimit'?: QuantityRules | null;
    /**
     * 
     * @type {ExtendedResourcesRules}
     * @memberof ComputeFieldsRules
     */
    'extendedResources'?: ExtendedResourcesRules | null;
}
/**
 * 
 * @export
 * @interface ComputeFlatFields
 */
export interface ComputeFlatFields {
    /**
     * Requested number of GPU devices. Currently if more than one device is requested, it is not possible to provide values for gpuMemory, gpuPortion or migProfile [deprecated].
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuDevicesRequest'?: number | null;
    /**
     * 
     * @type {GpuRequestType}
     * @memberof ComputeFlatFields
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * Required if and only if gpuRequestType is portion. States the portion of the GPU to allocate for the created workload, per GPU device, between 0 and 1. The default is no allocated GPUs.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuPortionRequest'?: number | null;
    /**
     * Limitations on the portion consumed by the workload, per GPU device. The system guarantees The gpuPotionLimit must be no less than the gpuPortionRequest.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'gpuPortionLimit'?: number | null;
    /**
     * Required if and only if gpuRequestType is memory. States the GPU memory to allocate for the created workload, per GPU device. Note that the workload will not be scheduled unless the system can guarantee this amount of GPU memory to the workload.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'gpuMemoryRequest'?: string | null;
    /**
     * Limitation on the memory consumed by the workload, per GPU device. The system guarantees The gpuMemoryLimit must be no less than gpuMemoryRequest.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'gpuMemoryLimit'?: string | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof ComputeFlatFields
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * CPU units to allocate for the created workload (0.5, 1, .etc). The workload will receive at least this amount of CPU. Note that the workload will not be scheduled unless the system can guarantee this amount of CPUs to the workload.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'cpuCoreRequest'?: number | null;
    /**
     * Limitations on the number of CPUs consumed by the workload (0.5, 1, .etc). The system guarantees that this workload will not be able to consume more than this amount of CPUs.
     * @type {number}
     * @memberof ComputeFlatFields
     */
    'cpuCoreLimit'?: number | null;
    /**
     * The amount of CPU memory to allocate for this workload (1G, 20M, .etc). The workload will receive at least this amount of memory. Note that the workload will not be scheduled unless the system can guarantee this amount of memory to the workload
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'cpuMemoryRequest'?: string | null;
    /**
     * Limitations on the CPU memory to allocate for this workload (1G, 20M, .etc). The system guarantees that this workload will not be able to consume more than this amount of memory. The workload will receive an error when trying to allocate more memory than this limit.
     * @type {string}
     * @memberof ComputeFlatFields
     */
    'cpuMemoryLimit'?: string | null;
    /**
     * A large /dev/shm device to mount into a container running the created workload. An shm is a shared file system mounted on RAM.
     * @type {boolean}
     * @memberof ComputeFlatFields
     */
    'largeShmRequest'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ComputeFlatFieldsRules
 */
export interface ComputeFlatFieldsRules {
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuCoreRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuCoreLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'cpuMemoryLimit'?: QuantityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ComputeFlatFieldsRules
     */
    'largeShmRequest'?: BooleanRules | null;
    /**
     * 
     * @type {GpuRequestRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuRequestType'?: GpuRequestRules | null;
    /**
     * 
     * @type {MigProfileRules}
     * @memberof ComputeFlatFieldsRules
     */
    'migProfile'?: MigProfileRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuDevicesRequest'?: IntegerRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuPortionRequest'?: NumberRules | null;
    /**
     * 
     * @type {NumberRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuPortionLimit'?: NumberRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuMemoryRequest'?: QuantityRules | null;
    /**
     * 
     * @type {QuantityRules}
     * @memberof ComputeFlatFieldsRules
     */
    'gpuMemoryLimit'?: QuantityRules | null;
}
/**
 * 
 * @export
 * @interface ComputeItemizedFields
 */
export interface ComputeItemizedFields {
    /**
     * Extended resources and their quantity.
     * @type {Array<ExtendedResource>}
     * @memberof ComputeItemizedFields
     */
    'extendedResources'?: Array<ExtendedResource> | null;
}
/**
 * 
 * @export
 * @interface ComputeItemizedFieldsDefaults
 */
export interface ComputeItemizedFieldsDefaults {
    /**
     * 
     * @type {ExtendedResourcesDefaults}
     * @memberof ComputeItemizedFieldsDefaults
     */
    'extendedResources'?: ExtendedResourcesDefaults | null;
}
/**
 * 
 * @export
 * @interface ComputeItemizedFieldsRules
 */
export interface ComputeItemizedFieldsRules {
    /**
     * 
     * @type {ExtendedResourcesRules}
     * @memberof ComputeItemizedFieldsRules
     */
    'extendedResources'?: ExtendedResourcesRules | null;
}
/**
 * 
 * @export
 * @interface ComputeRules
 */
export interface ComputeRules {
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof ComputeRules
     */
    'compute'?: ComputeFieldsRules | null;
}
/**
 * 
 * @export
 * @interface Condition
 */
export interface Condition {
    /**
     * The type of the condition, such as Failed or Available. See Types of domain status conditions.
     * @type {string}
     * @memberof Condition
     */
    'type': string;
    /**
     * The status of the condition, such as True, False or Unknown.
     * @type {string}
     * @memberof Condition
     */
    'status': string;
    /**
     * An optional, human-readable message providing more details about the condition.
     * @type {string}
     * @memberof Condition
     */
    'message'?: string;
    /**
     * The reason for the Failed condition. Not applicable to other types of condition.
     * @type {string}
     * @memberof Condition
     */
    'reason'?: string;
    /**
     * A timestamp of when the condition was created or the last time time the condition transitioned from one status to another.
     * @type {string}
     * @memberof Condition
     */
    'lastTransitionTime'?: string | null;
}
/**
 * 
 * @export
 * @interface ConfigMap
 */
export interface ConfigMap {
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof ConfigMap
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof ConfigMap
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof ConfigMap
     */
    'subPath'?: string | null;
}
/**
 * 
 * @export
 * @interface ConfigMapInstance
 */
export interface ConfigMapInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'name'?: string | null;
    /**
     * The name of the ConfigMap resource. (mandatory)
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'configMap'?: string | null;
    /**
     * Local path within the workspace to which the ConfigMap will be mapped to. (mandatory)
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'mountPath'?: string | null;
    /**
     * Path within the volume from which the container\'s volume should be mounted.
     * @type {string}
     * @memberof ConfigMapInstance
     */
    'subPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ConfigMapInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ConfigMapRules
 */
export interface ConfigMapRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'configMap'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'mountPath'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ConfigMapRules
     */
    'subPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface ConfigMapsDefaults
 */
export interface ConfigMapsDefaults {
    /**
     * 
     * @type {ConfigMapInstance}
     * @memberof ConfigMapsDefaults
     */
    'attributes'?: ConfigMapInstance | null;
    /**
     * Set of config map volumes to use in the workload
     * @type {Array<ConfigMapInstance>}
     * @memberof ConfigMapsDefaults
     */
    'instances'?: Array<ConfigMapInstance> | null;
}
/**
 * 
 * @export
 * @interface ConfigMapsRules
 */
export interface ConfigMapsRules {
    /**
     * 
     * @type {ConfigMapRules}
     * @memberof ConfigMapsRules
     */
    'attributes'?: ConfigMapRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof ConfigMapsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Connection that either expose port from the container (a port is associated with a tool that the container runs), or URL to be used for connecting to an external tool that is related to the action of the container (such as Weights & Biases).
 * @export
 * @interface Connection
 */
export interface Connection {
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'toolType': string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'connectionType': string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Connection
     */
    'authorizationType'?: ConnectionAuthorizationTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Connection
     */
    'authorizedUsers'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Connection
     */
    'authorizedGroups'?: Array<string>;
    /**
     * The port that the container running the workload exposes.
     * @type {number}
     * @memberof Connection
     */
    'containerPort'?: number;
}

export const ConnectionAuthorizationTypeEnum = {
    Public: 'public',
    AuthenticatedUsers: 'authenticatedUsers',
    AuthorizedUsersOrGroups: 'authorizedUsersOrGroups'
} as const;

export type ConnectionAuthorizationTypeEnum = typeof ConnectionAuthorizationTypeEnum[keyof typeof ConnectionAuthorizationTypeEnum];

/**
 * 
 * @export
 * @interface ConnectivityDefaults
 */
export interface ConnectivityDefaults {
    /**
     * 
     * @type {PortsDefaults}
     * @memberof ConnectivityDefaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof ConnectivityDefaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof ConnectivityDefaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
}
/**
 * 
 * @export
 * @interface ConnectivityFields
 */
export interface ConnectivityFields {
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof ConnectivityFields
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof ConnectivityFields
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof ConnectivityFields
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
}
/**
 * 
 * @export
 * @interface ConnectivityRules
 */
export interface ConnectivityRules {
    /**
     * 
     * @type {PortsRules}
     * @memberof ConnectivityRules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof ConnectivityRules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof ConnectivityRules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
}
/**
 * 
 * @export
 * @interface Container
 */
export interface Container {
    /**
     * 
     * @type {string}
     * @memberof Container
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Container
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof Container
     */
    'startedAt'?: string | null;
}
/**
 * Container non Inference overrideable fields. It adds properties which are not allowed for Inference containers
 * @export
 * @interface ContainerNonInferenceNonOverridable
 */
export interface ContainerNonInferenceNonOverridable {
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof ContainerNonInferenceNonOverridable
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof ContainerNonInferenceNonOverridable
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ContainerNonInferenceNonOverridableRules
 */
export interface ContainerNonInferenceNonOverridableRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof ContainerNonInferenceNonOverridableRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ContainerNonInferenceNonOverridableRules
     */
    'stdin'?: BooleanRules | null;
}
/**
 * Container non overrideable fields. In the context of assets,these are environment asset fields that cannot be overriden in the submit workload request.
 * @export
 * @interface ContainerNonOverridable
 */
export interface ContainerNonOverridable {
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof ContainerNonOverridable
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof ContainerNonOverridable
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof ContainerNonOverridable
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof ContainerNonOverridable
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof ContainerNonOverridable
     */
    'probes'?: Probes | null;
}
/**
 * 
 * @export
 * @interface ContainerNonOverridableRules
 */
export interface ContainerNonOverridableRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerNonOverridableRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof ContainerNonOverridableRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerNonOverridableRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ContainerNonOverridableRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof ContainerNonOverridableRules
     */
    'probes'?: ProbesRules | null;
}
/**
 * Container overrideable fields. In the context of assets,these are environment asset fields that can be overriden in the submit workload request.
 * @export
 * @interface ContainerOverridable
 */
export interface ContainerOverridable {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof ContainerOverridable
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof ContainerOverridable
     */
    'args'?: string | null;
}
/**
 * Container related fields. When used in assets context, those are environment asset fields that can be override in the submit workload request.
 * @export
 * @interface ContainerOverridableRules
 */
export interface ContainerOverridableRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerOverridableRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ContainerOverridableRules
     */
    'args'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface CountResponse
 */
export interface CountResponse {
    /**
     * 
     * @type {number}
     * @memberof CountResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface CountWorkloads200Response
 */
export interface CountWorkloads200Response {
    /**
     * 
     * @type {number}
     * @memberof CountWorkloads200Response
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface DataVolume
 */
export interface DataVolume {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DataVolume
     */
    'id'?: string | null;
    /**
     * The path where the data volume will be mounted. (mandatory)
     * @type {string}
     * @memberof DataVolume
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface DataVolumeInstance
 */
export interface DataVolumeInstance {
    /**
     * The unique identifier of the data volume. (mandatory)
     * @type {string}
     * @memberof DataVolumeInstance
     */
    'id'?: string | null;
    /**
     * The path where the data volume will be mounted. (mandatory)
     * @type {string}
     * @memberof DataVolumeInstance
     */
    'mountPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof DataVolumeInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface DataVolumeRules
 */
export interface DataVolumeRules {
    /**
     * 
     * @type {StringRules}
     * @memberof DataVolumeRules
     */
    'id'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DataVolumeRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface DataVolumesDefaults
 */
export interface DataVolumesDefaults {
    /**
     * 
     * @type {DataVolumeInstance}
     * @memberof DataVolumesDefaults
     */
    'attributes'?: DataVolumeInstance | null;
    /**
     * Set of data volumes to use in the workload.
     * @type {Array<DataVolumeInstance>}
     * @memberof DataVolumesDefaults
     */
    'instances'?: Array<DataVolumeInstance> | null;
}
/**
 * 
 * @export
 * @interface DataVolumesRules
 */
export interface DataVolumesRules {
    /**
     * 
     * @type {DataVolumeRules}
     * @memberof DataVolumesRules
     */
    'attributes'?: DataVolumeRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof DataVolumesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface Datasource
 */
export interface Datasource {
    /**
     * 
     * @type {string}
     * @memberof Datasource
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Datasource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Datasource
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface DefaultFromRule
 */
export interface DefaultFromRule {
    /**
     * The default of this field is taken from another field, with optional factor. The specified field must belong to the same workload section (compute, security, etc). For itemized field, the value of the field will be taken from the same instance.
     * @type {string}
     * @memberof DefaultFromRule
     */
    'field'?: string | null;
    /**
     * Multiple the value of the fromField by this factor to get the value for this field For example, if factor is 2 and defaultFrom field has value of 8, the calculated default will be determined to be 16.
     * @type {number}
     * @memberof DefaultFromRule
     */
    'factor'?: number | null;
}
/**
 * The policy describes how to deal with pods when the job is finished.
 * @export
 * @enum {string}
 */

export const DistributedCleanPodPolicy = {
    None: 'None',
    All: 'All',
    Running: 'Running'
} as const;

export type DistributedCleanPodPolicy = typeof DistributedCleanPodPolicy[keyof typeof DistributedCleanPodPolicy];


/**
 * 
 * @export
 * @interface DistributedCleanPodPolicyOptions
 */
export interface DistributedCleanPodPolicyOptions {
    /**
     * 
     * @type {Array<DistributedCleanPodPolicyOptionsOptionsInner>}
     * @memberof DistributedCleanPodPolicyOptions
     */
    'options'?: Array<DistributedCleanPodPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedCleanPodPolicyOptionsOptionsInner
 */
export interface DistributedCleanPodPolicyOptionsOptionsInner {
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof DistributedCleanPodPolicyOptionsOptionsInner
     */
    'value': DistributedCleanPodPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof DistributedCleanPodPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface DistributedCleanPodPolicyRules
 */
export interface DistributedCleanPodPolicyRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof DistributedCleanPodPolicyRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof DistributedCleanPodPolicyRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof DistributedCleanPodPolicyRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<DistributedCleanPodPolicyOptionsOptionsInner>}
     * @memberof DistributedCleanPodPolicyRules
     */
    'options'?: Array<DistributedCleanPodPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedCreationRequest
 */
export interface DistributedCreationRequest {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof DistributedCreationRequest
     */
    'name': string;
    /**
     * When true, the requested name will be treated as a prefix. The final name of the workload will be composed of the name followed by a random set of characters.
     * @type {boolean}
     * @memberof DistributedCreationRequest
     */
    'useGivenNameAsPrefix'?: boolean;
    /**
     * The id of the project.
     * @type {string}
     * @memberof DistributedCreationRequest
     */
    'projectId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof DistributedCreationRequest
     */
    'clusterId': string;
    /**
     * A unique ID of the template.
     * @type {string}
     * @memberof DistributedCreationRequest
     */
    'templateId'?: string | null;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedCreationRequest
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedCreationRequest
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {MasterSpec}
     * @memberof DistributedCreationRequest
     */
    'masterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface DistributedFields
 */
export interface DistributedFields {
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof DistributedFields
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedFields
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof DistributedFields
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof DistributedFields
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedFields
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedFields
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof DistributedFields
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
}
/**
 * 
 * @export
 * @interface DistributedFieldsRules
 */
export interface DistributedFieldsRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'numWorkers'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedFrameworkRules}
     * @memberof DistributedFieldsRules
     */
    'distributedFramework'?: DistributedFrameworkRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'slotsPerWorker'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof DistributedFieldsRules
     */
    'sshAuthMountPath'?: StringRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof DistributedFieldsRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedCleanPodPolicyRules}
     * @memberof DistributedFieldsRules
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicyRules | null;
}
/**
 * The distributed training framework used in the workload.
 * @export
 * @enum {string}
 */

export const DistributedFramework = {
    Mpi: 'MPI',
    PyTorch: 'PyTorch',
    Tf: 'TF',
    XgBoost: 'XGBoost',
    Jax: 'JAX'
} as const;

export type DistributedFramework = typeof DistributedFramework[keyof typeof DistributedFramework];


/**
 * 
 * @export
 * @interface DistributedFrameworkOptions
 */
export interface DistributedFrameworkOptions {
    /**
     * 
     * @type {Array<DistributedFrameworkOptionsOptionsInner>}
     * @memberof DistributedFrameworkOptions
     */
    'options'?: Array<DistributedFrameworkOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface DistributedFrameworkOptionsOptionsInner
 */
export interface DistributedFrameworkOptionsOptionsInner {
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedFrameworkOptionsOptionsInner
     */
    'value': DistributedFramework | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof DistributedFrameworkOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface DistributedFrameworkRules
 */
export interface DistributedFrameworkRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof DistributedFrameworkRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof DistributedFrameworkRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof DistributedFrameworkRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<DistributedFrameworkOptionsOptionsInner>}
     * @memberof DistributedFrameworkRules
     */
    'options'?: Array<DistributedFrameworkOptionsOptionsInner> | null;
}
/**
 * The specifications of the training to be created.
 * @export
 * @interface DistributedSpec
 */
export interface DistributedSpec {
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedSpec
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedSpec
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {MasterSpec}
     * @memberof DistributedSpec
     */
    'masterSpec'?: MasterSpec | null;
}
/**
 * The spec of the worker(s).
 * @export
 * @interface DistributedSpecSpec
 */
export interface DistributedSpecSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof DistributedSpecSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof DistributedSpecSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof DistributedSpecSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof DistributedSpecSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof DistributedSpecSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof DistributedSpecSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof DistributedSpecSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof DistributedSpecSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof DistributedSpecSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof DistributedSpecSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof DistributedSpecSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof DistributedSpecSpec
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof DistributedSpecSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof DistributedSpecSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof DistributedSpecSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof DistributedSpecSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof DistributedSpecSpec
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof DistributedSpecSpec
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof DistributedSpecSpec
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof DistributedSpecSpec
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof DistributedSpecSpec
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof DistributedSpecSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof DistributedSpecSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof DistributedSpecSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof DistributedSpecSpec
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof DistributedSpecSpec
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof DistributedSpecSpec
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof DistributedSpecSpec
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedSpecSpec
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof DistributedSpecSpec
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof DistributedSpecSpec
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof DistributedSpecSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof DistributedSpecSpec
     */
    'storage'?: StorageFields | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof DistributedSpecSpec
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface DistributedTemplate
 */
export interface DistributedTemplate {
    /**
     * 
     * @type {TemplateMetaFields}
     * @memberof DistributedTemplate
     */
    'meta': TemplateMetaFields;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedTemplate
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedTemplate
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof DistributedTemplate
     */
    'master'?: TemplateMasterSection | null;
    /**
     * 
     * @type {RunnableInfo}
     * @memberof DistributedTemplate
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedTemplate
     */
    'combinedSpec'?: DistributedSpecSpec;
    /**
     * 
     * @type {MasterSpec}
     * @memberof DistributedTemplate
     */
    'combinedMasterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface DistributedTemplateAllOf
 */
export interface DistributedTemplateAllOf {
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedTemplateAllOf
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedTemplateAllOf
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof DistributedTemplateAllOf
     */
    'master'?: TemplateMasterSection | null;
    /**
     * 
     * @type {RunnableInfo}
     * @memberof DistributedTemplateAllOf
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedTemplateAllOf
     */
    'combinedSpec'?: DistributedSpecSpec;
    /**
     * 
     * @type {MasterSpec}
     * @memberof DistributedTemplateAllOf
     */
    'combinedMasterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface DistributedTemplateCreationRequest
 */
export interface DistributedTemplateCreationRequest {
    /**
     * 
     * @type {TemplateCreationMetaFields}
     * @memberof DistributedTemplateCreationRequest
     */
    'meta': TemplateCreationMetaFields;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedTemplateCreationRequest
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedTemplateCreationRequest
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof DistributedTemplateCreationRequest
     */
    'master'?: TemplateMasterSection | null;
}
/**
 * 
 * @export
 * @interface DistributedTemplateCreationRequestAllOf
 */
export interface DistributedTemplateCreationRequestAllOf {
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedTemplateCreationRequestAllOf
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof DistributedTemplateCreationRequestAllOf
     */
    'master'?: TemplateMasterSection | null;
}
/**
 * 
 * @export
 * @interface DistributedTemplatePatchRequest
 */
export interface DistributedTemplatePatchRequest {
    /**
     * 
     * @type {TemplatePatchMetaFields}
     * @memberof DistributedTemplatePatchRequest
     */
    'meta'?: TemplatePatchMetaFields | null;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedTemplatePatchRequest
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedTemplatePatchRequest
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof DistributedTemplatePatchRequest
     */
    'master'?: TemplateMasterSection | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DistributedTemplatePatchRequest
     */
    'fieldsToClear'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DistributedTemplateUpdateRequest
 */
export interface DistributedTemplateUpdateRequest {
    /**
     * 
     * @type {TemplateUpdateMetaFields}
     * @memberof DistributedTemplateUpdateRequest
     */
    'meta': TemplateUpdateMetaFields;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedTemplateUpdateRequest
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedTemplateUpdateRequest
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof DistributedTemplateUpdateRequest
     */
    'master'?: TemplateMasterSection | null;
}
/**
 * 
 * @export
 * @interface DistributedTemplatesListResponse
 */
export interface DistributedTemplatesListResponse {
    /**
     * 
     * @type {Array<DistributedTemplate>}
     * @memberof DistributedTemplatesListResponse
     */
    'entries'?: Array<DistributedTemplate>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof DistributedTemplatesListResponse
     */
    'pagination'?: PaginationInfo;
}
/**
 * 
 * @export
 * @interface DistributedWorkload
 */
export interface DistributedWorkload {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'name': string;
    /**
     * The name as was requested for the workload. If useGivenNameAsPrefix, in the creation request, is false, name and requestedName should be identical. Otherwise, name should be composed of requestedName followed by a suffix of random characters.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'requestedName': string;
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'workloadId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'clusterId': string;
    /**
     * The user who created the workload
     * @type {string}
     * @memberof DistributedWorkload
     */
    'createdBy': string;
    /**
     * The creation time of the workload.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'createdAt': string;
    /**
     * The deletion time of the workload.
     * @type {string}
     * @memberof DistributedWorkload
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadDesiredPhase}
     * @memberof DistributedWorkload
     */
    'desiredPhase': WorkloadDesiredPhase;
    /**
     * 
     * @type {Phase}
     * @memberof DistributedWorkload
     */
    'actualPhase'?: Phase;
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof DistributedWorkload
     */
    'spec'?: DistributedSpecSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof DistributedWorkload
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {MasterSpec}
     * @memberof DistributedWorkload
     */
    'masterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface Environment
 */
export interface Environment {
    /**
     * 
     * @type {Array<Connection>}
     * @memberof Environment
     */
    'connections'?: Array<Connection>;
    /**
     * 
     * @type {string}
     * @memberof Environment
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Environment
     */
    'id': string;
    /**
     * 
     * @type {ReplicaType}
     * @memberof Environment
     */
    'replicaType'?: ReplicaType | null;
}
/**
 * Details of an environment variable which is populated into the container.
 * @export
 * @interface EnvironmentVariable
 */
export interface EnvironmentVariable {
    /**
     * The name of the environment variable. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'name'?: string | null;
    /**
     * The value of the environment variable. (mutually exclusive with secret, configMap and podFieldRef)
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'value'?: string | null;
    /**
     * 
     * @type {EnvironmentVariableSecret}
     * @memberof EnvironmentVariable
     */
    'secret'?: EnvironmentVariableSecret | null;
    /**
     * 
     * @type {EnvironmentVariableConfigMap}
     * @memberof EnvironmentVariable
     */
    'configMap'?: EnvironmentVariableConfigMap | null;
    /**
     * 
     * @type {EnvironmentVariablePodFieldReference}
     * @memberof EnvironmentVariable
     */
    'podFieldRef'?: EnvironmentVariablePodFieldReference | null;
    /**
     * Use \'true\' in case the environment variable is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof EnvironmentVariable
     */
    'exclude'?: boolean | null;
    /**
     * Description of the environment variable.
     * @type {string}
     * @memberof EnvironmentVariable
     */
    'description'?: string | null;
}
/**
 * Details of the configMap and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariableConfigMap
 */
export interface EnvironmentVariableConfigMap {
    /**
     * The name of the config-map resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableConfigMap
     */
    'name'?: string | null;
    /**
     * The key in the config-map resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableConfigMap
     */
    'key'?: string | null;
}
/**
 * Details of the filed-reference and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariablePodFieldReference
 */
export interface EnvironmentVariablePodFieldReference {
    /**
     * The field path resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariablePodFieldReference
     */
    'path'?: string | null;
}
/**
 * Details of the secret and key use to populated the environment variable
 * @export
 * @interface EnvironmentVariableSecret
 */
export interface EnvironmentVariableSecret {
    /**
     * The name of the secret resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableSecret
     */
    'name'?: string | null;
    /**
     * The key in the secret resource. (mandatory)
     * @type {string}
     * @memberof EnvironmentVariableSecret
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesDefaults
 */
export interface EnvironmentVariablesDefaults {
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof EnvironmentVariablesDefaults
     */
    'instances'?: Array<EnvironmentVariable> | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesField
 */
export interface EnvironmentVariablesField {
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof EnvironmentVariablesField
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesFieldDefaults
 */
export interface EnvironmentVariablesFieldDefaults {
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof EnvironmentVariablesFieldDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
}
/**
 * 
 * @export
 * @interface EnvironmentVariablesFieldRules
 */
export interface EnvironmentVariablesFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof EnvironmentVariablesFieldRules
     */
    'environmentVariables'?: InstancesRules | null;
}
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'type': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Event
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'source'?: string;
    /**
     * 
     * @type {InvolvedObject}
     * @memberof Event
     */
    'involvedObject'?: InvolvedObject;
}
/**
 * 
 * @export
 * @interface EventComputedFields
 */
export interface EventComputedFields {
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof EventComputedFields
     */
    'tenantId': number;
}
/**
 * 
 * @export
 * @interface EventSyncFields
 */
export interface EventSyncFields {
    /**
     * 
     * @type {string}
     * @memberof EventSyncFields
     */
    'id': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof EventSyncFields
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof EventSyncFields
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof EventSyncFields
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof EventSyncFields
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof EventSyncFields
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EventSyncFields
     */
    'source': string;
    /**
     * 
     * @type {InvolvedObject}
     * @memberof EventSyncFields
     */
    'involvedObject': InvolvedObject;
}
/**
 * 
 * @export
 * @interface EventsSyncRequest
 */
export interface EventsSyncRequest {
    /**
     * 
     * @type {Array<EventSyncFields>}
     * @memberof EventsSyncRequest
     */
    'events': Array<EventSyncFields>;
}
/**
 * 
 * @export
 * @interface ExcludeField
 */
export interface ExcludeField {
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExcludeField
     */
    'exclude'?: boolean | null;
}
/**
 * A URL for accessing the workload.
 * @export
 * @interface ExposedUrl
 */
export interface ExposedUrl {
    /**
     * The port that the container running the workload exposes. (mandatory)
     * @type {number}
     * @memberof ExposedUrl
     */
    'container'?: number | null;
    /**
     * The URL for connecting to the container port. If not specified, the URL will be auto-generated by the system..
     * @type {string}
     * @memberof ExposedUrl
     */
    'url'?: string | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ExposedUrl
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ExposedUrl
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * The tool type that runs on this container port.
     * @type {string}
     * @memberof ExposedUrl
     */
    'toolType'?: string | null;
    /**
     * A name describing the tool that runs on this url.
     * @type {string}
     * @memberof ExposedUrl
     */
    'toolName'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof ExposedUrl
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the instance is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExposedUrl
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for the attributed of exposedUrls
 * @export
 * @interface ExposedUrlRules
 */
export interface ExposedUrlRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ExposedUrlRules
     */
    'container'?: IntegerRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof ExposedUrlRules
     */
    'customUrl'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ExposedUrlRules
     */
    'url'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof ExposedUrlRules
     */
    'authorizedUsers'?: ArrayRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ExposedUrlRules
     */
    'toolType'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ExposedUrlRules
     */
    'toolName'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface ExposedUrlsDefaults
 */
export interface ExposedUrlsDefaults {
    /**
     * 
     * @type {ExposedUrl}
     * @memberof ExposedUrlsDefaults
     */
    'attributes'?: ExposedUrl | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof ExposedUrlsDefaults
     */
    'instances'?: Array<ExposedUrl> | null;
}
/**
 * 
 * @export
 * @interface ExposedUrlsRules
 */
export interface ExposedUrlsRules {
    /**
     * 
     * @type {ExposedUrlRules}
     * @memberof ExposedUrlsRules
     */
    'attributes'?: ExposedUrlRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof ExposedUrlsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Quantity of an extended resource.
 * @export
 * @interface ExtendedResource
 */
export interface ExtendedResource {
    /**
     * The name of the extended resource (mandatory)
     * @type {string}
     * @memberof ExtendedResource
     */
    'resource'?: string | null;
    /**
     * The requested quantity for the resource.
     * @type {string}
     * @memberof ExtendedResource
     */
    'quantity'?: string | null;
    /**
     * Use \'true\' in case the extended resource is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof ExtendedResource
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for the attributes of extendedResources
 * @export
 * @interface ExtendedResourceRules
 */
export interface ExtendedResourceRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ExtendedResourceRules
     */
    'quantity'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface ExtendedResourcesDefaults
 */
export interface ExtendedResourcesDefaults {
    /**
     * 
     * @type {ExtendedResource}
     * @memberof ExtendedResourcesDefaults
     */
    'attributes'?: ExtendedResource | null;
    /**
     * Extended resources and their quantity.
     * @type {Array<ExtendedResource>}
     * @memberof ExtendedResourcesDefaults
     */
    'instances'?: Array<ExtendedResource> | null;
}
/**
 * 
 * @export
 * @interface ExtendedResourcesRules
 */
export interface ExtendedResourcesRules {
    /**
     * 
     * @type {ExtendedResourceRules}
     * @memberof ExtendedResourcesRules
     */
    'attributes'?: ExtendedResourceRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof ExtendedResourcesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * array of xpath expression with fields that their values should be cleared
 * @export
 * @interface FieldsToClear
 */
export interface FieldsToClear {
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldsToClear
     */
    'fieldsToClear'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetInferenceWorkloadRevisions200Response
 */
export interface GetInferenceWorkloadRevisions200Response {
    /**
     * 
     * @type {Array<Revision>}
     * @memberof GetInferenceWorkloadRevisions200Response
     */
    'revisions': Array<Revision>;
}
/**
 * 
 * @export
 * @interface GetRevisionPods200Response
 */
export interface GetRevisionPods200Response {
    /**
     * 
     * @type {Array<Pod>}
     * @memberof GetRevisionPods200Response
     */
    'pods': Array<Pod>;
}
/**
 * 
 * @export
 * @interface GetWorkloadEvents200Response
 */
export interface GetWorkloadEvents200Response {
    /**
     * 
     * @type {number}
     * @memberof GetWorkloadEvents200Response
     */
    'next'?: number;
    /**
     * 
     * @type {Array<Event>}
     * @memberof GetWorkloadEvents200Response
     */
    'events': Array<Event>;
}
/**
 * 
 * @export
 * @interface GetWorkloadHistory200Response
 */
export interface GetWorkloadHistory200Response {
    /**
     * 
     * @type {number}
     * @memberof GetWorkloadHistory200Response
     */
    'next'?: number;
    /**
     * 
     * @type {Array<HistoryRecord>}
     * @memberof GetWorkloadHistory200Response
     */
    'records': Array<HistoryRecord>;
}
/**
 * 
 * @export
 * @interface GetWorkloads200Response
 */
export interface GetWorkloads200Response {
    /**
     * 
     * @type {number}
     * @memberof GetWorkloads200Response
     */
    'next'?: number;
    /**
     * 
     * @type {Array<Workload>}
     * @memberof GetWorkloads200Response
     */
    'workloads': Array<Workload>;
}
/**
 * 
 * @export
 * @interface GitCommon
 */
export interface GitCommon {
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof GitCommon
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof GitCommon
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof GitCommon
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof GitCommon
     */
    'path'?: string | null;
}
/**
 * 
 * @export
 * @interface GitInstance
 */
export interface GitInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof GitInstance
     */
    'name'?: string | null;
    /**
     * URL to a remote Git repository. The content of this repository will be mapped to the container running the workload. (mandatory)
     * @type {string}
     * @memberof GitInstance
     */
    'repository'?: string | null;
    /**
     * Specific branch to synchronize the repository from.
     * @type {string}
     * @memberof GitInstance
     */
    'branch'?: string | null;
    /**
     * Specific revision to synchronize the repository from.
     * @type {string}
     * @memberof GitInstance
     */
    'revision'?: string | null;
    /**
     * Local path within the workspace to which the Git repository will be mapped (mandatory).
     * @type {string}
     * @memberof GitInstance
     */
    'path'?: string | null;
    /**
     * Secret containing the credentials of the repository (needed for non public repository which requires authentication).
     * @type {string}
     * @memberof GitInstance
     */
    'passwordSecret'?: string | null;
    /**
     * The key to use for loading the user name from the secret. The default is `User`.
     * @type {string}
     * @memberof GitInstance
     */
    'secretKeyOfUser'?: string | null;
    /**
     * The key to use for loading the password from the secret. The default is `Password`.
     * @type {string}
     * @memberof GitInstance
     */
    'secretKeyOfPassword'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof GitInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface GitPassword
 */
export interface GitPassword {
    /**
     * Secret containing the credentials of the repository (needed for non public repository which requires authentication).
     * @type {string}
     * @memberof GitPassword
     */
    'passwordSecret'?: string | null;
    /**
     * The key to use for loading the user name from the secret. The default is `User`.
     * @type {string}
     * @memberof GitPassword
     */
    'secretKeyOfUser'?: string | null;
    /**
     * The key to use for loading the password from the secret. The default is `Password`.
     * @type {string}
     * @memberof GitPassword
     */
    'secretKeyOfPassword'?: string | null;
}
/**
 * 
 * @export
 * @interface GitRules
 */
export interface GitRules {
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'repository'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'branch'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'revision'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof GitRules
     */
    'path'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface GitsDefaults
 */
export interface GitsDefaults {
    /**
     * 
     * @type {GitInstance}
     * @memberof GitsDefaults
     */
    'attributes'?: GitInstance | null;
    /**
     * Set of git repositories to use in the workload.
     * @type {Array<GitInstance>}
     * @memberof GitsDefaults
     */
    'instances'?: Array<GitInstance> | null;
}
/**
 * 
 * @export
 * @interface GitsRules
 */
export interface GitsRules {
    /**
     * 
     * @type {GitRules}
     * @memberof GitsRules
     */
    'attributes'?: GitRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof GitsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface GpuRequestOptions
 */
export interface GpuRequestOptions {
    /**
     * Limit the permitted values for gpuRequest to a given set of values.
     * @type {Array<GpuRequestOptionsOptionsInner>}
     * @memberof GpuRequestOptions
     */
    'options'?: Array<GpuRequestOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface GpuRequestOptionsOptionsInner
 */
export interface GpuRequestOptionsOptionsInner {
    /**
     * 
     * @type {GpuRequestType}
     * @memberof GpuRequestOptionsOptionsInner
     */
    'value': GpuRequestType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof GpuRequestOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface GpuRequestRules
 */
export interface GpuRequestRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof GpuRequestRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof GpuRequestRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof GpuRequestRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for gpuRequest to a given set of values.
     * @type {Array<GpuRequestOptionsOptionsInner>}
     * @memberof GpuRequestRules
     */
    'options'?: Array<GpuRequestOptionsOptionsInner> | null;
}
/**
 * Sets the unit type for GPU resources requests. Stated in terms of portion, memory or  mig profile [deprecated]. Sets the unit type for other GPU request fields. If `gpuDevicesRequest > 1`, only `portion` is supported. If `gpuDeviceRequest = 1`, the request type can be stated as `portion`, `memory` or `migProfile` [deprecated].
 * @export
 * @enum {string}
 */

export const GpuRequestType = {
    Portion: 'portion',
    Memory: 'memory',
    MigProfile: 'migProfile'
} as const;

export type GpuRequestType = typeof GpuRequestType[keyof typeof GpuRequestType];


/**
 * 
 * @export
 * @interface HistoryRecord
 */
export interface HistoryRecord {
    /**
     * 
     * @type {HistoryRecordMeta}
     * @memberof HistoryRecord
     */
    'meta': HistoryRecordMeta;
    /**
     * 
     * @type {HistoryRecordSpec}
     * @memberof HistoryRecord
     */
    'spec': HistoryRecordSpec;
}
/**
 * 
 * @export
 * @interface HistoryRecordMeta
 */
export interface HistoryRecordMeta {
    /**
     * 
     * @type {string}
     * @memberof HistoryRecordMeta
     */
    'creationTimestamp': string;
    /**
     * 
     * @type {HistoryRecordType}
     * @memberof HistoryRecordMeta
     */
    'type': HistoryRecordType;
}
/**
 * 
 * @export
 * @interface HistoryRecordSpec
 */
export interface HistoryRecordSpec {
    /**
     * 
     * @type {Event}
     * @memberof HistoryRecordSpec
     */
    'event'?: Event | null;
    /**
     * 
     * @type {PhaseUpdate}
     * @memberof HistoryRecordSpec
     */
    'phaseUpdate'?: PhaseUpdate | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HistoryRecordType = {
    Event: 'Event',
    PhaseUpdate: 'PhaseUpdate'
} as const;

export type HistoryRecordType = typeof HistoryRecordType[keyof typeof HistoryRecordType];


/**
 * 
 * @export
 * @interface HostPath
 */
export interface HostPath {
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof HostPath
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof HostPath
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof HostPath
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPath
     */
    'mountPropagation'?: HostPathMountPropagation | null;
}
/**
 * 
 * @export
 * @interface HostPathInstance
 */
export interface HostPathInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof HostPathInstance
     */
    'name'?: string | null;
    /**
     * Local path within the controller to which the host volume will be mapped. (mandatory)
     * @type {string}
     * @memberof HostPathInstance
     */
    'path'?: string | null;
    /**
     * Force the volume to be mounted with read-only permissions. Defaults to false.
     * @type {boolean}
     * @memberof HostPathInstance
     */
    'readOnly'?: boolean | null;
    /**
     * The path that the host volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof HostPathInstance
     */
    'mountPath'?: string | null;
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPathInstance
     */
    'mountPropagation'?: HostPathMountPropagation | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof HostPathInstance
     */
    'exclude'?: boolean | null;
}
/**
 * Share this volumes mount with other containers. If set to HostToContainer, this volume mount will receive all subsequent mounts that are mounted to this volume or any of its subdirectories. In case of multiple hostPath entries, this field should have the same value for all of them.
 * @export
 * @enum {string}
 */

export const HostPathMountPropagation = {
    None: 'None',
    HostToContainer: 'HostToContainer'
} as const;

export type HostPathMountPropagation = typeof HostPathMountPropagation[keyof typeof HostPathMountPropagation];


/**
 * 
 * @export
 * @interface HostPathMountPropagationOptions
 */
export interface HostPathMountPropagationOptions {
    /**
     * 
     * @type {Array<HostPathMountPropagationOptionsOptionsInner>}
     * @memberof HostPathMountPropagationOptions
     */
    'options'?: Array<HostPathMountPropagationOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface HostPathMountPropagationOptionsOptionsInner
 */
export interface HostPathMountPropagationOptionsOptionsInner {
    /**
     * 
     * @type {HostPathMountPropagation}
     * @memberof HostPathMountPropagationOptionsOptionsInner
     */
    'value': HostPathMountPropagation | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof HostPathMountPropagationOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface HostPathMountPropagationRules
 */
export interface HostPathMountPropagationRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof HostPathMountPropagationRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof HostPathMountPropagationRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof HostPathMountPropagationRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<HostPathMountPropagationOptionsOptionsInner>}
     * @memberof HostPathMountPropagationRules
     */
    'options'?: Array<HostPathMountPropagationOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface HostPathRules
 */
export interface HostPathRules {
    /**
     * 
     * @type {StringRules}
     * @memberof HostPathRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof HostPathRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof HostPathRules
     */
    'mountPath'?: StringRules | null;
    /**
     * 
     * @type {HostPathMountPropagationRules}
     * @memberof HostPathRules
     */
    'mountPropagation'?: HostPathMountPropagationRules | null;
}
/**
 * 
 * @export
 * @interface HostPathsDefaults
 */
export interface HostPathsDefaults {
    /**
     * 
     * @type {HostPathInstance}
     * @memberof HostPathsDefaults
     */
    'attributes'?: HostPathInstance | null;
    /**
     * Set of host paths to use in the workload.
     * @type {Array<HostPathInstance>}
     * @memberof HostPathsDefaults
     */
    'instances'?: Array<HostPathInstance> | null;
}
/**
 * 
 * @export
 * @interface HostPathsRules
 */
export interface HostPathsRules {
    /**
     * 
     * @type {HostPathRules}
     * @memberof HostPathsRules
     */
    'attributes'?: HostPathRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof HostPathsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface HttpResponse
 */
export interface HttpResponse {
    /**
     * 
     * @type {number}
     * @memberof HttpResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof HttpResponse
     */
    'message': string;
}
/**
 * Image pull policy. Defaults to `Always` if `:latest` tag is specified, otherwise it is `IfNotPresent`.
 * @export
 * @enum {string}
 */

export const ImagePullPolicy = {
    Always: 'Always',
    Never: 'Never',
    IfNotPresent: 'IfNotPresent'
} as const;

export type ImagePullPolicy = typeof ImagePullPolicy[keyof typeof ImagePullPolicy];


/**
 * 
 * @export
 * @interface ImagePullPolicyOptions
 */
export interface ImagePullPolicyOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<ImagePullPolicyOptionsOptionsInner>}
     * @memberof ImagePullPolicyOptions
     */
    'options'?: Array<ImagePullPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ImagePullPolicyOptionsOptionsInner
 */
export interface ImagePullPolicyOptionsOptionsInner {
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof ImagePullPolicyOptionsOptionsInner
     */
    'value': ImagePullPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof ImagePullPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface ImagePullPolicyRules
 */
export interface ImagePullPolicyRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ImagePullPolicyRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof ImagePullPolicyRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof ImagePullPolicyRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<ImagePullPolicyOptionsOptionsInner>}
     * @memberof ImagePullPolicyRules
     */
    'options'?: Array<ImagePullPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface Inference
 */
export interface Inference {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof Inference
     */
    'name': string;
    /**
     * The name as was requested for the workload. If useGivenNameAsPrefix, in the creation request, is false, name and requestedName should be identical. Otherwise, name should be composed of requestedName followed by a suffix of random characters.
     * @type {string}
     * @memberof Inference
     */
    'requestedName': string;
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof Inference
     */
    'workloadId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof Inference
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof Inference
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Inference
     */
    'clusterId': string;
    /**
     * The user who created the workload
     * @type {string}
     * @memberof Inference
     */
    'createdBy': string;
    /**
     * The creation time of the workload.
     * @type {string}
     * @memberof Inference
     */
    'createdAt': string;
    /**
     * The deletion time of the workload.
     * @type {string}
     * @memberof Inference
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadDesiredPhase}
     * @memberof Inference
     */
    'desiredPhase': WorkloadDesiredPhase;
    /**
     * 
     * @type {Phase}
     * @memberof Inference
     */
    'actualPhase'?: Phase;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof Inference
     */
    'spec'?: InferenceSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceCreationRequest
 */
export interface InferenceCreationRequest {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof InferenceCreationRequest
     */
    'name': string;
    /**
     * When true, the requested name will be treated as a prefix. The final name of the workload will be composed of the name followed by a random set of characters.
     * @type {boolean}
     * @memberof InferenceCreationRequest
     */
    'useGivenNameAsPrefix'?: boolean;
    /**
     * The id of the project.
     * @type {string}
     * @memberof InferenceCreationRequest
     */
    'projectId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof InferenceCreationRequest
     */
    'clusterId': string;
    /**
     * A unique ID of the template.
     * @type {string}
     * @memberof InferenceCreationRequest
     */
    'templateId'?: string | null;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceCreationRequest
     */
    'spec'?: InferenceSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceFields
 */
export interface InferenceFields {
    /**
     * 
     * @type {ServingPort}
     * @memberof InferenceFields
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof InferenceFields
     */
    'autoscaling'?: AutoScaling | null;
}
/**
 * 
 * @export
 * @interface InferenceFieldsRules
 */
export interface InferenceFieldsRules {
    /**
     * 
     * @type {ServingPortRules}
     * @memberof InferenceFieldsRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof InferenceFieldsRules
     */
    'autoscaling'?: AutoScalingRules | null;
}
/**
 * 
 * @export
 * @interface InferenceFlatFields
 */
export interface InferenceFlatFields {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof InferenceFlatFields
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof InferenceFlatFields
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof InferenceFlatFields
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof InferenceFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof InferenceFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof InferenceFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * 
 * @export
 * @interface InferenceFlatFieldsRules
 */
export interface InferenceFlatFieldsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof InferenceFlatFieldsRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof InferenceFlatFieldsRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof InferenceFlatFieldsRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof InferenceFlatFieldsRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof InferenceFlatFieldsRules
     */
    'probes'?: ProbesRules | null;
}
/**
 * Specifies what data to request.
 * @export
 * @enum {string}
 */

export const InferencePodMetricType = {
    Throughput: 'THROUGHPUT',
    Latency: 'LATENCY'
} as const;

export type InferencePodMetricType = typeof InferencePodMetricType[keyof typeof InferencePodMetricType];


/**
 * The specifications of the inference to be created.
 * @export
 * @interface InferenceSpec
 */
export interface InferenceSpec {
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceSpec
     */
    'spec'?: InferenceSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceSpecSpec
 */
export interface InferenceSpecSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof InferenceSpecSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof InferenceSpecSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof InferenceSpecSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof InferenceSpecSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof InferenceSpecSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof InferenceSpecSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof InferenceSpecSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof InferenceSpecSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof InferenceSpecSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof InferenceSpecSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof InferenceSpecSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof InferenceSpecSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof InferenceSpecSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof InferenceSpecSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof InferenceSpecSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof InferenceSpecSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof InferenceSpecSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof InferenceSpecSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {CommonStorageFields}
     * @memberof InferenceSpecSpec
     */
    'storage'?: CommonStorageFields | null;
    /**
     * 
     * @type {CommonSecurityFlatFields}
     * @memberof InferenceSpecSpec
     */
    'security'?: CommonSecurityFlatFields | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof InferenceSpecSpec
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof InferenceSpecSpec
     */
    'autoscaling'?: AutoScaling | null;
}
/**
 * 
 * @export
 * @interface InferenceTemplate
 */
export interface InferenceTemplate {
    /**
     * 
     * @type {TemplateMetaFields}
     * @memberof InferenceTemplate
     */
    'meta': TemplateMetaFields;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceTemplate
     */
    'spec'?: InferenceSpecSpec;
    /**
     * 
     * @type {RunnableInfo}
     * @memberof InferenceTemplate
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceTemplate
     */
    'combinedSpec'?: InferenceSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceTemplateAllOf
 */
export interface InferenceTemplateAllOf {
    /**
     * 
     * @type {RunnableInfo}
     * @memberof InferenceTemplateAllOf
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceTemplateAllOf
     */
    'combinedSpec'?: InferenceSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceTemplateCreationRequest
 */
export interface InferenceTemplateCreationRequest {
    /**
     * 
     * @type {TemplateCreationMetaFields}
     * @memberof InferenceTemplateCreationRequest
     */
    'meta': TemplateCreationMetaFields;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceTemplateCreationRequest
     */
    'spec'?: InferenceSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceTemplatePatchRequest
 */
export interface InferenceTemplatePatchRequest {
    /**
     * 
     * @type {TemplatePatchMetaFields}
     * @memberof InferenceTemplatePatchRequest
     */
    'meta'?: TemplatePatchMetaFields | null;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceTemplatePatchRequest
     */
    'spec'?: InferenceSpecSpec;
    /**
     * 
     * @type {Array<string>}
     * @memberof InferenceTemplatePatchRequest
     */
    'fieldsToClear'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InferenceTemplateUpdateRequest
 */
export interface InferenceTemplateUpdateRequest {
    /**
     * 
     * @type {TemplateUpdateMetaFields}
     * @memberof InferenceTemplateUpdateRequest
     */
    'meta': TemplateUpdateMetaFields;
    /**
     * 
     * @type {InferenceSpecSpec}
     * @memberof InferenceTemplateUpdateRequest
     */
    'spec'?: InferenceSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceTemplatesListResponse
 */
export interface InferenceTemplatesListResponse {
    /**
     * 
     * @type {Array<InferenceTemplate>}
     * @memberof InferenceTemplatesListResponse
     */
    'entries'?: Array<InferenceTemplate>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InferenceTemplatesListResponse
     */
    'pagination'?: PaginationInfo;
}
/**
 * 
 * @export
 * @interface InferenceUpdateRequest
 */
export interface InferenceUpdateRequest {
    /**
     * 
     * @type {InferenceUpdateSpecSpec}
     * @memberof InferenceUpdateRequest
     */
    'spec'?: InferenceUpdateSpecSpec;
}
/**
 * The specifications of the inference to be updated.
 * @export
 * @interface InferenceUpdateSpec
 */
export interface InferenceUpdateSpec {
    /**
     * 
     * @type {InferenceUpdateSpecSpec}
     * @memberof InferenceUpdateSpec
     */
    'spec'?: InferenceUpdateSpecSpec;
}
/**
 * 
 * @export
 * @interface InferenceUpdateSpecAutoscaling
 */
export interface InferenceUpdateSpecAutoscaling {
    /**
     * 
     * @type {AutoScaling}
     * @memberof InferenceUpdateSpecAutoscaling
     */
    'autoscaling'?: AutoScaling | null;
}
/**
 * 
 * @export
 * @interface InferenceUpdateSpecSpec
 */
export interface InferenceUpdateSpecSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof InferenceUpdateSpecSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof InferenceUpdateSpecSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof InferenceUpdateSpecSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof InferenceUpdateSpecSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof InferenceUpdateSpecSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof InferenceUpdateSpecSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof InferenceUpdateSpecSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof InferenceUpdateSpecSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof InferenceUpdateSpecSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof InferenceUpdateSpecSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof InferenceUpdateSpecSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof InferenceUpdateSpecSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof InferenceUpdateSpecSpec
     */
    'autoscaling'?: AutoScaling | null;
}
/**
 * Specify which data to request.
 * @export
 * @enum {string}
 */

export const InferenceWorkloadMetricType = {
    Throughput: 'THROUGHPUT',
    Latency: 'LATENCY'
} as const;

export type InferenceWorkloadMetricType = typeof InferenceWorkloadMetricType[keyof typeof InferenceWorkloadMetricType];


/**
 * 
 * @export
 * @interface InstancesRules
 */
export interface InstancesRules {
    /**
     * 
     * @type {ItemRules}
     * @memberof InstancesRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface IntegerRules
 */
export interface IntegerRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof IntegerRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof IntegerRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof IntegerRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRules
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRules
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=10, step=2 implies that the values the field can hold are 2, 4, 6, 8 and 10.
     * @type {number}
     * @memberof IntegerRules
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof IntegerRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface IntegerRulesOptional
 */
export interface IntegerRulesOptional {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof IntegerRulesOptional
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof IntegerRulesOptional
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=10, step=2 implies that the values the field can hold are 2, 4, 6, 8 and 10.
     * @type {number}
     * @memberof IntegerRulesOptional
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof IntegerRulesOptional
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface InternalPodsSyncRequest
 */
export interface InternalPodsSyncRequest {
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof InternalPodsSyncRequest
     */
    'clusterId': string;
    /**
     * 
     * @type {Array<PodSyncFields>}
     * @memberof InternalPodsSyncRequest
     */
    'pods': Array<PodSyncFields>;
}
/**
 * 
 * @export
 * @interface InternalSyncPods207Response
 */
export interface InternalSyncPods207Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalSyncPods207Response
     */
    'successfullySyncedPods': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalSyncPods207Response
     */
    'failedPods': Array<string>;
}
/**
 * 
 * @export
 * @interface InternalSyncWorkloads207Response
 */
export interface InternalSyncWorkloads207Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalSyncWorkloads207Response
     */
    'successfullySyncedWorkloads': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalSyncWorkloads207Response
     */
    'failedWorkloads': Array<string>;
}
/**
 * 
 * @export
 * @interface InternalWorkloadsSyncRequest
 */
export interface InternalWorkloadsSyncRequest {
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof InternalWorkloadsSyncRequest
     */
    'clusterId': string;
    /**
     * 
     * @type {Array<WorkloadSyncFields>}
     * @memberof InternalWorkloadsSyncRequest
     */
    'workloads': Array<WorkloadSyncFields>;
}
/**
 * 
 * @export
 * @interface InvolvedObject
 */
export interface InvolvedObject {
    /**
     * 
     * @type {string}
     * @memberof InvolvedObject
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof InvolvedObject
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof InvolvedObject
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InvolvedObject
     */
    'namespace': string;
}
/**
 * 
 * @export
 * @interface ItemRules
 */
export interface ItemRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ItemRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether it is permitted to add items. Default to true.
     * @type {boolean}
     * @memberof ItemRules
     */
    'canAdd'?: boolean | null;
    /**
     * Set of keys for items that are \"locked\", i.e. cannot be removed or deleted.
     * @type {Array<string>}
     * @memberof ItemRules
     */
    'locked'?: Array<string>;
}
/**
 * Label details to be populated into the container.
 * @export
 * @interface Label
 */
export interface Label {
    /**
     * The name of the label (mandatory)
     * @type {string}
     * @memberof Label
     */
    'name'?: string | null;
    /**
     * The value of the label.
     * @type {string}
     * @memberof Label
     */
    'value'?: string | null;
    /**
     * Use \'true\' in case the label is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Label
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface LabelsDefaults
 */
export interface LabelsDefaults {
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof LabelsDefaults
     */
    'instances'?: Array<Label> | null;
}
/**
 * 
 * @export
 * @interface LabelsField
 */
export interface LabelsField {
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof LabelsField
     */
    'labels'?: Array<Label> | null;
}
/**
 * 
 * @export
 * @interface LabelsFieldDefaults
 */
export interface LabelsFieldDefaults {
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof LabelsFieldDefaults
     */
    'labels'?: LabelsDefaults | null;
}
/**
 * 
 * @export
 * @interface LabelsFieldRules
 */
export interface LabelsFieldRules {
    /**
     * 
     * @type {InstancesRules}
     * @memberof LabelsFieldRules
     */
    'labels'?: InstancesRules | null;
}
/**
 * 
 * @export
 * @interface ListPods200Response
 */
export interface ListPods200Response {
    /**
     * 
     * @type {number}
     * @memberof ListPods200Response
     */
    'next'?: number;
    /**
     * 
     * @type {Array<Pod>}
     * @memberof ListPods200Response
     */
    'pods': Array<Pod>;
}
/**
 * The spec of the master. Should be provided only if masterSpecSameAsWorker is false.
 * @export
 * @interface MasterSpec
 */
export interface MasterSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof MasterSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof MasterSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof MasterSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof MasterSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof MasterSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof MasterSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof MasterSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof MasterSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof MasterSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof MasterSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof MasterSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof MasterSpec
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof MasterSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof MasterSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof MasterSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof MasterSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof MasterSpec
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof MasterSpec
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof MasterSpec
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof MasterSpec
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof MasterSpec
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof MasterSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof MasterSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof MasterSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof MasterSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof MasterSpec
     */
    'storage'?: StorageFields | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof MasterSpec
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface MeasurementResponse
 */
export interface MeasurementResponse {
    /**
     * specifies what data returned
     * @type {string}
     * @memberof MeasurementResponse
     */
    'type': string;
    /**
     * labels of the metric measurement
     * @type {{ [key: string]: string; }}
     * @memberof MeasurementResponse
     */
    'labels'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {Array<MeasurementResponseValuesInner>}
     * @memberof MeasurementResponse
     */
    'values': Array<MeasurementResponseValuesInner> | null;
}
/**
 * 
 * @export
 * @interface MeasurementResponseValuesInner
 */
export interface MeasurementResponseValuesInner {
    /**
     * 
     * @type {string}
     * @memberof MeasurementResponseValuesInner
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementResponseValuesInner
     */
    'timestamp': string | null;
}
/**
 * 
 * @export
 * @interface MetricsResponse
 */
export interface MetricsResponse {
    /**
     * 
     * @type {Array<MeasurementResponse>}
     * @memberof MetricsResponse
     */
    'measurements': Array<MeasurementResponse>;
}
/**
 * Required only if `gpuRequestType` is `migProfile`. This states the memory profile to be used for the workload running NVIDIA Multi-Instance GPU (MIG) technology.
 * @export
 * @enum {string}
 */

export const MigProfile = {
    _1g5gb: '1g.5gb',
    _1g10gb: '1g.10gb',
    _2g10gb: '2g.10gb',
    _2g20gb: '2g.20gb',
    _3g20gb: '3g.20gb',
    _3g40gb: '3g.40gb',
    _4g20gb: '4g.20gb',
    _4g40gb: '4g.40gb',
    _7g40gb: '7g.40gb',
    _7g80gb: '7g.80gb'
} as const;

export type MigProfile = typeof MigProfile[keyof typeof MigProfile];


/**
 * 
 * @export
 * @interface MigProfileOptions
 */
export interface MigProfileOptions {
    /**
     * Limit the permitted values for migProfile to a given set of values.
     * @type {Array<MigProfileOptionsOptionsInner>}
     * @memberof MigProfileOptions
     */
    'options'?: Array<MigProfileOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface MigProfileOptionsOptionsInner
 */
export interface MigProfileOptionsOptionsInner {
    /**
     * 
     * @type {MigProfile}
     * @memberof MigProfileOptionsOptionsInner
     * @deprecated
     */
    'value': MigProfile | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof MigProfileOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface MigProfileRules
 */
export interface MigProfileRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof MigProfileRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof MigProfileRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof MigProfileRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for migProfile to a given set of values.
     * @type {Array<MigProfileOptionsOptionsInner>}
     * @memberof MigProfileRules
     */
    'options'?: Array<MigProfileOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'details'?: string;
}
/**
 * 
 * @export
 * @interface Nfs
 */
export interface Nfs {
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof Nfs
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof Nfs
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof Nfs
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof Nfs
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface NfsInstance
 */
export interface NfsInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof NfsInstance
     */
    'name'?: string | null;
    /**
     * Path that is exported by the NFS server (mandatory). For more information, see [NFS](https://kubernetes.io/docs/concepts/storage/volumes#nfs).
     * @type {string}
     * @memberof NfsInstance
     */
    'path'?: string | null;
    /**
     * Force the NFS export to be mounted with read-only permissions.
     * @type {boolean}
     * @memberof NfsInstance
     */
    'readOnly'?: boolean | null;
    /**
     * The hostname or IP address of the NFS server. (mandatory)
     * @type {string}
     * @memberof NfsInstance
     */
    'server'?: string | null;
    /**
     * The path that the NFS volume will be mounted to when in use. (mandatory)
     * @type {string}
     * @memberof NfsInstance
     */
    'mountPath'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof NfsInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NfsRules
 */
export interface NfsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NfsRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'server'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof NfsRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface NfssDefaults
 */
export interface NfssDefaults {
    /**
     * 
     * @type {NfsInstance}
     * @memberof NfssDefaults
     */
    'attributes'?: NfsInstance | null;
    /**
     * Set of nfs volumes to use in the workload.
     * @type {Array<NfsInstance>}
     * @memberof NfssDefaults
     */
    'instances'?: Array<NfsInstance> | null;
}
/**
 * 
 * @export
 * @interface NfssRules
 */
export interface NfssRules {
    /**
     * 
     * @type {NfsRules}
     * @memberof NfssRules
     */
    'attributes'?: NfsRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof NfssRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface NonInferenceFlatFields
 */
export interface NonInferenceFlatFields {
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof NonInferenceFlatFields
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof NonInferenceFlatFields
     */
    'stdin'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceFlatFieldsRules
 */
export interface NonInferenceFlatFieldsRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceFlatFieldsRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceFlatFieldsRules
     */
    'stdin'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface NonInferenceSecurityFlatFields
 */
export interface NonInferenceSecurityFlatFields {
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityFlatFields
     */
    'hostNetwork'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceSecurityFlatFieldsRules
 */
export interface NonInferenceSecurityFlatFieldsRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityFlatFieldsRules
     */
    'allowPrivilegeEscalation'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityFlatFieldsRules
     */
    'hostIpc'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityFlatFieldsRules
     */
    'hostNetwork'?: BooleanRules | null;
}
/**
 * Security related fields. When used in assets context, those are environment asset fields that cannot be override in the submit workload request.
 * @export
 * @interface NonInferenceSecurityNonOverridable
 */
export interface NonInferenceSecurityNonOverridable {
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof NonInferenceSecurityNonOverridable
     */
    'hostNetwork'?: boolean | null;
}
/**
 * 
 * @export
 * @interface NonInferenceSecurityNonOverridableRules
 */
export interface NonInferenceSecurityNonOverridableRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityNonOverridableRules
     */
    'allowPrivilegeEscalation'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityNonOverridableRules
     */
    'hostIpc'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof NonInferenceSecurityNonOverridableRules
     */
    'hostNetwork'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface NonInferenceStorageFields
 */
export interface NonInferenceStorageFields {
    /**
     * Set of s3 buckets to use in the workload.
     * @type {Array<S3Instance>}
     * @memberof NonInferenceStorageFields
     */
    's3'?: Array<S3Instance> | null;
}
/**
 * 
 * @export
 * @interface NonInferenceStorageFieldsDefaults
 */
export interface NonInferenceStorageFieldsDefaults {
    /**
     * 
     * @type {S3sDefaults}
     * @memberof NonInferenceStorageFieldsDefaults
     */
    's3'?: S3sDefaults | null;
}
/**
 * 
 * @export
 * @interface NonInferenceStorageFieldsRules
 */
export interface NonInferenceStorageFieldsRules {
    /**
     * 
     * @type {S3sRules}
     * @memberof NonInferenceStorageFieldsRules
     */
    's3'?: S3sRules | null;
}
/**
 * 
 * @export
 * @interface NumberRules
 */
export interface NumberRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof NumberRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory. default to false.
     * @type {boolean}
     * @memberof NumberRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable. default to true
     * @type {boolean}
     * @memberof NumberRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {number}
     * @memberof NumberRules
     */
    'min'?: number | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {number}
     * @memberof NumberRules
     */
    'max'?: number | null;
    /**
     * The minimal difference between two values the field can be assigned to. For example, min=2, max=3, step=0.25 implies that the values the field can hold are 2, 2.25, 2.5 and 3.
     * @type {number}
     * @memberof NumberRules
     */
    'step'?: number | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof NumberRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrgType = {
    Project: 'PROJECT',
    Department: 'DEPARTMENT'
} as const;

export type OrgType = typeof OrgType[keyof typeof OrgType];


/**
 * 
 * @export
 * @interface PaginationInfo
 */
export interface PaginationInfo {
    /**
     * the number of entries included in this bulk of entries
     * @type {number}
     * @memberof PaginationInfo
     */
    'limit'?: number;
    /**
     * the first entry that was requested to be included in this bulk
     * @type {number}
     * @memberof PaginationInfo
     */
    'offset'?: number;
    /**
     * the offset of the next bulk of entries
     * @type {number}
     * @memberof PaginationInfo
     */
    'nextOffset'?: number;
}
/**
 * 
 * @export
 * @interface ParallelismField
 */
export interface ParallelismField {
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof ParallelismField
     */
    'parallelism'?: number | null;
}
/**
 * 
 * @export
 * @interface PendingSchedulingMessage
 */
export interface PendingSchedulingMessage {
    /**
     * 
     * @type {string}
     * @memberof PendingSchedulingMessage
     */
    'nodePool': string;
    /**
     * 
     * @type {PhaseReason}
     * @memberof PendingSchedulingMessage
     */
    'phaseReason': PhaseReason;
    /**
     * 
     * @type {string}
     * @memberof PendingSchedulingMessage
     */
    'reason': string;
    /**
     * 
     * @type {OrgType}
     * @memberof PendingSchedulingMessage
     */
    'orgType'?: OrgType | null;
    /**
     * 
     * @type {string}
     * @memberof PendingSchedulingMessage
     */
    'userMessage'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Phase = {
    Creating: 'Creating',
    Initializing: 'Initializing',
    Resuming: 'Resuming',
    Pending: 'Pending',
    Deleting: 'Deleting',
    Running: 'Running',
    Updating: 'Updating',
    Stopped: 'Stopped',
    Stopping: 'Stopping',
    Degraded: 'Degraded',
    Failed: 'Failed',
    Completed: 'Completed',
    Terminating: 'Terminating',
    Unknown: 'Unknown'
} as const;

export type Phase = typeof Phase[keyof typeof Phase];


/**
 * 
 * @export
 * @enum {string}
 */

export const PhaseReason = {
    NonPreemptibleOverQuota: 'NonPreemptibleOverQuota',
    OverLimit: 'OverLimit'
} as const;

export type PhaseReason = typeof PhaseReason[keyof typeof PhaseReason];


/**
 * 
 * @export
 * @interface PhaseUpdate
 */
export interface PhaseUpdate {
    /**
     * 
     * @type {Phase}
     * @memberof PhaseUpdate
     */
    'phase': Phase;
    /**
     * 
     * @type {string}
     * @memberof PhaseUpdate
     */
    'phaseMessage': string;
}
/**
 * 
 * @export
 * @interface Pod
 */
export interface Pod {
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'priorityClassName': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'workloadId': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'revisionId'?: string | null;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Pod
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'nodeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {Array<Container>}
     * @memberof Pod
     */
    'containers': Array<Container>;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'currentNodePool'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Pod
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {PodRequestResources}
     * @memberof Pod
     */
    'requestedResources'?: PodRequestResources | null;
    /**
     * 
     * @type {AllocatedResources}
     * @memberof Pod
     */
    'allocatedResources'?: AllocatedResources | null;
    /**
     * 
     * @type {Array<PodToleration>}
     * @memberof Pod
     */
    'tolerations'?: Array<PodToleration>;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'k8sPhase': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'ip'?: string | null;
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof Pod
     */
    'tenantId': number;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'k8sPhaseUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pod
     */
    'workloadName'?: string;
}
/**
 * Pod affinity scheduling rules (e.g. co-locate this workload in the same node, zone, etc. as some other workloads).
 * @export
 * @interface PodAffinity
 */
export interface PodAffinity {
    /**
     * 
     * @type {PodAffinityType}
     * @memberof PodAffinity
     */
    'type'?: PodAffinityType | null;
    /**
     * The label key to use. (mandatory)
     * @type {string}
     * @memberof PodAffinity
     */
    'key'?: string | null;
}
/**
 * 
 * @export
 * @interface PodAffinityRules
 */
export interface PodAffinityRules {
    /**
     * 
     * @type {PodAffinityTypeRules}
     * @memberof PodAffinityRules
     */
    'type'?: PodAffinityTypeRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PodAffinityRules
     */
    'key'?: StringRules | null;
}
/**
 * The affinity type, required or preferred. (mandatory)
 * @export
 * @enum {string}
 */

export const PodAffinityType = {
    Required: 'Required',
    Preferred: 'Preferred'
} as const;

export type PodAffinityType = typeof PodAffinityType[keyof typeof PodAffinityType];


/**
 * 
 * @export
 * @interface PodAffinityTypeOptions
 */
export interface PodAffinityTypeOptions {
    /**
     * 
     * @type {Array<PodAffinityTypeOptionsOptionsInner>}
     * @memberof PodAffinityTypeOptions
     */
    'options'?: Array<PodAffinityTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PodAffinityTypeOptionsOptionsInner
 */
export interface PodAffinityTypeOptionsOptionsInner {
    /**
     * 
     * @type {PodAffinityType}
     * @memberof PodAffinityTypeOptionsOptionsInner
     */
    'value': PodAffinityType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof PodAffinityTypeOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface PodAffinityTypeRules
 */
export interface PodAffinityTypeRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof PodAffinityTypeRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof PodAffinityTypeRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof PodAffinityTypeRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<PodAffinityTypeOptionsOptionsInner>}
     * @memberof PodAffinityTypeRules
     */
    'options'?: Array<PodAffinityTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PodComputedFields
 */
export interface PodComputedFields {
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof PodComputedFields
     */
    'tenantId': number;
    /**
     * 
     * @type {string}
     * @memberof PodComputedFields
     */
    'k8sPhaseUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PodComputedFields
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PodComputedFields
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface PodGroupsSyncFields
 */
export interface PodGroupsSyncFields {
    /**
     * 
     * @type {string}
     * @memberof PodGroupsSyncFields
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PodGroupsSyncFields
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PodGroupsSyncFields
     */
    'workloadId': string;
    /**
     * 
     * @type {string}
     * @memberof PodGroupsSyncFields
     */
    'revisionId'?: string | null;
}
/**
 * 
 * @export
 * @interface PodGroupsSyncRequest
 */
export interface PodGroupsSyncRequest {
    /**
     * 
     * @type {Array<PodGroupsSyncFields>}
     * @memberof PodGroupsSyncRequest
     */
    'podGroups': Array<PodGroupsSyncFields>;
}
/**
 * Specify which data to request.
 * @export
 * @enum {string}
 */

export const PodMetricType = {
    GpuUtilizationPerGpu: 'GPU_UTILIZATION_PER_GPU',
    GpuUtilization: 'GPU_UTILIZATION',
    GpuMemoryUsageBytesPerGpu: 'GPU_MEMORY_USAGE_BYTES_PER_GPU',
    GpuMemoryUsageBytes: 'GPU_MEMORY_USAGE_BYTES',
    CpuUsageCores: 'CPU_USAGE_CORES',
    CpuMemoryUsageBytes: 'CPU_MEMORY_USAGE_BYTES',
    GpuGraphicsEngineActivityPerGpu: 'GPU_GRAPHICS_ENGINE_ACTIVITY_PER_GPU',
    GpuSmActivityPerGpu: 'GPU_SM_ACTIVITY_PER_GPU',
    GpuSmOccupancyPerGpu: 'GPU_SM_OCCUPANCY_PER_GPU',
    GpuTensorActivityPerGpu: 'GPU_TENSOR_ACTIVITY_PER_GPU',
    GpuFp64EngineActivityPerGpu: 'GPU_FP64_ENGINE_ACTIVITY_PER_GPU',
    GpuFp32EngineActivityPerGpu: 'GPU_FP32_ENGINE_ACTIVITY_PER_GPU',
    GpuFp16EngineActivityPerGpu: 'GPU_FP16_ENGINE_ACTIVITY_PER_GPU',
    GpuMemoryBandwidthUtilizationPerGpu: 'GPU_MEMORY_BANDWIDTH_UTILIZATION_PER_GPU',
    GpuNvlinkTransmittedBandwidthPerGpu: 'GPU_NVLINK_TRANSMITTED_BANDWIDTH_PER_GPU',
    GpuNvlinkReceivedBandwidthPerGpu: 'GPU_NVLINK_RECEIVED_BANDWIDTH_PER_GPU',
    GpuPcieTransmittedBandwidthPerGpu: 'GPU_PCIE_TRANSMITTED_BANDWIDTH_PER_GPU',
    GpuPcieReceivedBandwidthPerGpu: 'GPU_PCIE_RECEIVED_BANDWIDTH_PER_GPU',
    GpuSwapMemoryBytesPerGpu: 'GPU_SWAP_MEMORY_BYTES_PER_GPU'
} as const;

export type PodMetricType = typeof PodMetricType[keyof typeof PodMetricType];


/**
 * 
 * @export
 * @interface PodRequestResources
 */
export interface PodRequestResources {
    /**
     * 
     * @type {GpuRequestType}
     * @memberof PodRequestResources
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * 
     * @type {RequestResourceCores}
     * @memberof PodRequestResources
     */
    'gpu'?: RequestResourceCores | null;
    /**
     * 
     * @type {RequestResourceQuantity}
     * @memberof PodRequestResources
     */
    'gpuMemory'?: RequestResourceQuantity | null;
    /**
     * 
     * @type {RequestResourceCores}
     * @memberof PodRequestResources
     */
    'cpu'?: RequestResourceCores | null;
    /**
     * 
     * @type {RequestResourceQuantity}
     * @memberof PodRequestResources
     */
    'cpuMemory'?: RequestResourceQuantity | null;
    /**
     * 
     * @type {MigProfile}
     * @memberof PodRequestResources
     * @deprecated
     */
    'migProfile'?: MigProfile | null;
    /**
     * Set of extended resources with their quantity
     * @type {Array<WorkloadsExtendedResource>}
     * @memberof PodRequestResources
     */
    'extendedResources'?: Array<WorkloadsExtendedResource> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PodSortFilterFields = {
    ClusterId: 'clusterId',
    WorkloadId: 'workloadId',
    NodeName: 'nodeName',
    CurrentNodepool: 'currentNodepool',
    CreatedAt: 'createdAt',
    CompletedAt: 'completedAt',
    DeletedAt: 'deletedAt'
} as const;

export type PodSortFilterFields = typeof PodSortFilterFields[keyof typeof PodSortFilterFields];


/**
 * 
 * @export
 * @interface PodSyncFields
 */
export interface PodSyncFields {
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'priorityClassName': string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'workloadId': string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'revisionId'?: string | null;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof PodSyncFields
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'nodeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {Array<Container>}
     * @memberof PodSyncFields
     */
    'containers': Array<Container>;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'currentNodePool'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PodSyncFields
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {PodRequestResources}
     * @memberof PodSyncFields
     */
    'requestedResources'?: PodRequestResources | null;
    /**
     * 
     * @type {AllocatedResources}
     * @memberof PodSyncFields
     */
    'allocatedResources'?: AllocatedResources | null;
    /**
     * 
     * @type {Array<PodToleration>}
     * @memberof PodSyncFields
     */
    'tolerations'?: Array<PodToleration>;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'k8sPhase': string;
    /**
     * 
     * @type {string}
     * @memberof PodSyncFields
     */
    'ip'?: string | null;
}
/**
 * 
 * @export
 * @interface PodToleration
 */
export interface PodToleration {
    /**
     * Key is the taint key that the toleration applies to. Empty means match all taint keys.
     * @type {string}
     * @memberof PodToleration
     */
    'key'?: string;
    /**
     * Operator represents a key\'s relationship to the value.
     * @type {string}
     * @memberof PodToleration
     */
    'operator'?: string;
    /**
     * Value is the taint value the toleration matches to.
     * @type {string}
     * @memberof PodToleration
     */
    'value'?: string;
    /**
     * Effect indicates the taint effect to match. Empty means match all taint effects.
     * @type {string}
     * @memberof PodToleration
     */
    'effect'?: string;
    /**
     * TolerationSeconds represents the period of time the toleration (which must be of effect NoExecute, otherwise this field is ignored) tolerates the taint.
     * @type {number}
     * @memberof PodToleration
     */
    'tolerationSeconds'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PodVerbosity = {
    Brief: 'brief',
    Full: 'full'
} as const;

export type PodVerbosity = typeof PodVerbosity[keyof typeof PodVerbosity];


/**
 * 
 * @export
 * @interface PodVerbosityFields
 */
export interface PodVerbosityFields {
    /**
     * 
     * @type {string}
     * @memberof PodVerbosityFields
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PodVerbosityFields
     */
    'workloadName'?: string;
}
/**
 * 
 * @export
 * @interface PodsSyncRequest
 */
export interface PodsSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof PodsSyncRequest
     */
    'projectId': string;
    /**
     * 
     * @type {Array<PodSyncFields>}
     * @memberof PodsSyncRequest
     */
    'pods': Array<PodSyncFields>;
    /**
     * the first pod id to sync. if empty, all pods before the first one sent will be deleted.
     * @type {string}
     * @memberof PodsSyncRequest
     */
    'from'?: string;
    /**
     * the last pod to sync. if empty, all pods after the last one sent will be deleted.
     * @type {string}
     * @memberof PodsSyncRequest
     */
    'to'?: string;
    /**
     * pod ids to ignore when deleting.
     * @type {Array<string>}
     * @memberof PodsSyncRequest
     */
    'idsToIgnore'?: Array<string>;
}
/**
 * A port for accessing the workload.
 * @export
 * @interface Port
 */
export interface Port {
    /**
     * The port that the container running the workload exposes. (mandatory)
     * @type {number}
     * @memberof Port
     */
    'container'?: number | null;
    /**
     * 
     * @type {PortServiceType}
     * @memberof Port
     */
    'serviceType'?: PortServiceType | null;
    /**
     * The external port which allows a connection to the container port. If not specified, the port will be auto-generated by the system..
     * @type {number}
     * @memberof Port
     */
    'external'?: number | null;
    /**
     * The tool type that runs on this port.
     * @type {string}
     * @memberof Port
     */
    'toolType'?: string | null;
    /**
     * A name describing the tool that runs on this port.
     * @type {string}
     * @memberof Port
     */
    'toolName'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof Port
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Port
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for port attributes
 * @export
 * @interface PortRules
 */
export interface PortRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof PortRules
     */
    'container'?: IntegerRules | null;
    /**
     * 
     * @type {PortServiceTypeRules}
     * @memberof PortRules
     */
    'serviceType'?: PortServiceTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PortRules
     */
    'customExternalPort'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof PortRules
     */
    'external'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PortRules
     */
    'toolType'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PortRules
     */
    'toolName'?: StringRules | null;
}
/**
 * The service type of the port (mandatory).
 * @export
 * @enum {string}
 */

export const PortServiceType = {
    LoadBalancer: 'LoadBalancer',
    NodePort: 'NodePort',
    ClusterIp: 'ClusterIP'
} as const;

export type PortServiceType = typeof PortServiceType[keyof typeof PortServiceType];


/**
 * 
 * @export
 * @interface PortServiceTypeOptions
 */
export interface PortServiceTypeOptions {
    /**
     * 
     * @type {Array<PortServiceTypeOptionsOptionsInner>}
     * @memberof PortServiceTypeOptions
     */
    'options'?: Array<PortServiceTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PortServiceTypeOptionsOptionsInner
 */
export interface PortServiceTypeOptionsOptionsInner {
    /**
     * 
     * @type {PortServiceType}
     * @memberof PortServiceTypeOptionsOptionsInner
     */
    'value': PortServiceType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof PortServiceTypeOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface PortServiceTypeRules
 */
export interface PortServiceTypeRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof PortServiceTypeRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof PortServiceTypeRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof PortServiceTypeRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<PortServiceTypeOptionsOptionsInner>}
     * @memberof PortServiceTypeRules
     */
    'options'?: Array<PortServiceTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PortsDefaults
 */
export interface PortsDefaults {
    /**
     * 
     * @type {Port}
     * @memberof PortsDefaults
     */
    'attributes'?: Port | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof PortsDefaults
     */
    'instances'?: Array<Port> | null;
}
/**
 * 
 * @export
 * @interface PortsRules
 */
export interface PortsRules {
    /**
     * 
     * @type {PortRules}
     * @memberof PortsRules
     */
    'attributes'?: PortRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof PortsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * Priority class of the workload. The default value for workspace is \'build\' and it can be changed to \'interactive-preemptible\' to allow the workload to use over-quota resources. The default value for training is \'train\' and it can be changed to \'build\' to allow the training workload to have a higher priority for in-queue scheduling and also become non-preemptive (if it\'s in deserved quota)..
 * @export
 * @enum {string}
 */

export const PriorityClass = {
    Build: 'build',
    Train: 'train',
    InteractivePreemptible: 'interactive-preemptible'
} as const;

export type PriorityClass = typeof PriorityClass[keyof typeof PriorityClass];


/**
 * 
 * @export
 * @interface PriorityClassFields
 */
export interface PriorityClassFields {
    /**
     * 
     * @type {PriorityClass}
     * @memberof PriorityClassFields
     */
    'priorityClass'?: PriorityClass | null;
}
/**
 * 
 * @export
 * @interface PriorityClassFieldsRules
 */
export interface PriorityClassFieldsRules {
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof PriorityClassFieldsRules
     */
    'priorityClass'?: PriorityClassRules | null;
}
/**
 * 
 * @export
 * @interface PriorityClassOptions
 */
export interface PriorityClassOptions {
    /**
     * 
     * @type {Array<PriorityClassOptionsOptionsInner>}
     * @memberof PriorityClassOptions
     */
    'options'?: Array<PriorityClassOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface PriorityClassOptionsOptionsInner
 */
export interface PriorityClassOptionsOptionsInner {
    /**
     * 
     * @type {PriorityClass}
     * @memberof PriorityClassOptionsOptionsInner
     */
    'value': PriorityClass | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof PriorityClassOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface PriorityClassRules
 */
export interface PriorityClassRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof PriorityClassRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof PriorityClassRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof PriorityClassRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<PriorityClassOptionsOptionsInner>}
     * @memberof PriorityClassRules
     */
    'options'?: Array<PriorityClassOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface Probe
 */
export interface Probe {
    /**
     * Number of seconds after the container has started before liveness or readiness probes are initiated.
     * @type {number}
     * @memberof Probe
     */
    'initialDelaySeconds'?: number | null;
    /**
     * How often (in seconds) to perform the probe.
     * @type {number}
     * @memberof Probe
     */
    'periodSeconds'?: number | null;
    /**
     * Number of seconds after which the probe times out.
     * @type {number}
     * @memberof Probe
     */
    'timeoutSeconds'?: number | null;
    /**
     * Minimum consecutive successes for the probe to be considered successful after having failed.
     * @type {number}
     * @memberof Probe
     */
    'successThreshold'?: number | null;
    /**
     * When a probe fails, the number of times to try before giving up.
     * @type {number}
     * @memberof Probe
     */
    'failureThreshold'?: number | null;
    /**
     * 
     * @type {ProbeHandler}
     * @memberof Probe
     */
    'handler'?: ProbeHandler | null;
}
/**
 * The action taken to determine the health of the container. (mandatory)
 * @export
 * @interface ProbeHandler
 */
export interface ProbeHandler {
    /**
     * 
     * @type {ProbeHandlerHttpGet}
     * @memberof ProbeHandler
     */
    'httpGet'?: ProbeHandlerHttpGet;
}
/**
 * An action based on HTTP Get requests.
 * @export
 * @interface ProbeHandlerHttpGet
 */
export interface ProbeHandlerHttpGet {
    /**
     * Path to access on the HTTP server, defaults to /.
     * @type {string}
     * @memberof ProbeHandlerHttpGet
     */
    'path'?: string | null;
    /**
     * Number of the port to access on the container.
     * @type {number}
     * @memberof ProbeHandlerHttpGet
     */
    'port'?: number | null;
    /**
     * Host name to connect to, defaults to the pod IP.
     * @type {string}
     * @memberof ProbeHandlerHttpGet
     */
    'host'?: string | null;
    /**
     * 
     * @type {ProbeHandlerScheme}
     * @memberof ProbeHandlerHttpGet
     */
    'scheme'?: ProbeHandlerScheme | null;
}
/**
 * 
 * @export
 * @interface ProbeHandlerRules
 */
export interface ProbeHandlerRules {
    /**
     * 
     * @type {ProbeHandlerRulesHttpGet}
     * @memberof ProbeHandlerRules
     */
    'httpGet'?: ProbeHandlerRulesHttpGet;
}
/**
 * 
 * @export
 * @interface ProbeHandlerRulesHttpGet
 */
export interface ProbeHandlerRulesHttpGet {
    /**
     * 
     * @type {StringRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'port'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'host'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof ProbeHandlerRulesHttpGet
     */
    'scheme'?: StringRules | null;
}
/**
 * Scheme to use for connecting to the host, defaults to HTTP.
 * @export
 * @enum {string}
 */

export const ProbeHandlerScheme = {
    Http: 'HTTP',
    Https: 'HTTPS'
} as const;

export type ProbeHandlerScheme = typeof ProbeHandlerScheme[keyof typeof ProbeHandlerScheme];


/**
 * 
 * @export
 * @interface ProbeRules
 */
export interface ProbeRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'initialDelaySeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'periodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'timeoutSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'successThreshold'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof ProbeRules
     */
    'failureThreshold'?: IntegerRules | null;
    /**
     * 
     * @type {ProbeHandlerRules}
     * @memberof ProbeRules
     */
    'handler'?: ProbeHandlerRules | null;
}
/**
 * Probes are used to determine if the container is healthy and ready to accept traffic.
 * @export
 * @interface Probes
 */
export interface Probes {
    /**
     * 
     * @type {Probe}
     * @memberof Probes
     */
    'readiness'?: Probe | null;
}
/**
 * 
 * @export
 * @interface ProbesRules
 */
export interface ProbesRules {
    /**
     * 
     * @type {ProbeRules}
     * @memberof ProbesRules
     */
    'readiness'?: ProbeRules | null;
}
/**
 * 
 * @export
 * @interface Pvc
 */
export interface Pvc {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof Pvc
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof Pvc
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof Pvc
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof Pvc
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof Pvc
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof Pvc
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof Pvc
     */
    'dataSharing'?: boolean | null;
}
/**
 * Requested access mode(s) for the newly created PVC.
 * @export
 * @interface PvcAccessModes
 */
export interface PvcAccessModes {
    /**
     * Requesting claim that can be mounted in read/write mode to exactly one host. This is the default access mode.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readWriteOnce'?: boolean | null;
    /**
     * Requesting claim that can be mounted in read-only mode to many hosts.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readOnlyMany'?: boolean | null;
    /**
     * Requesting claim that can be mounted in read/write mode to many hosts.
     * @type {boolean}
     * @memberof PvcAccessModes
     */
    'readWriteMany'?: boolean | null;
}
/**
 * Rules for access mode(s) for a newly created PVC.
 * @export
 * @interface PvcAccessModesRules
 */
export interface PvcAccessModesRules {
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readWriteOnce'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readOnlyMany'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcAccessModesRules
     */
    'readWriteMany'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface PvcAddedAttrValue
 */
export interface PvcAddedAttrValue {
    /**
     * 
     * @type {string}
     * @memberof PvcAddedAttrValue
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof PvcAddedAttrValue
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface PvcFieldsNonUpdatable
 */
export interface PvcFieldsNonUpdatable {
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof PvcFieldsNonUpdatable
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'ephemeral'?: boolean | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof PvcFieldsNonUpdatable
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof PvcFieldsNonUpdatable
     */
    'dataSharing'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PvcFieldsUpdatable
 */
export interface PvcFieldsUpdatable {
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof PvcFieldsUpdatable
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfoUpdatable}
     * @memberof PvcFieldsUpdatable
     */
    'claimInfo'?: ClaimInfoUpdatable | null;
}
/**
 * 
 * @export
 * @interface PvcInstance
 */
export interface PvcInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof PvcInstance
     */
    'name'?: string | null;
    /**
     * Local path within the workspace to which the PVC bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof PvcInstance
     */
    'path'?: string | null;
    /**
     * 
     * @type {ClaimInfo}
     * @memberof PvcInstance
     */
    'claimInfo'?: ClaimInfo | null;
    /**
     * Verify existing PVC. PVC is assumed to exist when set to `true`. If set to `false`, the PVC will be created, if it does not exist.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'existingPvc'?: boolean | null;
    /**
     * Name for the PVC. Allow referencing it across workloads. If not provided, a name based on the workload name and scope will be auto-generated.
     * @type {string}
     * @memberof PvcInstance
     */
    'claimName'?: string | null;
    /**
     * Permit only read access to PVC.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'readOnly'?: boolean | null;
    /**
     * Use `true` to set PVC to ephemeral. If set to `true`, the PVC will be deleted when the workload is stopped. Not supported for inference workloads.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'ephemeral'?: boolean | null;
    /**
     * use `true` to share the PVC data to all projects under the selected scope.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'dataSharing'?: boolean | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof PvcInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface PvcRules
 */
export interface PvcRules {
    /**
     * 
     * @type {StringRules}
     * @memberof PvcRules
     */
    'claimName'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof PvcRules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof PvcRules
     */
    'readOnly'?: BooleanRules | null;
    /**
     * 
     * @type {ClaimInfoRules}
     * @memberof PvcRules
     */
    'claimInfo'?: ClaimInfoRules | null;
}
/**
 * The volume mode required by the claim. Choose Filesystem (default) or Block.
 * @export
 * @enum {string}
 */

export const PvcVolumeMode = {
    Filesystem: 'Filesystem',
    Block: 'Block'
} as const;

export type PvcVolumeMode = typeof PvcVolumeMode[keyof typeof PvcVolumeMode];


/**
 * 
 * @export
 * @interface PvcsDefaults
 */
export interface PvcsDefaults {
    /**
     * 
     * @type {PvcInstance}
     * @memberof PvcsDefaults
     */
    'attributes'?: PvcInstance | null;
    /**
     * Set of pvc persistent volume claims to use in the workload.
     * @type {Array<PvcInstance>}
     * @memberof PvcsDefaults
     */
    'instances'?: Array<PvcInstance> | null;
}
/**
 * 
 * @export
 * @interface PvcsRules
 */
export interface PvcsRules {
    /**
     * 
     * @type {PvcRules}
     * @memberof PvcsRules
     */
    'attributes'?: PvcRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof PvcsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface QuantityRules
 */
export interface QuantityRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof QuantityRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof QuantityRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof QuantityRules
     */
    'canEdit'?: boolean | null;
    /**
     * The minimum value that the field can be assigned to.
     * @type {string}
     * @memberof QuantityRules
     */
    'min'?: string | null;
    /**
     * The maximum value that the field can be assigned to.
     * @type {string}
     * @memberof QuantityRules
     */
    'max'?: string | null;
    /**
     * 
     * @type {DefaultFromRule}
     * @memberof QuantityRules
     */
    'defaultFrom'?: DefaultFromRule | null;
}
/**
 * 
 * @export
 * @interface QueueResources
 */
export interface QueueResources {
    /**
     * The number of GPUs (allocated/requested/...).
     * @type {number}
     * @memberof QueueResources
     */
    'gpu': number;
    /**
     * CPU in Cores (allocated/requested/...).
     * @type {number}
     * @memberof QueueResources
     */
    'cpu': number;
    /**
     * Memory in Bytes (allocated/requested/...).
     * @type {number}
     * @memberof QueueResources
     */
    'memory': number;
}
/**
 * A URL that is related to the workload. For example, a URL to an external server providing statistics or logging about the workload.
 * @export
 * @interface RelatedUrl
 */
export interface RelatedUrl {
    /**
     * The URL for connecting an external service related to the workload. (mandatory)
     * @type {string}
     * @memberof RelatedUrl
     */
    'url'?: string | null;
    /**
     * The type of service that the url provides. For example, wandb (Weights & Biases). (mandatory)
     * @type {string}
     * @memberof RelatedUrl
     */
    'type'?: string | null;
    /**
     * Unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof RelatedUrl
     */
    'name'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof RelatedUrl
     */
    'exclude'?: boolean | null;
}
/**
 * Rules for the attributes of relatedUrls
 * @export
 * @interface RelatedUrlRules
 */
export interface RelatedUrlRules {
    /**
     * 
     * @type {StringRules}
     * @memberof RelatedUrlRules
     */
    'url'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof RelatedUrlRules
     */
    'type'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof RelatedUrlRules
     */
    'name'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface RelatedUrlsDefaults
 */
export interface RelatedUrlsDefaults {
    /**
     * 
     * @type {RelatedUrl}
     * @memberof RelatedUrlsDefaults
     */
    'attributes'?: RelatedUrl | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof RelatedUrlsDefaults
     */
    'instances'?: Array<RelatedUrl> | null;
}
/**
 * 
 * @export
 * @interface RelatedUrlsRules
 */
export interface RelatedUrlsRules {
    /**
     * 
     * @type {RelatedUrlRules}
     * @memberof RelatedUrlsRules
     */
    'attributes'?: RelatedUrlRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof RelatedUrlsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReplicaType = {
    Master: 'Master',
    Worker: 'Worker'
} as const;

export type ReplicaType = typeof ReplicaType[keyof typeof ReplicaType];


/**
 * value that the agent sent to the afterUpdate query parameter.
 * @export
 * @interface RequestInfo
 */
export interface RequestInfo {
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof RequestInfo
     */
    'afterUpdate': number;
}
/**
 * 
 * @export
 * @interface RequestResourceCores
 */
export interface RequestResourceCores {
    /**
     * 
     * @type {number}
     * @memberof RequestResourceCores
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestResourceCores
     */
    'request'?: number | null;
}
/**
 * 
 * @export
 * @interface RequestResourceQuantity
 */
export interface RequestResourceQuantity {
    /**
     * 
     * @type {string}
     * @memberof RequestResourceQuantity
     */
    'limit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RequestResourceQuantity
     */
    'request'?: string | null;
}
/**
 * 
 * @export
 * @interface RequestedPods
 */
export interface RequestedPods {
    /**
     * 
     * @type {number}
     * @memberof RequestedPods
     */
    'number'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestedPods
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RequestedPods
     */
    'max'?: number | null;
    /**
     * specifies how many Pods can run in parallel
     * @type {number}
     * @memberof RequestedPods
     */
    'parallelism'?: number | null;
    /**
     * specifies how many Pods should terminate successfully before the Workload is completed
     * @type {number}
     * @memberof RequestedPods
     */
    'completions'?: number | null;
}
/**
 * Resource parameters.
 * @export
 * @interface ResourcesFlatFields
 */
export interface ResourcesFlatFields {
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof ResourcesFlatFields
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof ResourcesFlatFields
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof ResourcesFlatFields
     */
    'podAffinity'?: PodAffinity | null;
}
/**
 * Resource related parameters.
 * @export
 * @interface ResourcesFlatFieldsRules
 */
export interface ResourcesFlatFieldsRules {
    /**
     * 
     * @type {StringRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof ResourcesFlatFieldsRules
     */
    'podAffinity'?: PodAffinityRules | null;
}
/**
 * The lowest and highest update counts included in this bulk of updates. for example, it is possible that agent requester for afterUpdate=10 and received a bulk of four updates - 12, 13, 16, 18. in this case lowestUpdate=12, highestUpdate=18.
 * @export
 * @interface ResponseInfo
 */
export interface ResponseInfo {
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof ResponseInfo
     */
    'lowestUpdate'?: number;
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof ResponseInfo
     */
    'highestUpdate'?: number;
}
/**
 * Specify the restart policy of the workload pods. Default is empty, which is determine by the framework default
 * @export
 * @enum {string}
 */

export const RestartPolicy = {
    Always: 'Always',
    Never: 'Never',
    OnFailure: 'OnFailure'
} as const;

export type RestartPolicy = typeof RestartPolicy[keyof typeof RestartPolicy];


/**
 * 
 * @export
 * @interface RestartPolicyOptions
 */
export interface RestartPolicyOptions {
    /**
     * Limit the permitted values for restartPolicy to a given set of values.
     * @type {Array<RestartPolicyOptionsOptionsInner>}
     * @memberof RestartPolicyOptions
     */
    'options'?: Array<RestartPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface RestartPolicyOptionsOptionsInner
 */
export interface RestartPolicyOptionsOptionsInner {
    /**
     * 
     * @type {RestartPolicy}
     * @memberof RestartPolicyOptionsOptionsInner
     */
    'value': RestartPolicy | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof RestartPolicyOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface RestartPolicyRule
 */
export interface RestartPolicyRule {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof RestartPolicyRule
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof RestartPolicyRule
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof RestartPolicyRule
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for restartPolicy to a given set of values.
     * @type {Array<RestartPolicyOptionsOptionsInner>}
     * @memberof RestartPolicyRule
     */
    'options'?: Array<RestartPolicyOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface Revision
 */
export interface Revision {
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'workloadId': string;
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof Revision
     */
    'tenantId': number;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Revision
     */
    'clusterId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof Revision
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof Revision
     */
    'departmentId': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof Revision
     */
    'revisionRequestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof Revision
     */
    'podsRequestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {RequestedPods}
     * @memberof Revision
     */
    'requestedPods'?: RequestedPods;
    /**
     * 
     * @type {Array<string>}
     * @memberof Revision
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {WorkloadAllocatedResources}
     * @memberof Revision
     */
    'allocatedResources'?: WorkloadAllocatedResources | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Revision
     */
    'currentNodePools'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Revision
     */
    'runningPods'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Revision
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Revision
     */
    'environmentVariables'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'command'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'arguments'?: string;
    /**
     * 
     * @type {Array<WorkloadChildrenIdsInner>}
     * @memberof Revision
     */
    'childrenIds'?: Array<WorkloadChildrenIdsInner>;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof Revision
     */
    'conditions'?: Array<Condition>;
    /**
     * 
     * @type {Phase}
     * @memberof Revision
     */
    'phase': Phase;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    'phaseUpdatedAt'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Revision
     */
    'additionalFields'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface RevisionSyncFields
 */
export interface RevisionSyncFields {
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'workloadId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'departmentId': string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'createdAt': string;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof RevisionSyncFields
     */
    'requestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {RequestedPods}
     * @memberof RevisionSyncFields
     */
    'requestedPods'?: RequestedPods;
    /**
     * 
     * @type {Array<string>}
     * @memberof RevisionSyncFields
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RevisionSyncFields
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RevisionSyncFields
     */
    'environmentVariables'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'command'?: string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'arguments'?: string;
    /**
     * 
     * @type {Array<WorkloadChildrenIdsInner>}
     * @memberof RevisionSyncFields
     */
    'childrenIds'?: Array<WorkloadChildrenIdsInner>;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof RevisionSyncFields
     */
    'conditions'?: Array<Condition>;
    /**
     * 
     * @type {Phase}
     * @memberof RevisionSyncFields
     */
    'phase': Phase;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'phaseUpdatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RevisionSyncFields
     */
    'additionalFields'?: string;
}
/**
 * 
 * @export
 * @interface RevisionsSyncRequest
 */
export interface RevisionsSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof RevisionsSyncRequest
     */
    'projectId': string;
    /**
     * 
     * @type {Array<RevisionSyncFields>}
     * @memberof RevisionsSyncRequest
     */
    'revisions': Array<RevisionSyncFields>;
    /**
     * the first revision id to sync. if empty, all revisions before the first one sent will be deleted.
     * @type {string}
     * @memberof RevisionsSyncRequest
     */
    'from'?: string;
    /**
     * the last revision to sync. if empty, all revisions after the last one sent will be deleted.
     * @type {string}
     * @memberof RevisionsSyncRequest
     */
    'to'?: string;
    /**
     * revision ids to ignore when deleting.
     * @type {Array<string>}
     * @memberof RevisionsSyncRequest
     */
    'idsToIgnore'?: Array<string>;
}
/**
 * whether the template can be submitted, as is
 * @export
 * @interface RunnableInfo
 */
export interface RunnableInfo {
    /**
     * indication if the template is runnable, as is
     * @type {boolean}
     * @memberof RunnableInfo
     */
    'isRunnable'?: boolean;
    /**
     * if the template is non runnable, specify a reason
     * @type {string}
     * @memberof RunnableInfo
     */
    'issue'?: string | null;
}
/**
 * 
 * @export
 * @interface S3AccessKey
 */
export interface S3AccessKey {
    /**
     * Name of the secret containing credentials of the S3 bucket. Used for private S3 buckets.
     * @type {string}
     * @memberof S3AccessKey
     */
    'accessKeySecret'?: string | null;
    /**
     * The key to use for loading the access key id from the secret. The default is `AccessKeyId`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3AccessKey
     */
    'secretKeyOfAccessKeyId'?: string | null;
    /**
     * The key to use for loading the secret key from the secret. The default is `SecretKey`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3AccessKey
     */
    'secretKeyOfSecretKey'?: string | null;
}
/**
 * 
 * @export
 * @interface S3Common
 */
export interface S3Common {
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof S3Common
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof S3Common
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof S3Common
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface S3Instance
 */
export interface S3Instance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof S3Instance
     */
    'name'?: string | null;
    /**
     * The name of the bucket. (mandatory)
     * @type {string}
     * @memberof S3Instance
     */
    'bucket'?: string | null;
    /**
     * Local path within the workspace to which the S3 bucket will be mapped. (mandatory)
     * @type {string}
     * @memberof S3Instance
     */
    'path'?: string | null;
    /**
     * The url of the S3 service provider. The default is the URL of the Amazon AWS S3 service.
     * @type {string}
     * @memberof S3Instance
     */
    'url'?: string | null;
    /**
     * Name of the secret containing credentials of the S3 bucket. Used for private S3 buckets.
     * @type {string}
     * @memberof S3Instance
     */
    'accessKeySecret'?: string | null;
    /**
     * The key to use for loading the access key id from the secret. The default is `AccessKeyId`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3Instance
     */
    'secretKeyOfAccessKeyId'?: string | null;
    /**
     * The key to use for loading the secret key from the secret. The default is `SecretKey`. For more information, see [Credentials access keys](https://docs.aws.amazon.com/IAM/latest/UserGuide/id_credentials_access-keys.html).
     * @type {string}
     * @memberof S3Instance
     */
    'secretKeyOfSecretKey'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof S3Instance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface S3Rules
 */
export interface S3Rules {
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'bucket'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'path'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof S3Rules
     */
    'url'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface S3sDefaults
 */
export interface S3sDefaults {
    /**
     * 
     * @type {S3Instance}
     * @memberof S3sDefaults
     */
    'attributes'?: S3Instance | null;
    /**
     * Set of s3 buckets to use in the workload.
     * @type {Array<S3Instance>}
     * @memberof S3sDefaults
     */
    'instances'?: Array<S3Instance> | null;
}
/**
 * 
 * @export
 * @interface S3sRules
 */
export interface S3sRules {
    /**
     * 
     * @type {S3Rules}
     * @memberof S3sRules
     */
    'attributes'?: S3Rules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof S3sRules
     */
    'instances'?: ItemRules | null;
}
/**
 * The scheduling condition synced from the podgroup status by the cluster-sync.
 * @export
 * @interface SchedulingCondition
 */
export interface SchedulingCondition {
    /**
     * 
     * @type {string}
     * @memberof SchedulingCondition
     */
    'nodePool': string;
    /**
     * 
     * @type {PhaseReason}
     * @memberof SchedulingCondition
     */
    'reason': PhaseReason;
    /**
     * 
     * @type {SchedulingConditionQueueDetails}
     * @memberof SchedulingCondition
     */
    'queueDetails'?: SchedulingConditionQueueDetails | null;
}
/**
 * 
 * @export
 * @interface SchedulingConditionQueueDetails
 */
export interface SchedulingConditionQueueDetails {
    /**
     * 
     * @type {OrgType}
     * @memberof SchedulingConditionQueueDetails
     */
    'orgType': OrgType;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'exceedingResources'?: QueueResources;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'queueRequestedResources'?: QueueResources;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'queueDeservedResources'?: QueueResources;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'queueAllocatedResources'?: QueueResources;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'queueAllocatedNonPreemptibleResources'?: QueueResources;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'queueResourceLimits'?: QueueResources;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'podGroupRequestedResources'?: QueueResources;
    /**
     * 
     * @type {QueueResources}
     * @memberof SchedulingConditionQueueDetails
     */
    'podGroupRequestedNonPreemptibleResources'?: QueueResources;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ScopeType = {
    System: 'system',
    Tenant: 'tenant',
    Cluster: 'cluster',
    Department: 'department',
    Project: 'project'
} as const;

export type ScopeType = typeof ScopeType[keyof typeof ScopeType];


/**
 * Indicates which kind of seccomp profile will be applied to the container. The options are a. `RuntimeDefault` - the container runtime default profile should be used. b. `Unconfined` - no profile should be applied. c. `Localhost` is not yet supported by Run:ai.
 * @export
 * @enum {string}
 */

export const SeccompProfileType = {
    RuntimeDefault: 'RuntimeDefault',
    Unconfined: 'Unconfined',
    Localhost: 'Localhost'
} as const;

export type SeccompProfileType = typeof SeccompProfileType[keyof typeof SeccompProfileType];


/**
 * 
 * @export
 * @interface SeccompProfileTypeOptions
 */
export interface SeccompProfileTypeOptions {
    /**
     * Limit the permitted values for secompProfileType to a given set of values.
     * @type {Array<SeccompProfileTypeOptionsOptionsInner>}
     * @memberof SeccompProfileTypeOptions
     */
    'options'?: Array<SeccompProfileTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface SeccompProfileTypeOptionsOptionsInner
 */
export interface SeccompProfileTypeOptionsOptionsInner {
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof SeccompProfileTypeOptionsOptionsInner
     */
    'value': SeccompProfileType | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof SeccompProfileTypeOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface SeccompProfileTypeRules
 */
export interface SeccompProfileTypeRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof SeccompProfileTypeRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof SeccompProfileTypeRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof SeccompProfileTypeRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for secompProfileType to a given set of values.
     * @type {Array<SeccompProfileTypeOptionsOptionsInner>}
     * @memberof SeccompProfileTypeRules
     */
    'options'?: Array<SeccompProfileTypeOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface Secret
 */
export interface Secret {
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof Secret
     */
    'mountPath'?: string | null;
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof Secret
     */
    'secret'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretFieldsNonUpdatable
 */
export interface SecretFieldsNonUpdatable {
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof SecretFieldsNonUpdatable
     */
    'secret'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretFieldsUpdatable
 */
export interface SecretFieldsUpdatable {
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof SecretFieldsUpdatable
     */
    'mountPath'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretInstance
 */
export interface SecretInstance {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof SecretInstance
     */
    'name'?: string | null;
    /**
     * Local path within the workspace to which the Secret will be mapped to. (mandatory)
     * @type {string}
     * @memberof SecretInstance
     */
    'mountPath'?: string | null;
    /**
     * The name of the Secret resource. (mandatory)
     * @type {string}
     * @memberof SecretInstance
     */
    'secret'?: string | null;
    /**
     * Use \'true\' in case the item is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof SecretInstance
     */
    'exclude'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SecretRules
 */
export interface SecretRules {
    /**
     * 
     * @type {StringRules}
     * @memberof SecretRules
     */
    'secret'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SecretRules
     */
    'mountPath'?: StringRules | null;
}
/**
 * 
 * @export
 * @interface SecretsDefaults
 */
export interface SecretsDefaults {
    /**
     * 
     * @type {SecretInstance}
     * @memberof SecretsDefaults
     */
    'attributes'?: SecretInstance | null;
    /**
     * Set of secret volumes to use in the workload
     * @type {Array<SecretInstance>}
     * @memberof SecretsDefaults
     */
    'instances'?: Array<SecretInstance> | null;
}
/**
 * 
 * @export
 * @interface SecretsRules
 */
export interface SecretsRules {
    /**
     * 
     * @type {SecretRules}
     * @memberof SecretsRules
     */
    'attributes'?: SecretRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof SecretsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface Security
 */
export interface Security {
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof Security
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface SecurityFlatFields
 */
export interface SecurityFlatFields {
    /**
     * 
     * @type {UidGidSource}
     * @memberof SecurityFlatFields
     */
    'uidGidSource'?: UidGidSource | null;
    /**
     * Add POSIX capabilities to running containers. Defaults to the default set of capabilities granted by the container runtime.
     * @type {Array<Capability>}
     * @memberof SecurityFlatFields
     */
    'capabilities'?: Array<Capability> | null;
    /**
     * 
     * @type {SeccompProfileType}
     * @memberof SecurityFlatFields
     */
    'seccompProfileType'?: SeccompProfileType | null;
    /**
     * Force the container to run as a non-root user.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'runAsNonRoot'?: boolean | null;
    /**
     * If true, mounts the container\'s root filesystem as read-only.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'readOnlyRootFilesystem'?: boolean | null;
    /**
     * The user id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsUid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SecurityFlatFields
     */
    'runAsUid'?: number | null;
    /**
     * The group id to run the entrypoint of the container which executes the workspace. Default to the value specified in the environment asset `runAsGid` field (optional). Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled.
     * @type {number}
     * @memberof SecurityFlatFields
     */
    'runAsGid'?: number | null;
    /**
     * Comma separated list of groups that the user running the container belongs to, in addition to the group indicated by runAsGid. Use only when the source uid/gid of the environment asset is not `fromTheImage`, and `overrideUidGidInWorkspace` is enabled. Using an empty string implies reverting the supplementary groups of the image.
     * @type {string}
     * @memberof SecurityFlatFields
     */
    'supplementalGroups'?: string | null;
    /**
     * Allow the container running the workload and all launched processes to gain additional privileges after the workload starts. For more information consult the User Identity in Container guide at https://docs.run.ai/admin/runai-setup/config/non-root-containers/
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'allowPrivilegeEscalation'?: boolean | null;
    /**
     * Whether to enable host IPC. Defaults to false.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'hostIpc'?: boolean | null;
    /**
     * Whether to enable host networking. Default to false.
     * @type {boolean}
     * @memberof SecurityFlatFields
     */
    'hostNetwork'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SecurityFlatFieldsRules
 */
export interface SecurityFlatFieldsRules {
    /**
     * 
     * @type {UidGidSourceRules}
     * @memberof SecurityFlatFieldsRules
     */
    'uidGidSource'?: UidGidSourceRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof SecurityFlatFieldsRules
     */
    'capabilities'?: ArrayRules | null;
    /**
     * 
     * @type {SeccompProfileTypeRules}
     * @memberof SecurityFlatFieldsRules
     */
    'seccompProfileType'?: SeccompProfileTypeRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'runAsNonRoot'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'readOnlyRootFilesystem'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SecurityFlatFieldsRules
     */
    'runAsUid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {IntegerRulesOptional}
     * @memberof SecurityFlatFieldsRules
     */
    'runAsGid'?: IntegerRulesOptional | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SecurityFlatFieldsRules
     */
    'supplementalGroups'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'allowPrivilegeEscalation'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'hostIpc'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SecurityFlatFieldsRules
     */
    'hostNetwork'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface SecurityRules
 */
export interface SecurityRules {
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof SecurityRules
     */
    'security'?: SecurityFlatFieldsRules | null;
}
/**
 * A port for accessing the inference service
 * @export
 * @interface ServingPort
 */
export interface ServingPort {
    /**
     * The port that the container running the inference service exposes (mandatory).
     * @type {number}
     * @memberof ServingPort
     */
    'container'?: number | null;
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPort
     */
    'protocol'?: ServingPortProtocol | null;
    /**
     * 
     * @type {ServingPortAccessAuthorizationTypeEnum}
     * @memberof ServingPort
     */
    'authorizationType'?: ServingPortAccessAuthorizationTypeEnum | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPort
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPort
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * Configure the serving port URL to be available only on the cluster-local network, and not externally. Defaults to false
     * @type {boolean}
     * @memberof ServingPort
     */
    'clusterLocalAccessOnly'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ServingPortAccess
 */
export interface ServingPortAccess {
    /**
     * 
     * @type {ServingPortAccessAuthorizationTypeEnum}
     * @memberof ServingPortAccess
     */
    'authorizationType'?: ServingPortAccessAuthorizationTypeEnum | null;
    /**
     * List of users that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPortAccess
     */
    'authorizedUsers'?: Array<string> | null;
    /**
     * List of groups that are allowed to access the URL. Note that authorizedUsers and authorizedGroups are mutually exclusive.
     * @type {Array<string>}
     * @memberof ServingPortAccess
     */
    'authorizedGroups'?: Array<string> | null;
    /**
     * Configure the serving port URL to be available only on the cluster-local network, and not externally. Defaults to false
     * @type {boolean}
     * @memberof ServingPortAccess
     */
    'clusterLocalAccessOnly'?: boolean | null;
}
/**
 * The authorization type for serving port URL access. Defaults to public, which means no authorization is required. If set to authenticatedUsers, only authenticated Run:ai users are allowed to access the URL. If set to authorizedUsersOrGroups, only users or groups specified in authorizedUsers or authorizedGroups are allowed to access the URL.
 * @export
 * @enum {string}
 */

export const ServingPortAccessAuthorizationTypeEnum = {
    Public: 'public',
    AuthenticatedUsers: 'authenticatedUsers',
    AuthorizedUsersOrGroups: 'authorizedUsersOrGroups'
} as const;

export type ServingPortAccessAuthorizationTypeEnum = typeof ServingPortAccessAuthorizationTypeEnum[keyof typeof ServingPortAccessAuthorizationTypeEnum];


/**
 * 
 * @export
 * @interface ServingPortContainerAndProtocol
 */
export interface ServingPortContainerAndProtocol {
    /**
     * The port that the container running the inference service exposes (mandatory).
     * @type {number}
     * @memberof ServingPortContainerAndProtocol
     */
    'container'?: number | null;
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPortContainerAndProtocol
     */
    'protocol'?: ServingPortProtocol | null;
}
/**
 * The protocol used by the port, defaults to http
 * @export
 * @enum {string}
 */

export const ServingPortProtocol = {
    Http: 'http',
    Grpc: 'grpc'
} as const;

export type ServingPortProtocol = typeof ServingPortProtocol[keyof typeof ServingPortProtocol];


/**
 * 
 * @export
 * @interface ServingPortProtocolOptions
 */
export interface ServingPortProtocolOptions {
    /**
     * 
     * @type {Array<ServingPortProtocolOptionsOptionsInner>}
     * @memberof ServingPortProtocolOptions
     */
    'options'?: Array<ServingPortProtocolOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ServingPortProtocolOptionsOptionsInner
 */
export interface ServingPortProtocolOptionsOptionsInner {
    /**
     * 
     * @type {ServingPortProtocol}
     * @memberof ServingPortProtocolOptionsOptionsInner
     */
    'value': ServingPortProtocol | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof ServingPortProtocolOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface ServingPortProtocolRules
 */
export interface ServingPortProtocolRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof ServingPortProtocolRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof ServingPortProtocolRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof ServingPortProtocolRules
     */
    'canEdit'?: boolean | null;
    /**
     * 
     * @type {Array<ServingPortProtocolOptionsOptionsInner>}
     * @memberof ServingPortProtocolRules
     */
    'options'?: Array<ServingPortProtocolOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface ServingPortRules
 */
export interface ServingPortRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof ServingPortRules
     */
    'container'?: IntegerRules | null;
    /**
     * 
     * @type {ServingPortProtocolRules}
     * @memberof ServingPortRules
     */
    'protocol'?: ServingPortProtocolRules | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Source = {
    Cli: 'CLI',
    ControlPlane: 'Control-plane',
    Other: 'Other'
} as const;

export type Source = typeof Source[keyof typeof Source];


/**
 * This field is used by the system along with effective rules, in order to specify the org unit from which this effective rule has been derived. It should be left empty when sending apply policy requests.
 * @export
 * @interface SourceOfRule
 */
export interface SourceOfRule {
    /**
     * 
     * @type {ScopeType}
     * @memberof SourceOfRule
     */
    'scope': ScopeType;
    /**
     * The id of the project.
     * @type {number}
     * @memberof SourceOfRule
     */
    'projectId'?: number | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof SourceOfRule
     */
    'departmentId'?: string | null;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof SourceOfRule
     */
    'clusterId'?: string | null;
    /**
     * source of this rule is the fallback policy
     * @type {boolean}
     * @memberof SourceOfRule
     */
    'isFallback'?: boolean;
}
/**
 * 
 * @export
 * @interface Storage
 */
export interface Storage {
    /**
     * 
     * @type {StorageFields}
     * @memberof Storage
     */
    'storage'?: StorageFields | null;
}
/**
 * 
 * @export
 * @interface StorageDefaults
 */
export interface StorageDefaults {
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof StorageDefaults
     */
    'storage'?: StorageFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface StorageFields
 */
export interface StorageFields {
    /**
     * Set of data volumes to use in the workload.
     * @type {Array<DataVolumeInstance>}
     * @memberof StorageFields
     */
    'dataVolume'?: Array<DataVolumeInstance> | null;
    /**
     * Set of pvc persistent volume claims to use in the workload.
     * @type {Array<PvcInstance>}
     * @memberof StorageFields
     */
    'pvc'?: Array<PvcInstance> | null;
    /**
     * Set of host paths to use in the workload.
     * @type {Array<HostPathInstance>}
     * @memberof StorageFields
     */
    'hostPath'?: Array<HostPathInstance> | null;
    /**
     * Set of nfs volumes to use in the workload.
     * @type {Array<NfsInstance>}
     * @memberof StorageFields
     */
    'nfs'?: Array<NfsInstance> | null;
    /**
     * Set of git repositories to use in the workload.
     * @type {Array<GitInstance>}
     * @memberof StorageFields
     */
    'git'?: Array<GitInstance> | null;
    /**
     * Set of config map volumes to use in the workload
     * @type {Array<ConfigMapInstance>}
     * @memberof StorageFields
     */
    'configMapVolume'?: Array<ConfigMapInstance> | null;
    /**
     * Set of secret volumes to use in the workload
     * @type {Array<SecretInstance>}
     * @memberof StorageFields
     */
    'secretVolume'?: Array<SecretInstance> | null;
    /**
     * Set of s3 buckets to use in the workload.
     * @type {Array<S3Instance>}
     * @memberof StorageFields
     */
    's3'?: Array<S3Instance> | null;
}
/**
 * 
 * @export
 * @interface StorageFieldsDefaults
 */
export interface StorageFieldsDefaults {
    /**
     * 
     * @type {DataVolumesDefaults}
     * @memberof StorageFieldsDefaults
     */
    'dataVolume'?: DataVolumesDefaults | null;
    /**
     * 
     * @type {PvcsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'pvc'?: PvcsDefaults | null;
    /**
     * 
     * @type {HostPathsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'hostPath'?: HostPathsDefaults | null;
    /**
     * 
     * @type {NfssDefaults}
     * @memberof StorageFieldsDefaults
     */
    'nfs'?: NfssDefaults | null;
    /**
     * 
     * @type {GitsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'git'?: GitsDefaults | null;
    /**
     * 
     * @type {ConfigMapsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'configMapVolume'?: ConfigMapsDefaults | null;
    /**
     * 
     * @type {SecretsDefaults}
     * @memberof StorageFieldsDefaults
     */
    'secretVolume'?: SecretsDefaults | null;
    /**
     * 
     * @type {S3sDefaults}
     * @memberof StorageFieldsDefaults
     */
    's3'?: S3sDefaults | null;
}
/**
 * 
 * @export
 * @interface StorageFieldsRules
 */
export interface StorageFieldsRules {
    /**
     * 
     * @type {DataVolumesRules}
     * @memberof StorageFieldsRules
     */
    'dataVolume'?: DataVolumesRules | null;
    /**
     * 
     * @type {PvcsRules}
     * @memberof StorageFieldsRules
     */
    'pvc'?: PvcsRules | null;
    /**
     * 
     * @type {HostPathsRules}
     * @memberof StorageFieldsRules
     */
    'hostPath'?: HostPathsRules | null;
    /**
     * 
     * @type {NfssRules}
     * @memberof StorageFieldsRules
     */
    'nfs'?: NfssRules | null;
    /**
     * 
     * @type {GitsRules}
     * @memberof StorageFieldsRules
     */
    'git'?: GitsRules | null;
    /**
     * 
     * @type {ConfigMapsRules}
     * @memberof StorageFieldsRules
     */
    'configMapVolume'?: ConfigMapsRules | null;
    /**
     * 
     * @type {SecretsRules}
     * @memberof StorageFieldsRules
     */
    'secretVolume'?: SecretsRules | null;
    /**
     * 
     * @type {S3sRules}
     * @memberof StorageFieldsRules
     */
    's3'?: S3sRules | null;
}
/**
 * 
 * @export
 * @interface StorageInstanceName
 */
export interface StorageInstanceName {
    /**
     * unique name to identify the instance. primarily used for policy locked rules.
     * @type {string}
     * @memberof StorageInstanceName
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface StorageRules
 */
export interface StorageRules {
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof StorageRules
     */
    'storage'?: StorageFieldsRules | null;
}
/**
 * One of the values that the field can be assigned to, when options police is applied on the field.
 * @export
 * @interface StringOption
 */
export interface StringOption {
    /**
     * The value that the field should hold
     * @type {string}
     * @memberof StringOption
     */
    'value': string;
    /**
     * Textual description of the value. to be used by user interface applications.
     * @type {string}
     * @memberof StringOption
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface StringRules
 */
export interface StringRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof StringRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof StringRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof StringRules
     */
    'canEdit'?: boolean | null;
    /**
     * Set of options that the value of the field must be chosen from.
     * @type {Array<StringOption>}
     * @memberof StringRules
     */
    'options'?: Array<StringOption> | null;
}
/**
 * 
 * @export
 * @interface StringRulesCommon
 */
export interface StringRulesCommon {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof StringRulesCommon
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof StringRulesCommon
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof StringRulesCommon
     */
    'canEdit'?: boolean | null;
}
/**
 * 
 * @export
 * @interface StringRulesOptions
 */
export interface StringRulesOptions {
    /**
     * Set of options that the value of the field must be chosen from.
     * @type {Array<StringOption>}
     * @memberof StringRulesOptions
     */
    'options'?: Array<StringOption> | null;
}
/**
 * 
 * @export
 * @interface SubmissionError
 */
export interface SubmissionError {
    /**
     * 
     * @type {number}
     * @memberof SubmissionError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionError
     */
    'details'?: string;
    /**
     * 
     * @type {Array<ComplianceIssuesComplianceIssuesInner>}
     * @memberof SubmissionError
     */
    'complianceIssues'?: Array<ComplianceIssuesComplianceIssuesInner>;
}
/**
 * 
 * @export
 * @interface SupersetDefaults
 */
export interface SupersetDefaults {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof SupersetDefaults
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof SupersetDefaults
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof SupersetDefaults
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof SupersetDefaults
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof SupersetDefaults
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof SupersetDefaults
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'stdin'?: boolean | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof SupersetDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof SupersetDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof SupersetDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof SupersetDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof SupersetDefaults
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof SupersetDefaults
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof SupersetDefaults
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof SupersetDefaults
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof SupersetDefaults
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof SupersetDefaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof SupersetDefaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof SupersetDefaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof SupersetDefaults
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof SupersetDefaults
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof SupersetDefaults
     */
    'parallelism'?: number | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof SupersetDefaults
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof SupersetDefaults
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof SupersetDefaults
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof SupersetDefaults
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetDefaults
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetDefaults
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof SupersetDefaults
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof SupersetDefaults
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof SupersetDefaults
     */
    'autoscaling'?: AutoScaling | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof SupersetDefaults
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof SupersetDefaults
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof SupersetDefaults
     */
    'storage'?: StorageFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface SupersetRules
 */
export interface SupersetRules {
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof SupersetRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof SupersetRules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof SupersetRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof SupersetRules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'stdin'?: BooleanRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SupersetRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SupersetRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof SupersetRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof SupersetRules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof SupersetRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof SupersetRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof SupersetRules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof SupersetRules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof SupersetRules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof SupersetRules
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'numWorkers'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedFrameworkRules}
     * @memberof SupersetRules
     */
    'distributedFramework'?: DistributedFrameworkRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'slotsPerWorker'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof SupersetRules
     */
    'sshAuthMountPath'?: StringRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof SupersetRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedCleanPodPolicyRules}
     * @memberof SupersetRules
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicyRules | null;
    /**
     * 
     * @type {ServingPortRules}
     * @memberof SupersetRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof SupersetRules
     */
    'autoscaling'?: AutoScalingRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof SupersetRules
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof SupersetRules
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof SupersetRules
     */
    'storage'?: StorageFieldsRules | null;
}
/**
 * 
 * @export
 * @interface SupersetSpec
 */
export interface SupersetSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof SupersetSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof SupersetSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof SupersetSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof SupersetSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof SupersetSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof SupersetSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof SupersetSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof SupersetSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof SupersetSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof SupersetSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof SupersetSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof SupersetSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof SupersetSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof SupersetSpec
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof SupersetSpec
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof SupersetSpec
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof SupersetSpec
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof SupersetSpec
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof SupersetSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof SupersetSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof SupersetSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof SupersetSpec
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof SupersetSpec
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof SupersetSpec
     */
    'parallelism'?: number | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof SupersetSpec
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof SupersetSpec
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof SupersetSpec
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof SupersetSpec
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetSpec
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof SupersetSpec
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof SupersetSpec
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof SupersetSpec
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof SupersetSpec
     */
    'autoscaling'?: AutoScaling | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof SupersetSpec
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof SupersetSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof SupersetSpec
     */
    'storage'?: StorageFields | null;
}
/**
 * 
 * @export
 * @interface SupersetTemplate
 */
export interface SupersetTemplate {
    /**
     * 
     * @type {TemplateMetaFields}
     * @memberof SupersetTemplate
     */
    'meta': TemplateMetaFields;
    /**
     * 
     * @type {RunnableInfo}
     * @memberof SupersetTemplate
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {SupersetSpec}
     * @memberof SupersetTemplate
     */
    'spec'?: SupersetSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof SupersetTemplate
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof SupersetTemplate
     */
    'master'?: TemplateMasterSection | null;
    /**
     * 
     * @type {SupersetSpec}
     * @memberof SupersetTemplate
     */
    'combinedSpec'?: SupersetSpec;
    /**
     * 
     * @type {MasterSpec}
     * @memberof SupersetTemplate
     */
    'combinedMasterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface SupersetTemplateAllOf
 */
export interface SupersetTemplateAllOf {
    /**
     * 
     * @type {RunnableInfo}
     * @memberof SupersetTemplateAllOf
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {SupersetSpec}
     * @memberof SupersetTemplateAllOf
     */
    'spec'?: SupersetSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof SupersetTemplateAllOf
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {TemplateMasterSection}
     * @memberof SupersetTemplateAllOf
     */
    'master'?: TemplateMasterSection | null;
    /**
     * 
     * @type {SupersetSpec}
     * @memberof SupersetTemplateAllOf
     */
    'combinedSpec'?: SupersetSpec;
    /**
     * 
     * @type {MasterSpec}
     * @memberof SupersetTemplateAllOf
     */
    'combinedMasterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface SupersetWorkload
 */
export interface SupersetWorkload {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'name': string;
    /**
     * The name as was requested for the workload. If useGivenNameAsPrefix, in the creation request, is false, name and requestedName should be identical. Otherwise, name should be composed of requestedName followed by a suffix of random characters.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'requestedName': string;
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'workloadId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'clusterId': string;
    /**
     * The user who created the workload
     * @type {string}
     * @memberof SupersetWorkload
     */
    'createdBy': string;
    /**
     * The creation time of the workload.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'createdAt': string;
    /**
     * The deletion time of the workload.
     * @type {string}
     * @memberof SupersetWorkload
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadDesiredPhase}
     * @memberof SupersetWorkload
     */
    'desiredPhase': WorkloadDesiredPhase;
    /**
     * 
     * @type {Phase}
     * @memberof SupersetWorkload
     */
    'actualPhase'?: Phase;
    /**
     * 
     * @type {SupersetSpec}
     * @memberof SupersetWorkload
     */
    'spec'?: SupersetSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof SupersetWorkload
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {MasterSpec}
     * @memberof SupersetWorkload
     */
    'masterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface SupersetWorkloadAllOf
 */
export interface SupersetWorkloadAllOf {
    /**
     * 
     * @type {SupersetSpec}
     * @memberof SupersetWorkloadAllOf
     */
    'spec'?: SupersetSpec;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof SupersetWorkloadAllOf
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {MasterSpec}
     * @memberof SupersetWorkloadAllOf
     */
    'masterSpec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface SyncPodGroups207Response
 */
export interface SyncPodGroups207Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncPodGroups207Response
     */
    'successfullySyncedPodGroups': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncPodGroups207Response
     */
    'failedPodGroups': Array<string>;
}
/**
 * 
 * @export
 * @interface SyncRevisions207Response
 */
export interface SyncRevisions207Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncRevisions207Response
     */
    'successfullySyncedRevisions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncRevisions207Response
     */
    'failedRevisions': Array<string>;
}
/**
 * the highest update count that was assigned to the data being synchronized. for example, it is possible that the agent sent afterUpdate=12 and received a bulk containing only four updates (13, 15, 18, 19) but in the system there is already update 21 which was not included in this bulk and can be received in the following bulk.
 * @export
 * @interface SystemInfo
 */
export interface SystemInfo {
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof SystemInfo
     */
    'highestUpdate'?: number;
}
/**
 * 
 * @export
 * @interface TelemetryResponse
 */
export interface TelemetryResponse {
    /**
     * specifies what data returned
     * @type {string}
     * @memberof TelemetryResponse
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryResponse
     */
    'timestamp': string;
    /**
     * 
     * @type {Array<TelemetryResponseValuesInner>}
     * @memberof TelemetryResponse
     */
    'values': Array<TelemetryResponseValuesInner>;
}
/**
 * 
 * @export
 * @interface TelemetryResponseValuesInner
 */
export interface TelemetryResponseValuesInner {
    /**
     * 
     * @type {string}
     * @memberof TelemetryResponseValuesInner
     */
    'value': string;
    /**
     * columns the data is grouped by
     * @type {Array<TelemetryResponseValuesInnerGroupsInner>}
     * @memberof TelemetryResponseValuesInner
     */
    'groups'?: Array<TelemetryResponseValuesInnerGroupsInner>;
}
/**
 * 
 * @export
 * @interface TelemetryResponseValuesInnerGroupsInner
 */
export interface TelemetryResponseValuesInnerGroupsInner {
    /**
     * 
     * @type {string}
     * @memberof TelemetryResponseValuesInnerGroupsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryResponseValuesInnerGroupsInner
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof TelemetryResponseValuesInnerGroupsInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface TemplateCreationMeta
 */
export interface TemplateCreationMeta {
    /**
     * 
     * @type {TemplateCreationMetaFields}
     * @memberof TemplateCreationMeta
     */
    'meta': TemplateCreationMetaFields;
}
/**
 * 
 * @export
 * @interface TemplateCreationMetaFields
 */
export interface TemplateCreationMetaFields {
    /**
     * The name of the template.
     * @type {string}
     * @memberof TemplateCreationMetaFields
     */
    'name': string;
    /**
     * A description of the template.
     * @type {string}
     * @memberof TemplateCreationMetaFields
     */
    'description'?: string | null;
    /**
     * 
     * @type {ScopeType}
     * @memberof TemplateCreationMetaFields
     */
    'scopeType': ScopeType;
    /**
     * The id of the cluster, department or project, depending on the scope type.
     * @type {string}
     * @memberof TemplateCreationMetaFields
     */
    'scopeId'?: string | null;
}
/**
 * 
 * @export
 * @interface TemplateListInfo
 */
export interface TemplateListInfo {
    /**
     * 
     * @type {TemplateMetaFields}
     * @memberof TemplateListInfo
     */
    'meta': TemplateMetaFields;
    /**
     * 
     * @type {RunnableInfo}
     * @memberof TemplateListInfo
     */
    'runnable'?: RunnableInfo;
}
/**
 * 
 * @export
 * @interface TemplateListInfoAllOf
 */
export interface TemplateListInfoAllOf {
    /**
     * 
     * @type {RunnableInfo}
     * @memberof TemplateListInfoAllOf
     */
    'runnable'?: RunnableInfo;
}
/**
 * 
 * @export
 * @interface TemplateMasterSection
 */
export interface TemplateMasterSection {
    /**
     * 
     * @type {MasterSpec}
     * @memberof TemplateMasterSection
     */
    'spec'?: MasterSpec | null;
}
/**
 * 
 * @export
 * @interface TemplateMeta
 */
export interface TemplateMeta {
    /**
     * 
     * @type {TemplateMetaFields}
     * @memberof TemplateMeta
     */
    'meta': TemplateMetaFields;
}
/**
 * 
 * @export
 * @interface TemplateMetaFields
 */
export interface TemplateMetaFields {
    /**
     * A unique ID of the template.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'id': string;
    /**
     * The name of the template.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'name': string;
    /**
     * A description of the template.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'description'?: string | null;
    /**
     * 
     * @type {WorkloadType}
     * @memberof TemplateMetaFields
     */
    'workloadType': WorkloadType;
    /**
     * 
     * @type {ScopeType}
     * @memberof TemplateMetaFields
     */
    'scopeType': ScopeType;
    /**
     * The id of the cluster, department or project, depending on the scope type.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'scopeId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'clusterId'?: string | null;
    /**
     * The id of the department.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'departmentId'?: string | null;
    /**
     * The id of the project.
     * @type {number}
     * @memberof TemplateMetaFields
     */
    'projectId'?: number | null;
    /**
     * The user who created the template
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'createdBy': string;
    /**
     * The creation time of the template.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'createdAt': string;
    /**
     * The user who recently updated the template
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'updatedBy'?: string | null;
    /**
     * The time of the recent update.
     * @type {string}
     * @memberof TemplateMetaFields
     */
    'updatedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface TemplatePatchMeta
 */
export interface TemplatePatchMeta {
    /**
     * 
     * @type {TemplatePatchMetaFields}
     * @memberof TemplatePatchMeta
     */
    'meta'?: TemplatePatchMetaFields | null;
}
/**
 * 
 * @export
 * @interface TemplatePatchMetaFields
 */
export interface TemplatePatchMetaFields {
    /**
     * The name of the template.
     * @type {string}
     * @memberof TemplatePatchMetaFields
     */
    'name': string | null;
    /**
     * A description of the template.
     * @type {string}
     * @memberof TemplatePatchMetaFields
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface TemplateUpdateMeta
 */
export interface TemplateUpdateMeta {
    /**
     * 
     * @type {TemplateUpdateMetaFields}
     * @memberof TemplateUpdateMeta
     */
    'meta': TemplateUpdateMetaFields;
}
/**
 * 
 * @export
 * @interface TemplateUpdateMetaFields
 */
export interface TemplateUpdateMetaFields {
    /**
     * The name of the template.
     * @type {string}
     * @memberof TemplateUpdateMetaFields
     */
    'name': string;
    /**
     * A description of the template.
     * @type {string}
     * @memberof TemplateUpdateMetaFields
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface TemplatesListResponse
 */
export interface TemplatesListResponse {
    /**
     * 
     * @type {Array<TemplateListInfo>}
     * @memberof TemplatesListResponse
     */
    'entries'?: Array<TemplateListInfo>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof TemplatesListResponse
     */
    'pagination'?: PaginationInfo;
}
/**
 * Toleration details.
 * @export
 * @interface Toleration
 */
export interface Toleration {
    /**
     * The name of the toleration.
     * @type {string}
     * @memberof Toleration
     */
    'name'?: string | null;
    /**
     * 
     * @type {TolerationOperator}
     * @memberof Toleration
     */
    'operator'?: TolerationOperator | null;
    /**
     * The taint key that the toleration applies to. (mandatory)
     * @type {string}
     * @memberof Toleration
     */
    'key'?: string | null;
    /**
     * The taint value the toleration matches to. Mandatory if operator is Exists, forbidden otherwise.
     * @type {string}
     * @memberof Toleration
     */
    'value'?: string | null;
    /**
     * 
     * @type {TolerationEffect}
     * @memberof Toleration
     */
    'effect'?: TolerationEffect | null;
    /**
     * The period of time the toleration tolerates the taint. Valid only if effect is NoExecute. taint.
     * @type {number}
     * @memberof Toleration
     */
    'seconds'?: number | null;
    /**
     * Use \'true\' in case the label is defined in defaults of the policy, and you wish to exclude it from the workload.
     * @type {boolean}
     * @memberof Toleration
     */
    'exclude'?: boolean | null;
}
/**
 * The taint effect to match. (mandatory)
 * @export
 * @enum {string}
 */

export const TolerationEffect = {
    NoSchedule: 'NoSchedule',
    NoExecute: 'NoExecute',
    PreferNoSchedule: 'PreferNoSchedule',
    Any: 'Any'
} as const;

export type TolerationEffect = typeof TolerationEffect[keyof typeof TolerationEffect];


/**
 * 
 * @export
 * @interface TolerationEffectOptions
 */
export interface TolerationEffectOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationEffectOptionsOptionsInner>}
     * @memberof TolerationEffectOptions
     */
    'options'?: Array<TolerationEffectOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface TolerationEffectOptionsOptionsInner
 */
export interface TolerationEffectOptionsOptionsInner {
    /**
     * 
     * @type {TolerationEffect}
     * @memberof TolerationEffectOptionsOptionsInner
     */
    'value': TolerationEffect | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof TolerationEffectOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface TolerationEffectRules
 */
export interface TolerationEffectRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof TolerationEffectRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof TolerationEffectRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof TolerationEffectRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationEffectOptionsOptionsInner>}
     * @memberof TolerationEffectRules
     */
    'options'?: Array<TolerationEffectOptionsOptionsInner> | null;
}
/**
 * A key\'s relationship to the value. Equal uses key and value. Exists is equivalent to wildcard for value, so that a workload can tolerate all taints of a particular category. (mandatory)
 * @export
 * @enum {string}
 */

export const TolerationOperator = {
    Equal: 'Equal',
    Exists: 'Exists'
} as const;

export type TolerationOperator = typeof TolerationOperator[keyof typeof TolerationOperator];


/**
 * 
 * @export
 * @interface TolerationOperatorOptions
 */
export interface TolerationOperatorOptions {
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationOperatorOptionsOptionsInner>}
     * @memberof TolerationOperatorOptions
     */
    'options'?: Array<TolerationOperatorOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface TolerationOperatorOptionsOptionsInner
 */
export interface TolerationOperatorOptionsOptionsInner {
    /**
     * 
     * @type {TolerationOperator}
     * @memberof TolerationOperatorOptionsOptionsInner
     */
    'value': TolerationOperator | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof TolerationOperatorOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface TolerationOperatorRules
 */
export interface TolerationOperatorRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof TolerationOperatorRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof TolerationOperatorRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof TolerationOperatorRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for imagePullPolicy to a given set of values.
     * @type {Array<TolerationOperatorOptionsOptionsInner>}
     * @memberof TolerationOperatorRules
     */
    'options'?: Array<TolerationOperatorOptionsOptionsInner> | null;
}
/**
 * Toleration details.
 * @export
 * @interface TolerationRules
 */
export interface TolerationRules {
    /**
     * 
     * @type {TolerationOperatorRules}
     * @memberof TolerationRules
     */
    'operator'?: TolerationOperatorRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TolerationRules
     */
    'key'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof TolerationRules
     */
    'value'?: StringRules | null;
    /**
     * 
     * @type {TolerationEffectRules}
     * @memberof TolerationRules
     */
    'effect'?: TolerationEffectRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TolerationRules
     */
    'seconds'?: IntegerRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof TolerationRules
     */
    'exclude'?: BooleanRules | null;
}
/**
 * 
 * @export
 * @interface TolerationsDefaults
 */
export interface TolerationsDefaults {
    /**
     * 
     * @type {Toleration}
     * @memberof TolerationsDefaults
     */
    'attributes'?: Toleration | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof TolerationsDefaults
     */
    'instances'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface TolerationsField
 */
export interface TolerationsField {
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof TolerationsField
     */
    'tolerations'?: Array<Toleration> | null;
}
/**
 * 
 * @export
 * @interface TolerationsFieldDefaults
 */
export interface TolerationsFieldDefaults {
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof TolerationsFieldDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
}
/**
 * 
 * @export
 * @interface TolerationsFieldRules
 */
export interface TolerationsFieldRules {
    /**
     * 
     * @type {TolerationsRules}
     * @memberof TolerationsFieldRules
     */
    'tolerations'?: TolerationsRules | null;
}
/**
 * 
 * @export
 * @interface TolerationsRules
 */
export interface TolerationsRules {
    /**
     * 
     * @type {TolerationRules}
     * @memberof TolerationsRules
     */
    'attributes'?: TolerationRules | null;
    /**
     * 
     * @type {ItemRules}
     * @memberof TolerationsRules
     */
    'instances'?: ItemRules | null;
}
/**
 * 
 * @export
 * @interface Training
 */
export interface Training {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof Training
     */
    'name': string;
    /**
     * The name as was requested for the workload. If useGivenNameAsPrefix, in the creation request, is false, name and requestedName should be identical. Otherwise, name should be composed of requestedName followed by a suffix of random characters.
     * @type {string}
     * @memberof Training
     */
    'requestedName': string;
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof Training
     */
    'workloadId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof Training
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof Training
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Training
     */
    'clusterId': string;
    /**
     * The user who created the workload
     * @type {string}
     * @memberof Training
     */
    'createdBy': string;
    /**
     * The creation time of the workload.
     * @type {string}
     * @memberof Training
     */
    'createdAt': string;
    /**
     * The deletion time of the workload.
     * @type {string}
     * @memberof Training
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadDesiredPhase}
     * @memberof Training
     */
    'desiredPhase': WorkloadDesiredPhase;
    /**
     * 
     * @type {Phase}
     * @memberof Training
     */
    'actualPhase'?: Phase;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof Training
     */
    'spec'?: TrainingSpecSpec;
}
/**
 * 
 * @export
 * @interface TrainingCreationRequest
 */
export interface TrainingCreationRequest {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof TrainingCreationRequest
     */
    'name': string;
    /**
     * When true, the requested name will be treated as a prefix. The final name of the workload will be composed of the name followed by a random set of characters.
     * @type {boolean}
     * @memberof TrainingCreationRequest
     */
    'useGivenNameAsPrefix'?: boolean;
    /**
     * The id of the project.
     * @type {string}
     * @memberof TrainingCreationRequest
     */
    'projectId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof TrainingCreationRequest
     */
    'clusterId': string;
    /**
     * A unique ID of the template.
     * @type {string}
     * @memberof TrainingCreationRequest
     */
    'templateId'?: string | null;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingCreationRequest
     */
    'spec'?: TrainingSpecSpec;
}
/**
 * 
 * @export
 * @interface TrainingFields
 */
export interface TrainingFields {
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof TrainingFields
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof TrainingFields
     */
    'parallelism'?: number | null;
}
/**
 * 
 * @export
 * @interface TrainingFieldsRules
 */
export interface TrainingFieldsRules {
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingFieldsRules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof TrainingFieldsRules
     */
    'parallelism'?: IntegerRules | null;
}
/**
 * The specifications of the training to be created.
 * @export
 * @interface TrainingSpec
 */
export interface TrainingSpec {
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingSpec
     */
    'spec'?: TrainingSpecSpec;
}
/**
 * 
 * @export
 * @interface TrainingSpecSpec
 */
export interface TrainingSpecSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof TrainingSpecSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof TrainingSpecSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof TrainingSpecSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof TrainingSpecSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof TrainingSpecSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof TrainingSpecSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof TrainingSpecSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof TrainingSpecSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof TrainingSpecSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof TrainingSpecSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof TrainingSpecSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof TrainingSpecSpec
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof TrainingSpecSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof TrainingSpecSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof TrainingSpecSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof TrainingSpecSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof TrainingSpecSpec
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof TrainingSpecSpec
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof TrainingSpecSpec
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof TrainingSpecSpec
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof TrainingSpecSpec
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof TrainingSpecSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof TrainingSpecSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof TrainingSpecSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof TrainingSpecSpec
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof TrainingSpecSpec
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof TrainingSpecSpec
     */
    'parallelism'?: number | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof TrainingSpecSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof TrainingSpecSpec
     */
    'storage'?: StorageFields | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof TrainingSpecSpec
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface TrainingTemplate
 */
export interface TrainingTemplate {
    /**
     * 
     * @type {TemplateMetaFields}
     * @memberof TrainingTemplate
     */
    'meta': TemplateMetaFields;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingTemplate
     */
    'spec'?: TrainingSpecSpec;
    /**
     * 
     * @type {RunnableInfo}
     * @memberof TrainingTemplate
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingTemplate
     */
    'combinedSpec'?: TrainingSpecSpec;
}
/**
 * 
 * @export
 * @interface TrainingTemplateAllOf
 */
export interface TrainingTemplateAllOf {
    /**
     * 
     * @type {RunnableInfo}
     * @memberof TrainingTemplateAllOf
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingTemplateAllOf
     */
    'combinedSpec'?: TrainingSpecSpec;
}
/**
 * 
 * @export
 * @interface TrainingTemplateCreationRequest
 */
export interface TrainingTemplateCreationRequest {
    /**
     * 
     * @type {TemplateCreationMetaFields}
     * @memberof TrainingTemplateCreationRequest
     */
    'meta': TemplateCreationMetaFields;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingTemplateCreationRequest
     */
    'spec'?: TrainingSpecSpec;
}
/**
 * 
 * @export
 * @interface TrainingTemplatePatchRequest
 */
export interface TrainingTemplatePatchRequest {
    /**
     * 
     * @type {TemplatePatchMetaFields}
     * @memberof TrainingTemplatePatchRequest
     */
    'meta'?: TemplatePatchMetaFields | null;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingTemplatePatchRequest
     */
    'spec'?: TrainingSpecSpec;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrainingTemplatePatchRequest
     */
    'fieldsToClear'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TrainingTemplateUpdateRequest
 */
export interface TrainingTemplateUpdateRequest {
    /**
     * 
     * @type {TemplateUpdateMetaFields}
     * @memberof TrainingTemplateUpdateRequest
     */
    'meta': TemplateUpdateMetaFields;
    /**
     * 
     * @type {TrainingSpecSpec}
     * @memberof TrainingTemplateUpdateRequest
     */
    'spec'?: TrainingSpecSpec;
}
/**
 * 
 * @export
 * @interface TrainingTemplatesListResponse
 */
export interface TrainingTemplatesListResponse {
    /**
     * 
     * @type {Array<TrainingTemplate>}
     * @memberof TrainingTemplatesListResponse
     */
    'entries'?: Array<TrainingTemplate>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof TrainingTemplatesListResponse
     */
    'pagination'?: PaginationInfo;
}
/**
 * Indicate the way to determine the user and group ids of the container. The options are a. `fromTheImage` - user and group ids are determined by the docker image that the container runs. this is the default option. b. `custom` - user and group ids can be specified in the environment asset and/or the workspace creation request. c. `idpToken` - user and group ids are determined according to the identity provider (idp) access token. This option is intended for internal use of the environment UI form. For more information, see [User Identity](https://docs.run.ai/latest/admin/runai-setup/config/non-root-containers/).
 * @export
 * @enum {string}
 */

export const UidGidSource = {
    FromTheImage: 'fromTheImage',
    FromIdpToken: 'fromIdpToken',
    Custom: 'custom'
} as const;

export type UidGidSource = typeof UidGidSource[keyof typeof UidGidSource];


/**
 * 
 * @export
 * @interface UidGidSourceOptions
 */
export interface UidGidSourceOptions {
    /**
     * Limit the permitted values for uidGidSource to a given set of values.
     * @type {Array<UidGidSourceOptionsOptionsInner>}
     * @memberof UidGidSourceOptions
     */
    'options'?: Array<UidGidSourceOptionsOptionsInner> | null;
}
/**
 * 
 * @export
 * @interface UidGidSourceOptionsOptionsInner
 */
export interface UidGidSourceOptionsOptionsInner {
    /**
     * 
     * @type {UidGidSource}
     * @memberof UidGidSourceOptionsOptionsInner
     */
    'value': UidGidSource | null;
    /**
     * Textual description of the value
     * @type {string}
     * @memberof UidGidSourceOptionsOptionsInner
     */
    'displayed'?: string | null;
}
/**
 * 
 * @export
 * @interface UidGidSourceRules
 */
export interface UidGidSourceRules {
    /**
     * 
     * @type {SourceOfRule}
     * @memberof UidGidSourceRules
     */
    'sourceOfRule'?: SourceOfRule | null;
    /**
     * Whether the field is mandatory, default to false.
     * @type {boolean}
     * @memberof UidGidSourceRules
     */
    'required'?: boolean | null;
    /**
     * Whether the value of the field is editable, default to true
     * @type {boolean}
     * @memberof UidGidSourceRules
     */
    'canEdit'?: boolean | null;
    /**
     * Limit the permitted values for uidGidSource to a given set of values.
     * @type {Array<UidGidSourceOptionsOptionsInner>}
     * @memberof UidGidSourceRules
     */
    'options'?: Array<UidGidSourceOptionsOptionsInner> | null;
}
/**
 * policy information per replica for non-distributed, worker replica is used as the container for the information.
 * @export
 * @interface UnifiedPolicyInfo
 */
export interface UnifiedPolicyInfo {
    /**
     * 
     * @type {UnifiedPolicyInfoPerReplicaType}
     * @memberof UnifiedPolicyInfo
     */
    'worker'?: UnifiedPolicyInfoPerReplicaType | null;
    /**
     * 
     * @type {UnifiedPolicyInfoPerReplicaType}
     * @memberof UnifiedPolicyInfo
     */
    'master'?: UnifiedPolicyInfoPerReplicaType | null;
}
/**
 * 
 * @export
 * @interface UnifiedPolicyInfoPerReplicaType
 */
export interface UnifiedPolicyInfoPerReplicaType {
    /**
     * 
     * @type {UnifiedPolicyInfoPerReplicaTypeDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaType
     */
    'defaults'?: UnifiedPolicyInfoPerReplicaTypeDefaults | null;
    /**
     * 
     * @type {UnifiedPolicyInfoPerReplicaTypeRules}
     * @memberof UnifiedPolicyInfoPerReplicaType
     */
    'rules'?: UnifiedPolicyInfoPerReplicaTypeRules | null;
}
/**
 * 
 * @export
 * @interface UnifiedPolicyInfoPerReplicaTypeDefaults
 */
export interface UnifiedPolicyInfoPerReplicaTypeDefaults {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'stdin'?: boolean | null;
    /**
     * 
     * @type {EnvironmentVariablesDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'environmentVariables'?: EnvironmentVariablesDefaults | null;
    /**
     * 
     * @type {AnnotationsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'annotations'?: AnnotationsDefaults | null;
    /**
     * 
     * @type {LabelsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'labels'?: LabelsDefaults | null;
    /**
     * 
     * @type {TolerationsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'tolerations'?: TolerationsDefaults | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * 
     * @type {PortsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'ports'?: PortsDefaults | null;
    /**
     * 
     * @type {ExposedUrlsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'exposedUrls'?: ExposedUrlsDefaults | null;
    /**
     * 
     * @type {RelatedUrlsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'relatedUrls'?: RelatedUrlsDefaults | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'parallelism'?: number | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'autoscaling'?: AutoScaling | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFieldsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'compute'?: ComputeFieldsDefaults | null;
    /**
     * 
     * @type {StorageFieldsDefaults}
     * @memberof UnifiedPolicyInfoPerReplicaTypeDefaults
     */
    'storage'?: StorageFieldsDefaults | null;
}
/**
 * 
 * @export
 * @interface UnifiedPolicyInfoPerReplicaTypeRules
 */
export interface UnifiedPolicyInfoPerReplicaTypeRules {
    /**
     * 
     * @type {StringRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'command'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'args'?: StringRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'image'?: StringRules | null;
    /**
     * 
     * @type {ImagePullPolicyRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'imagePullPolicy'?: ImagePullPolicyRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'workingDir'?: StringRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'createHomeDir'?: BooleanRules | null;
    /**
     * 
     * @type {ProbesRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'probes'?: ProbesRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'nodeType'?: StringRules | null;
    /**
     * 
     * @type {ArrayRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'nodePools'?: ArrayRules | null;
    /**
     * 
     * @type {PodAffinityRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'podAffinity'?: PodAffinityRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'tty'?: BooleanRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'stdin'?: BooleanRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'environmentVariables'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'annotations'?: InstancesRules | null;
    /**
     * 
     * @type {InstancesRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'labels'?: InstancesRules | null;
    /**
     * 
     * @type {TolerationsRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'tolerations'?: TolerationsRules | null;
    /**
     * 
     * @type {BooleanRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'terminateAfterPreemption'?: BooleanRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'autoDeletionTimeAfterCompletionSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'terminationGracePeriodSeconds'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'backoffLimit'?: IntegerRules | null;
    /**
     * 
     * @type {RestartPolicyRule}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'restartPolicy'?: RestartPolicyRule | null;
    /**
     * 
     * @type {PortsRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'ports'?: PortsRules | null;
    /**
     * 
     * @type {ExposedUrlsRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'exposedUrls'?: ExposedUrlsRules | null;
    /**
     * 
     * @type {RelatedUrlsRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'relatedUrls'?: RelatedUrlsRules | null;
    /**
     * 
     * @type {PriorityClassRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'priorityClass'?: PriorityClassRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'completions'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'parallelism'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'numWorkers'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedFrameworkRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'distributedFramework'?: DistributedFrameworkRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'slotsPerWorker'?: IntegerRules | null;
    /**
     * 
     * @type {StringRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'sshAuthMountPath'?: StringRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'minReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {IntegerRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'maxReplicas'?: IntegerRules | null;
    /**
     * 
     * @type {DistributedCleanPodPolicyRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicyRules | null;
    /**
     * 
     * @type {ServingPortRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'servingPort'?: ServingPortRules | null;
    /**
     * 
     * @type {AutoScalingRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'autoscaling'?: AutoScalingRules | null;
    /**
     * 
     * @type {SecurityFlatFieldsRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'security'?: SecurityFlatFieldsRules | null;
    /**
     * 
     * @type {ComputeFieldsRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'compute'?: ComputeFieldsRules | null;
    /**
     * 
     * @type {StorageFieldsRules}
     * @memberof UnifiedPolicyInfoPerReplicaTypeRules
     */
    'storage'?: StorageFieldsRules | null;
}
/**
 * project information that are needed for the construction of the submission form
 * @export
 * @interface UnifiedProjectInfo
 */
export interface UnifiedProjectInfo {
    /**
     * the name of the project, for reference
     * @type {string}
     * @memberof UnifiedProjectInfo
     */
    'name'?: string;
}
/**
 * unified spec containing all possible fields, per replica type. for non-distributed, worker replica is used as the container for the spec.
 * @export
 * @interface UnifiedSpec
 */
export interface UnifiedSpec {
    /**
     * 
     * @type {UnifiedSpecWorker}
     * @memberof UnifiedSpec
     */
    'worker'?: UnifiedSpecWorker | null;
    /**
     * used for distributed workloads to indicate that the master spec should be the same as the worker spec. in this case, masterSpec should not be specified.
     * @type {boolean}
     * @memberof UnifiedSpec
     */
    'masterSpecSameAsWorker'?: boolean | null;
    /**
     * 
     * @type {UnifiedSpecMaster}
     * @memberof UnifiedSpec
     */
    'master'?: UnifiedSpecMaster | null;
}
/**
 * 
 * @export
 * @interface UnifiedSpecMaster
 */
export interface UnifiedSpecMaster {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof UnifiedSpecMaster
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof UnifiedSpecMaster
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof UnifiedSpecMaster
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof UnifiedSpecMaster
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof UnifiedSpecMaster
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof UnifiedSpecMaster
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof UnifiedSpecMaster
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof UnifiedSpecMaster
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof UnifiedSpecMaster
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof UnifiedSpecMaster
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof UnifiedSpecMaster
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof UnifiedSpecMaster
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof UnifiedSpecMaster
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof UnifiedSpecMaster
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof UnifiedSpecMaster
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof UnifiedSpecMaster
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof UnifiedSpecMaster
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof UnifiedSpecMaster
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof UnifiedSpecMaster
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof UnifiedSpecMaster
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof UnifiedSpecMaster
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof UnifiedSpecMaster
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof UnifiedSpecMaster
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof UnifiedSpecMaster
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof UnifiedSpecMaster
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof UnifiedSpecMaster
     */
    'storage'?: StorageFields | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof UnifiedSpecMaster
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface UnifiedSpecWorker
 */
export interface UnifiedSpecWorker {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof UnifiedSpecWorker
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof UnifiedSpecWorker
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof UnifiedSpecWorker
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof UnifiedSpecWorker
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof UnifiedSpecWorker
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof UnifiedSpecWorker
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof UnifiedSpecWorker
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof UnifiedSpecWorker
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof UnifiedSpecWorker
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof UnifiedSpecWorker
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof UnifiedSpecWorker
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof UnifiedSpecWorker
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof UnifiedSpecWorker
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof UnifiedSpecWorker
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof UnifiedSpecWorker
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof UnifiedSpecWorker
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof UnifiedSpecWorker
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof UnifiedSpecWorker
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof UnifiedSpecWorker
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof UnifiedSpecWorker
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof UnifiedSpecWorker
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof UnifiedSpecWorker
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the number of successful pods the job should reach to be completed. The Job will be marked as successful once the specified amount of pods has been reached (applicable to standard training only).
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'completions'?: number | null;
    /**
     * Used with Hyperparameter Optimization. Specifies the maximum number of pods the workload should run at any given time (applicable to standard training only).
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'parallelism'?: number | null;
    /**
     * the number of workers that will be allocated for running the workload.
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'numWorkers'?: number | null;
    /**
     * 
     * @type {DistributedFramework}
     * @memberof UnifiedSpecWorker
     */
    'distributedFramework'?: DistributedFramework | null;
    /**
     * Specifies the number of slots per worker used in hostfile. Defaults to 1. (applicable only for MPI)
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'slotsPerWorker'?: number | null;
    /**
     * Specifies the directory where SSH keys are mounted. (applicable only for MPI)
     * @type {string}
     * @memberof UnifiedSpecWorker
     */
    'sshAuthMountPath'?: string | null;
    /**
     * the lower limit for the number of worker pods to which the training job can scale down. (applicable only for PyTorch)
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'minReplicas'?: number | null;
    /**
     * the upper limit for the number of worker pods that can be set by the autoscaler. Cannot be smaller than MinReplicas. (applicable only for PyTorch)
     * @type {number}
     * @memberof UnifiedSpecWorker
     */
    'maxReplicas'?: number | null;
    /**
     * 
     * @type {DistributedCleanPodPolicy}
     * @memberof UnifiedSpecWorker
     */
    'cleanPodPolicy'?: DistributedCleanPodPolicy | null;
    /**
     * 
     * @type {ServingPort}
     * @memberof UnifiedSpecWorker
     */
    'servingPort'?: ServingPort | null;
    /**
     * 
     * @type {AutoScaling}
     * @memberof UnifiedSpecWorker
     */
    'autoscaling'?: AutoScaling | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof UnifiedSpecWorker
     */
    'security'?: SecurityFlatFields | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof UnifiedSpecWorker
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof UnifiedSpecWorker
     */
    'storage'?: StorageFields | null;
}
/**
 * 
 * @export
 * @interface UnifiedWorkload
 */
export interface UnifiedWorkload {
    /**
     * 
     * @type {WorkloadMeta}
     * @memberof UnifiedWorkload
     */
    'meta'?: WorkloadMeta;
    /**
     * 
     * @type {UnifiedSpec}
     * @memberof UnifiedWorkload
     */
    'spec'?: UnifiedSpec | null;
    /**
     * 
     * @type {UnifiedPolicyInfo}
     * @memberof UnifiedWorkload
     */
    'policyInfo'?: UnifiedPolicyInfo | null;
    /**
     * 
     * @type {UnifiedProjectInfo}
     * @memberof UnifiedWorkload
     */
    'projectInfo'?: UnifiedProjectInfo | null;
}
/**
 * parameters for unified workload request workloadType and projectId are always mandatory assetId is needed for unifying asset info. it also mandates the caller to provide clusterId workloadId is needed for unifying workload spec. workloadId and assetId are mutual exclusive. templateId is needed for unifying template spec.
 * @export
 * @interface UnifiedWorkloadRequest
 */
export interface UnifiedWorkloadRequest {
    /**
     * 
     * @type {WorkloadType}
     * @memberof UnifiedWorkloadRequest
     */
    'workloadType'?: WorkloadType;
    /**
     * The id of the project.
     * @type {string}
     * @memberof UnifiedWorkloadRequest
     */
    'projectId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof UnifiedWorkloadRequest
     */
    'clusterId'?: string | null;
    /**
     * Optional unique identifier of the asset.
     * @type {string}
     * @memberof UnifiedWorkloadRequest
     */
    'assetId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnifiedWorkloadRequest
     */
    'assetIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnifiedWorkloadRequest
     */
    'dataVolumeIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UnifiedWorkloadRequest
     */
    'workloadId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnifiedWorkloadRequest
     */
    'templateId'?: string | null;
}
/**
 * 
 * @export
 * @interface WorkerSpec
 */
export interface WorkerSpec {
    /**
     * 
     * @type {DistributedSpecSpec}
     * @memberof WorkerSpec
     */
    'spec'?: DistributedSpecSpec;
}
/**
 * 
 * @export
 * @interface Workload
 */
export interface Workload {
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof Workload
     */
    'tenantId': number;
    /**
     * 
     * @type {number}
     * @memberof Workload
     */
    'runningPods': number;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'phaseUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'k8sPhaseUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'updatedAt': string;
    /**
     * 
     * @type {Source}
     * @memberof Workload
     */
    'source': Source;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Workload
     */
    'priority': number | null;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'priorityClassName': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'submittedBy'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Workload
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'departmentName': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'departmentId': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'namespace': string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'createdAt': string;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof Workload
     */
    'workloadRequestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof Workload
     */
    'podsRequestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {WorkloadAllocatedResources}
     * @memberof Workload
     */
    'allocatedResources'?: WorkloadAllocatedResources | null;
    /**
     * 
     * @type {ActionsSupport}
     * @memberof Workload
     */
    'actionsSupport'?: ActionsSupport;
    /**
     * 
     * @type {Phase}
     * @memberof Workload
     */
    'phase': Phase;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof Workload
     */
    'conditions': Array<Condition>;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'k8sPhase': string;
    /**
     * 
     * @type {RequestedPods}
     * @memberof Workload
     */
    'requestedPods'?: RequestedPods;
    /**
     * 
     * @type {Array<string>}
     * @memberof Workload
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Workload
     */
    'currentNodePools'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Workload
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {Array<WorkloadChildrenIdsInner>}
     * @memberof Workload
     */
    'childrenIds'?: Array<WorkloadChildrenIdsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Workload
     */
    'urls'?: Array<string>;
    /**
     * 
     * @type {Array<Datasource>}
     * @memberof Workload
     */
    'datasources'?: Array<Datasource>;
    /**
     * 
     * @type {Array<Environment>}
     * @memberof Workload
     */
    'environments'?: Array<Environment>;
    /**
     * 
     * @type {Array<Connection>}
     * @memberof Workload
     */
    'externalConnections'?: Array<Connection>;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'distributedFramework'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Workload
     */
    'additionalFields'?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof Workload
     */
    'preemptible'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Workload
     */
    'fullySaasWorkload'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Workload
     */
    'environmentVariables'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'command'?: string;
    /**
     * 
     * @type {string}
     * @memberof Workload
     */
    'arguments'?: string;
    /**
     * 
     * @type {PhaseReason}
     * @memberof Workload
     */
    'phaseReason'?: PhaseReason | null;
    /**
     * deprecated. use idleAllocatedGpus instead
     * @type {number}
     * @memberof Workload
     * @deprecated
     */
    'idleGpus'?: number | null;
    /**
     * sum of idle allocated gpus in the workload
     * @type {number}
     * @memberof Workload
     */
    'idleAllocatedGpus'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Workload
     */
    'totalPendingTimeSeconds'?: number | null;
}
/**
 * 
 * @export
 * @interface WorkloadAllocatedResources
 */
export interface WorkloadAllocatedResources {
    /**
     * Required if and only if gpuRequestType is portion. States the number of GPUs allocated for the created workload. The default is no allocated GPUs.
     * @type {number}
     * @memberof WorkloadAllocatedResources
     */
    'gpu'?: number | null;
    /**
     * 
     * @type {Array<MigProfile>}
     * @memberof WorkloadAllocatedResources
     */
    'migProfile'?: Array<MigProfile> | null;
    /**
     * 
     * @type {string}
     * @memberof WorkloadAllocatedResources
     */
    'gpuMemory'?: string | null;
    /**
     * States the amount of CPU cores used by the workload running.
     * @type {number}
     * @memberof WorkloadAllocatedResources
     */
    'cpu'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkloadAllocatedResources
     */
    'cpuMemory'?: string | null;
    /**
     * Set of extended resources with their quantity
     * @type {Array<WorkloadsExtendedResource>}
     * @memberof WorkloadAllocatedResources
     */
    'extendedResources'?: Array<WorkloadsExtendedResource> | null;
}
/**
 * The ids and action to perform on a batch of workloads. The number of ids is limited to 100.
 * @export
 * @interface WorkloadBatch
 */
export interface WorkloadBatch {
    /**
     * List of ids to perform the action on.
     * @type {Array<string>}
     * @memberof WorkloadBatch
     */
    'ids': Array<string>;
    /**
     * 
     * @type {Action}
     * @memberof WorkloadBatch
     */
    'action': Action;
}
/**
 * 
 * @export
 * @interface WorkloadChildrenIdsInner
 */
export interface WorkloadChildrenIdsInner {
    /**
     * 
     * @type {string}
     * @memberof WorkloadChildrenIdsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadChildrenIdsInner
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface WorkloadCreationFields
 */
export interface WorkloadCreationFields {
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'submittedBy'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'departmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'departmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'createdAt': string;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof WorkloadCreationFields
     */
    'requestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {RequestedPods}
     * @memberof WorkloadCreationFields
     */
    'requestedPods'?: RequestedPods;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadCreationFields
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {Array<Datasource>}
     * @memberof WorkloadCreationFields
     */
    'datasources'?: Array<Datasource>;
    /**
     * 
     * @type {Array<Environment>}
     * @memberof WorkloadCreationFields
     */
    'environments'?: Array<Environment>;
    /**
     * 
     * @type {Array<Connection>}
     * @memberof WorkloadCreationFields
     */
    'externalConnections'?: Array<Connection>;
    /**
     * 
     * @type {string}
     * @memberof WorkloadCreationFields
     */
    'distributedFramework'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadCreationFields
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkloadCreationFields
     */
    'fullySaasWorkload'?: boolean;
}
/**
 * 
 * @export
 * @interface WorkloadCreationMeta
 */
export interface WorkloadCreationMeta {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'name': string;
    /**
     * When true, the requested name will be treated as a prefix. The final name of the workload will be composed of the name followed by a random set of characters.
     * @type {boolean}
     * @memberof WorkloadCreationMeta
     */
    'useGivenNameAsPrefix'?: boolean;
    /**
     * The id of the project.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'projectId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'clusterId': string;
    /**
     * A unique ID of the template.
     * @type {string}
     * @memberof WorkloadCreationMeta
     */
    'templateId'?: string | null;
}
/**
 * The desired phase of the workload.
 * @export
 * @enum {string}
 */

export const WorkloadDesiredPhase = {
    Running: 'Running',
    Stopped: 'Stopped',
    Deleted: 'Deleted'
} as const;

export type WorkloadDesiredPhase = typeof WorkloadDesiredPhase[keyof typeof WorkloadDesiredPhase];


/**
 * 
 * @export
 * @interface WorkloadDetailed
 */
export interface WorkloadDetailed {
    /**
     * The id of the tenant.
     * @type {number}
     * @memberof WorkloadDetailed
     */
    'tenantId': number;
    /**
     * 
     * @type {number}
     * @memberof WorkloadDetailed
     */
    'runningPods': number;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'phaseUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'k8sPhaseUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'updatedAt': string;
    /**
     * 
     * @type {Source}
     * @memberof WorkloadDetailed
     */
    'source': Source;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof WorkloadDetailed
     */
    'priority': number | null;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'priorityClassName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'submittedBy'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'departmentName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'departmentId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'namespace': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'createdAt': string;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof WorkloadDetailed
     */
    'workloadRequestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof WorkloadDetailed
     */
    'podsRequestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {WorkloadAllocatedResources}
     * @memberof WorkloadDetailed
     */
    'allocatedResources'?: WorkloadAllocatedResources | null;
    /**
     * 
     * @type {ActionsSupport}
     * @memberof WorkloadDetailed
     */
    'actionsSupport'?: ActionsSupport;
    /**
     * 
     * @type {Phase}
     * @memberof WorkloadDetailed
     */
    'phase': Phase;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof WorkloadDetailed
     */
    'conditions': Array<Condition>;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'k8sPhase': string;
    /**
     * 
     * @type {RequestedPods}
     * @memberof WorkloadDetailed
     */
    'requestedPods'?: RequestedPods;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadDetailed
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadDetailed
     */
    'currentNodePools'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadDetailed
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {Array<WorkloadChildrenIdsInner>}
     * @memberof WorkloadDetailed
     */
    'childrenIds'?: Array<WorkloadChildrenIdsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadDetailed
     */
    'urls'?: Array<string>;
    /**
     * 
     * @type {Array<Datasource>}
     * @memberof WorkloadDetailed
     */
    'datasources'?: Array<Datasource>;
    /**
     * 
     * @type {Array<Environment>}
     * @memberof WorkloadDetailed
     */
    'environments'?: Array<Environment>;
    /**
     * 
     * @type {Array<Connection>}
     * @memberof WorkloadDetailed
     */
    'externalConnections'?: Array<Connection>;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'distributedFramework'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WorkloadDetailed
     */
    'additionalFields'?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof WorkloadDetailed
     */
    'preemptible'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkloadDetailed
     */
    'fullySaasWorkload'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WorkloadDetailed
     */
    'environmentVariables'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'command'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadDetailed
     */
    'arguments'?: string;
    /**
     * 
     * @type {PhaseReason}
     * @memberof WorkloadDetailed
     */
    'phaseReason'?: PhaseReason | null;
    /**
     * deprecated. use idleAllocatedGpus instead
     * @type {number}
     * @memberof WorkloadDetailed
     * @deprecated
     */
    'idleGpus'?: number | null;
    /**
     * sum of idle allocated gpus in the workload
     * @type {number}
     * @memberof WorkloadDetailed
     */
    'idleAllocatedGpus'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkloadDetailed
     */
    'totalPendingTimeSeconds'?: number | null;
    /**
     * 
     * @type {Array<PendingSchedulingMessage>}
     * @memberof WorkloadDetailed
     */
    'pendingSchedulingMessages'?: Array<PendingSchedulingMessage> | null;
}
/**
 * 
 * @export
 * @interface WorkloadDetailedAllOf
 */
export interface WorkloadDetailedAllOf {
    /**
     * 
     * @type {Array<PendingSchedulingMessage>}
     * @memberof WorkloadDetailedAllOf
     */
    'pendingSchedulingMessages'?: Array<PendingSchedulingMessage> | null;
}
/**
 * 
 * @export
 * @interface WorkloadMeta
 */
export interface WorkloadMeta {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'name': string;
    /**
     * The name as was requested for the workload. If useGivenNameAsPrefix, in the creation request, is false, name and requestedName should be identical. Otherwise, name should be composed of requestedName followed by a suffix of random characters.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'requestedName': string;
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'workloadId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'clusterId': string;
    /**
     * The user who created the workload
     * @type {string}
     * @memberof WorkloadMeta
     */
    'createdBy': string;
    /**
     * The creation time of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'createdAt': string;
    /**
     * The deletion time of the workload.
     * @type {string}
     * @memberof WorkloadMeta
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadDesiredPhase}
     * @memberof WorkloadMeta
     */
    'desiredPhase': WorkloadDesiredPhase;
    /**
     * 
     * @type {Phase}
     * @memberof WorkloadMeta
     */
    'actualPhase'?: Phase;
}
/**
 * Specify which metric data to request.
 * @export
 * @enum {string}
 */

export const WorkloadMetricType = {
    GpuUtilization: 'GPU_UTILIZATION',
    GpuMemoryUsageBytes: 'GPU_MEMORY_USAGE_BYTES',
    GpuMemoryRequestBytes: 'GPU_MEMORY_REQUEST_BYTES',
    CpuUsageCores: 'CPU_USAGE_CORES',
    CpuRequestCores: 'CPU_REQUEST_CORES',
    CpuLimitCores: 'CPU_LIMIT_CORES',
    CpuMemoryUsageBytes: 'CPU_MEMORY_USAGE_BYTES',
    CpuMemoryRequestBytes: 'CPU_MEMORY_REQUEST_BYTES',
    CpuMemoryLimitBytes: 'CPU_MEMORY_LIMIT_BYTES',
    PodCount: 'POD_COUNT',
    RunningPodCount: 'RUNNING_POD_COUNT',
    GpuAllocation: 'GPU_ALLOCATION'
} as const;

export type WorkloadMetricType = typeof WorkloadMetricType[keyof typeof WorkloadMetricType];


/**
 * 
 * @export
 * @interface WorkloadNetworkStatus
 */
export interface WorkloadNetworkStatus {
    /**
     * 
     * @type {Array<WorkloadNetworkStatusServicesInner>}
     * @memberof WorkloadNetworkStatus
     */
    'services'?: Array<WorkloadNetworkStatusServicesInner>;
}
/**
 * 
 * @export
 * @interface WorkloadNetworkStatusServicesInner
 */
export interface WorkloadNetworkStatusServicesInner {
    /**
     * 
     * @type {string}
     * @memberof WorkloadNetworkStatusServicesInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadNetworkStatusServicesInner
     */
    'type'?: string;
    /**
     * 
     * @type {Array<WorkloadNetworkStatusServicesInnerPortsInner>}
     * @memberof WorkloadNetworkStatusServicesInner
     */
    'ports'?: Array<WorkloadNetworkStatusServicesInnerPortsInner>;
}
/**
 * 
 * @export
 * @interface WorkloadNetworkStatusServicesInnerPortsInner
 */
export interface WorkloadNetworkStatusServicesInnerPortsInner {
    /**
     * 
     * @type {string}
     * @memberof WorkloadNetworkStatusServicesInnerPortsInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadNetworkStatusServicesInnerPortsInner
     */
    'targetPort'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkloadNetworkStatusServicesInnerPortsInner
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkloadNetworkStatusServicesInnerPortsInner
     */
    'protocol'?: string;
}
/**
 * 
 * @export
 * @interface WorkloadPatchFields
 */
export interface WorkloadPatchFields {
    /**
     * 
     * @type {Phase}
     * @memberof WorkloadPatchFields
     */
    'phase': Phase;
    /**
     * 
     * @type {string}
     * @memberof WorkloadPatchFields
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkloadPatchFields
     */
    'softDelete'?: boolean;
}
/**
 * 
 * @export
 * @interface WorkloadPodsSyncRequest
 */
export interface WorkloadPodsSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadPodsSyncRequest
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadPodsSyncRequest
     */
    'workloadId': string;
    /**
     * 
     * @type {Array<PodSyncFields>}
     * @memberof WorkloadPodsSyncRequest
     */
    'pods': Array<PodSyncFields>;
    /**
     * pod ids to ignore when deleting.
     * @type {Array<string>}
     * @memberof WorkloadPodsSyncRequest
     */
    'idsToIgnore'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkloadRequestResources
 */
export interface WorkloadRequestResources {
    /**
     * 
     * @type {GpuRequestType}
     * @memberof WorkloadRequestResources
     */
    'gpuRequestType'?: GpuRequestType | null;
    /**
     * 
     * @type {RequestResourceCores}
     * @memberof WorkloadRequestResources
     */
    'gpu'?: RequestResourceCores | null;
    /**
     * 
     * @type {RequestResourceQuantity}
     * @memberof WorkloadRequestResources
     */
    'gpuMemory'?: RequestResourceQuantity | null;
    /**
     * 
     * @type {RequestResourceCores}
     * @memberof WorkloadRequestResources
     */
    'cpu'?: RequestResourceCores | null;
    /**
     * 
     * @type {RequestResourceQuantity}
     * @memberof WorkloadRequestResources
     */
    'cpuMemory'?: RequestResourceQuantity | null;
    /**
     * 
     * @type {Array<MigProfile>}
     * @memberof WorkloadRequestResources
     */
    'migProfile'?: Array<MigProfile> | null;
    /**
     * Set of extended resources with their quantity
     * @type {Array<WorkloadsExtendedResource>}
     * @memberof WorkloadRequestResources
     */
    'extendedResources'?: Array<WorkloadsExtendedResource> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WorkloadSortFilterFields = {
    Type: 'type',
    Name: 'name',
    ClusterId: 'clusterId',
    ProjectId: 'projectId',
    ProjectName: 'projectName',
    DepartmentId: 'departmentId',
    DepartmentName: 'departmentName',
    CreatedAt: 'createdAt',
    DeletedAt: 'deletedAt',
    SubmittedBy: 'submittedBy',
    Phase: 'phase',
    CompletedAt: 'completedAt',
    Nodepool: 'nodepool',
    DistributedFramework: 'distributedFramework',
    AllocatedGpu: 'allocatedGPU',
    IdleGpus: 'idleGpus',
    IdleAllocatedGpus: 'idleAllocatedGpus',
    TotalPendingTimeSeconds: 'totalPendingTimeSeconds',
    PhaseUpdatedAt: 'phaseUpdatedAt'
} as const;

export type WorkloadSortFilterFields = typeof WorkloadSortFilterFields[keyof typeof WorkloadSortFilterFields];


/**
 * 
 * @export
 * @interface WorkloadSyncFields
 */
export interface WorkloadSyncFields {
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'submittedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'priorityClassName': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'clusterId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'departmentName': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'departmentId': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'namespace': string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'createdAt': string;
    /**
     * 
     * @type {WorkloadRequestResources}
     * @memberof WorkloadSyncFields
     */
    'requestedResources'?: WorkloadRequestResources | null;
    /**
     * 
     * @type {ActionsSupport}
     * @memberof WorkloadSyncFields
     */
    'actionsSupport'?: ActionsSupport;
    /**
     * 
     * @type {Phase}
     * @memberof WorkloadSyncFields
     */
    'phase': Phase;
    /**
     * 
     * @type {Source}
     * @memberof WorkloadSyncFields
     */
    'source': Source;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof WorkloadSyncFields
     */
    'conditions'?: Array<Condition>;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'phaseMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'k8sPhase': string;
    /**
     * 
     * @type {RequestedPods}
     * @memberof WorkloadSyncFields
     */
    'requestedPods'?: RequestedPods;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadSyncFields
     */
    'requestedNodePools'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadSyncFields
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'distributedFramework'?: string;
    /**
     * 
     * @type {Array<WorkloadChildrenIdsInner>}
     * @memberof WorkloadSyncFields
     */
    'childrenIds'?: Array<WorkloadChildrenIdsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkloadSyncFields
     */
    'urls'?: Array<string>;
    /**
     * 
     * @type {WorkloadNetworkStatus}
     * @memberof WorkloadSyncFields
     */
    'networkStatus'?: WorkloadNetworkStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'additionalFields'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkloadSyncFields
     */
    'priority'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkloadSyncFields
     */
    'fullySaasWorkload'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WorkloadSyncFields
     */
    'environmentVariables'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'command'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkloadSyncFields
     */
    'arguments'?: string;
    /**
     * 
     * @type {Array<SchedulingCondition>}
     * @memberof WorkloadSyncFields
     */
    'schedulingConditions'?: Array<SchedulingCondition> | null;
}
/**
 * Select a telemetry type.
 * @export
 * @enum {string}
 */

export const WorkloadTelemetryType = {
    WorkloadsCount: 'WORKLOADS_COUNT',
    GpuAllocation: 'GPU_ALLOCATION'
} as const;

export type WorkloadTelemetryType = typeof WorkloadTelemetryType[keyof typeof WorkloadTelemetryType];


/**
 * the type of workload
 * @export
 * @enum {string}
 */

export const WorkloadType = {
    Workspace: 'Workspace',
    Training: 'Training',
    Distributed: 'Distributed',
    Inference: 'Inference'
} as const;

export type WorkloadType = typeof WorkloadType[keyof typeof WorkloadType];


/**
 * Quantity of an extended resource.
 * @export
 * @interface WorkloadsExtendedResource
 */
export interface WorkloadsExtendedResource {
    /**
     * The name of the extended resource (mandatory)
     * @type {string}
     * @memberof WorkloadsExtendedResource
     */
    'resource'?: string | null;
    /**
     * The requested quantity for the given resource.
     * @type {string}
     * @memberof WorkloadsExtendedResource
     */
    'quantity'?: string | null;
    /**
     * Whether to exclude this extended resource from the workload. This is necessary in case the extended resource is inherited from the policy defaults and it is desired not to include it in this workload.
     * @type {boolean}
     * @memberof WorkloadsExtendedResource
     */
    'exclude'?: boolean | null;
    /**
     * Deprecated value sent from the cluster, not to be used.
     * @type {string}
     * @memberof WorkloadsExtendedResource
     * @deprecated
     */
    'limit'?: string | null;
    /**
     * Deprecated value sent from the cluster, not to be used.
     * @type {string}
     * @memberof WorkloadsExtendedResource
     * @deprecated
     */
    'request'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkloadsExtendedResource
     * @deprecated
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface WorkloadsSyncInfo
 */
export interface WorkloadsSyncInfo {
    /**
     * the value of an update counter of a data in the system.
     * @type {number}
     * @memberof WorkloadsSyncInfo
     */
    'updateCount'?: number;
    /**
     * 
     * @type {SupersetWorkload}
     * @memberof WorkloadsSyncInfo
     */
    'workload'?: SupersetWorkload;
}
/**
 * 
 * @export
 * @interface WorkloadsSyncRequest
 */
export interface WorkloadsSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkloadsSyncRequest
     */
    'projectId': string;
    /**
     * 
     * @type {Array<WorkloadSyncFields>}
     * @memberof WorkloadsSyncRequest
     */
    'workloads': Array<WorkloadSyncFields>;
    /**
     * the first workload id to sync. if empty, all workloads before the first one sent will be deleted.
     * @type {string}
     * @memberof WorkloadsSyncRequest
     */
    'from'?: string;
    /**
     * the last workload to sync. if empty, all workloads after the last one sent will be deleted.
     * @type {string}
     * @memberof WorkloadsSyncRequest
     */
    'to'?: string;
    /**
     * workload ids to ignore when deleting.
     * @type {Array<string>}
     * @memberof WorkloadsSyncRequest
     */
    'idsToIgnore'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkloadsSyncResponse
 */
export interface WorkloadsSyncResponse {
    /**
     * 
     * @type {RequestInfo}
     * @memberof WorkloadsSyncResponse
     */
    'requestInfo'?: RequestInfo;
    /**
     * 
     * @type {ResponseInfo}
     * @memberof WorkloadsSyncResponse
     */
    'responseInfo'?: ResponseInfo;
    /**
     * 
     * @type {SystemInfo}
     * @memberof WorkloadsSyncResponse
     */
    'systemInfo'?: SystemInfo;
    /**
     * 
     * @type {Array<WorkloadsSyncInfo>}
     * @memberof WorkloadsSyncResponse
     */
    'workloads'?: Array<WorkloadsSyncInfo>;
}
/**
 * 
 * @export
 * @interface Workspace
 */
export interface Workspace {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof Workspace
     */
    'name': string;
    /**
     * The name as was requested for the workload. If useGivenNameAsPrefix, in the creation request, is false, name and requestedName should be identical. Otherwise, name should be composed of requestedName followed by a suffix of random characters.
     * @type {string}
     * @memberof Workspace
     */
    'requestedName': string;
    /**
     * A unique ID of the workload.
     * @type {string}
     * @memberof Workspace
     */
    'workloadId': string;
    /**
     * The id of the project.
     * @type {string}
     * @memberof Workspace
     */
    'projectId': string;
    /**
     * The id of the department.
     * @type {string}
     * @memberof Workspace
     */
    'departmentId'?: string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof Workspace
     */
    'clusterId': string;
    /**
     * The user who created the workload
     * @type {string}
     * @memberof Workspace
     */
    'createdBy': string;
    /**
     * The creation time of the workload.
     * @type {string}
     * @memberof Workspace
     */
    'createdAt': string;
    /**
     * The deletion time of the workload.
     * @type {string}
     * @memberof Workspace
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {WorkloadDesiredPhase}
     * @memberof Workspace
     */
    'desiredPhase': WorkloadDesiredPhase;
    /**
     * 
     * @type {Phase}
     * @memberof Workspace
     */
    'actualPhase'?: Phase;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof Workspace
     */
    'spec'?: WorkspaceSpecSpec;
}
/**
 * 
 * @export
 * @interface WorkspaceCreationRequest
 */
export interface WorkspaceCreationRequest {
    /**
     * The name of the workload.
     * @type {string}
     * @memberof WorkspaceCreationRequest
     */
    'name': string;
    /**
     * When true, the requested name will be treated as a prefix. The final name of the workload will be composed of the name followed by a random set of characters.
     * @type {boolean}
     * @memberof WorkspaceCreationRequest
     */
    'useGivenNameAsPrefix'?: boolean;
    /**
     * The id of the project.
     * @type {string}
     * @memberof WorkspaceCreationRequest
     */
    'projectId': string;
    /**
     * The id of the cluster.
     * @type {string}
     * @memberof WorkspaceCreationRequest
     */
    'clusterId': string;
    /**
     * A unique ID of the template.
     * @type {string}
     * @memberof WorkspaceCreationRequest
     */
    'templateId'?: string | null;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceCreationRequest
     */
    'spec'?: WorkspaceSpecSpec;
}
/**
 * The specifications of the workspace to be created.
 * @export
 * @interface WorkspaceSpec
 */
export interface WorkspaceSpec {
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceSpec
     */
    'spec'?: WorkspaceSpecSpec;
}
/**
 * 
 * @export
 * @interface WorkspaceSpecSpec
 */
export interface WorkspaceSpecSpec {
    /**
     * A command to the server as the entry point of the container running the workspace.
     * @type {string}
     * @memberof WorkspaceSpecSpec
     */
    'command'?: string | null;
    /**
     * Arguments to the command that the container running the workspace executes.
     * @type {string}
     * @memberof WorkspaceSpecSpec
     */
    'args'?: string | null;
    /**
     * Docker image name. For more information, see [Images](https://kubernetes.io/docs/concepts/containers/images). The image name is mandatory for creating a workspace.
     * @type {string}
     * @memberof WorkspaceSpecSpec
     */
    'image'?: string | null;
    /**
     * 
     * @type {ImagePullPolicy}
     * @memberof WorkspaceSpecSpec
     */
    'imagePullPolicy'?: ImagePullPolicy | null;
    /**
     * Container\'s working directory. If not specified, the container runtime default will be used. This may be configured in the container image.
     * @type {string}
     * @memberof WorkspaceSpecSpec
     */
    'workingDir'?: string | null;
    /**
     * When set to `true`, creates a home directory for the container.
     * @type {boolean}
     * @memberof WorkspaceSpecSpec
     */
    'createHomeDir'?: boolean | null;
    /**
     * 
     * @type {Probes}
     * @memberof WorkspaceSpecSpec
     */
    'probes'?: Probes | null;
    /**
     * Nodes (machines), or a group of nodes on which the workload will run. To use this feature, your Administrator will need to label nodes. For more information, see [Group Nodes](https://docs.run.ai/latest/admin/researcher-setup/limit-to-node-group). When using this flag with with Project-based affinity, it refines the list of allowable node groups set in the Project. For more information, see [Projects](https://docshub.run.ai/guides/platform-management/aiinitiatives/organization/projects).
     * @type {string}
     * @memberof WorkspaceSpecSpec
     */
    'nodeType'?: string | null;
    /**
     * A prioritized list of node pools for the scheduler to run the workspace on. The scheduler will always try to use the first node pool before moving to the next one if the first is not available.
     * @type {Array<string>}
     * @memberof WorkspaceSpecSpec
     */
    'nodePools'?: Array<string> | null;
    /**
     * 
     * @type {PodAffinity}
     * @memberof WorkspaceSpecSpec
     */
    'podAffinity'?: PodAffinity | null;
    /**
     * Whether this container should allocate a TTY for itself, also requires \'stdin\' to be true.
     * @type {boolean}
     * @memberof WorkspaceSpecSpec
     */
    'tty'?: boolean | null;
    /**
     * Whether this container should allocate a buffer for stdin in the container runtime. If this is not set, reads from stdin in the container will always result in EOF
     * @type {boolean}
     * @memberof WorkspaceSpecSpec
     */
    'stdin'?: boolean | null;
    /**
     * Set of environment variables to populate into the container running the workspace.
     * @type {Array<EnvironmentVariable>}
     * @memberof WorkspaceSpecSpec
     */
    'environmentVariables'?: Array<EnvironmentVariable> | null;
    /**
     * Set of annotations to populate into the container running the workspace.
     * @type {Array<Annotation>}
     * @memberof WorkspaceSpecSpec
     */
    'annotations'?: Array<Annotation> | null;
    /**
     * Set of labels to populate into the container running the workspace.
     * @type {Array<Label>}
     * @memberof WorkspaceSpecSpec
     */
    'labels'?: Array<Label> | null;
    /**
     * Set of tolerations to apply to the workload.
     * @type {Array<Toleration>}
     * @memberof WorkspaceSpecSpec
     */
    'tolerations'?: Array<Toleration> | null;
    /**
     * Indicates if the job should be terminated by the system after it has been preempted.
     * @type {boolean}
     * @memberof WorkspaceSpecSpec
     */
    'terminateAfterPreemption'?: boolean | null;
    /**
     * Specifies the duration after which a finished workload (completed or failed) will be automatically deleted. The default is 30 days.
     * @type {number}
     * @memberof WorkspaceSpecSpec
     */
    'autoDeletionTimeAfterCompletionSeconds'?: number | null;
    /**
     * Duration in seconds the pod needs to terminate gracefully upon probe failure. The grace period is the duration in seconds after the processes running in the pod are sent a termination signal and the time when the processes are forcibly halted with a kill signal. Set this value longer than the expected cleanup time for your process. Value must be non-negative integer. The value zero indicates stop immediately via the kill signal (no opportunity to shut down).
     * @type {number}
     * @memberof WorkspaceSpecSpec
     */
    'terminationGracePeriodSeconds'?: number | null;
    /**
     * Specifies the number of retries before marking a workload as failed (not applicable to Inference workloads). The default value is 6.
     * @type {number}
     * @memberof WorkspaceSpecSpec
     */
    'backoffLimit'?: number | null;
    /**
     * 
     * @type {RestartPolicy}
     * @memberof WorkspaceSpecSpec
     */
    'restartPolicy'?: RestartPolicy | null;
    /**
     * Set of container ports that the workload exposes.
     * @type {Array<Port>}
     * @memberof WorkspaceSpecSpec
     */
    'ports'?: Array<Port> | null;
    /**
     * Set of container ports that the workload exposes via URLs.
     * @type {Array<ExposedUrl>}
     * @memberof WorkspaceSpecSpec
     */
    'exposedUrls'?: Array<ExposedUrl> | null;
    /**
     * Set of URLs that are related to the workload.
     * @type {Array<RelatedUrl>}
     * @memberof WorkspaceSpecSpec
     */
    'relatedUrls'?: Array<RelatedUrl> | null;
    /**
     * 
     * @type {PriorityClass}
     * @memberof WorkspaceSpecSpec
     */
    'priorityClass'?: PriorityClass | null;
    /**
     * 
     * @type {ComputeFields}
     * @memberof WorkspaceSpecSpec
     */
    'compute'?: ComputeFields | null;
    /**
     * 
     * @type {StorageFields}
     * @memberof WorkspaceSpecSpec
     */
    'storage'?: StorageFields | null;
    /**
     * 
     * @type {SecurityFlatFields}
     * @memberof WorkspaceSpecSpec
     */
    'security'?: SecurityFlatFields | null;
}
/**
 * 
 * @export
 * @interface WorkspaceTemplate
 */
export interface WorkspaceTemplate {
    /**
     * 
     * @type {TemplateMetaFields}
     * @memberof WorkspaceTemplate
     */
    'meta': TemplateMetaFields;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceTemplate
     */
    'spec'?: WorkspaceSpecSpec;
    /**
     * 
     * @type {RunnableInfo}
     * @memberof WorkspaceTemplate
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceTemplate
     */
    'combinedSpec'?: WorkspaceSpecSpec;
}
/**
 * 
 * @export
 * @interface WorkspaceTemplateAllOf
 */
export interface WorkspaceTemplateAllOf {
    /**
     * 
     * @type {RunnableInfo}
     * @memberof WorkspaceTemplateAllOf
     */
    'runnable'?: RunnableInfo;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceTemplateAllOf
     */
    'combinedSpec'?: WorkspaceSpecSpec;
}
/**
 * 
 * @export
 * @interface WorkspaceTemplateCreationRequest
 */
export interface WorkspaceTemplateCreationRequest {
    /**
     * 
     * @type {TemplateCreationMetaFields}
     * @memberof WorkspaceTemplateCreationRequest
     */
    'meta': TemplateCreationMetaFields;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceTemplateCreationRequest
     */
    'spec'?: WorkspaceSpecSpec;
}
/**
 * 
 * @export
 * @interface WorkspaceTemplatePatchRequest
 */
export interface WorkspaceTemplatePatchRequest {
    /**
     * 
     * @type {TemplatePatchMetaFields}
     * @memberof WorkspaceTemplatePatchRequest
     */
    'meta'?: TemplatePatchMetaFields | null;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceTemplatePatchRequest
     */
    'spec'?: WorkspaceSpecSpec;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkspaceTemplatePatchRequest
     */
    'fieldsToClear'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkspaceTemplateUpdateRequest
 */
export interface WorkspaceTemplateUpdateRequest {
    /**
     * 
     * @type {TemplateUpdateMetaFields}
     * @memberof WorkspaceTemplateUpdateRequest
     */
    'meta': TemplateUpdateMetaFields;
    /**
     * 
     * @type {WorkspaceSpecSpec}
     * @memberof WorkspaceTemplateUpdateRequest
     */
    'spec'?: WorkspaceSpecSpec;
}
/**
 * 
 * @export
 * @interface WorkspaceTemplatesListResponse
 */
export interface WorkspaceTemplatesListResponse {
    /**
     * 
     * @type {Array<WorkspaceTemplate>}
     * @memberof WorkspaceTemplatesListResponse
     */
    'entries'?: Array<WorkspaceTemplate>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof WorkspaceTemplatesListResponse
     */
    'pagination'?: PaginationInfo;
}

/**
 * DistributedApi - axios parameter creator
 * @export
 */
export const DistributedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Use to create a distributed training.
         * @summary Create a distributed training.
         * @param {DistributedCreationRequest} [distributedCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDistributed: async (distributedCreationRequest?: DistributedCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/distributed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distributedCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Use to delete a distributed training by workload id.
         * @summary Delete a distributed training by id.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDistributed: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('deleteDistributed', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/distributed/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a distributed training by workload id.
         * @summary Get distributed training\'s data. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributed: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getDistributed', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/distributed/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve distributed training updates based on an update counter.
         * @summary Get distributed training updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributedUpdates: async (updatesAfter: number, clusterId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('listDistributedUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('listDistributedUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/distributed/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve distributed trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request distributed training updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDistributedUpdates: async (updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('requestDistributedUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('requestDistributedUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/distributed/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resume a distributed training that was suspended using a workload id.
         * @summary Resume a distributed training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeDistributed: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('resumeDistributed', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/distributed/{workloadId}/resume`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suspend a distributed training from running using a workload id.
         * @summary Suspend a distributed training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendDistributed: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('suspendDistributed', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/distributed/{workloadId}/suspend`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DistributedApi - functional programming interface
 * @export
 */
export const DistributedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DistributedApiAxiosParamCreator(configuration)
    return {
        /**
         * Use to create a distributed training.
         * @summary Create a distributed training.
         * @param {DistributedCreationRequest} [distributedCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDistributed(distributedCreationRequest?: DistributedCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedWorkload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDistributed(distributedCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Use to delete a distributed training by workload id.
         * @summary Delete a distributed training by id.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDistributed(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDistributed(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a distributed training by workload id.
         * @summary Get distributed training\'s data. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributed(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedWorkload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributed(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve distributed training updates based on an update counter.
         * @summary Get distributed training updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDistributedUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDistributedUpdates(updatesAfter, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve distributed trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request distributed training updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDistributedUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDistributedUpdates(updatesAfter, clusterId, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resume a distributed training that was suspended using a workload id.
         * @summary Resume a distributed training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeDistributed(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeDistributed(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Suspend a distributed training from running using a workload id.
         * @summary Suspend a distributed training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendDistributed(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendDistributed(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DistributedApi - factory interface
 * @export
 */
export const DistributedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DistributedApiFp(configuration)
    return {
        /**
         * Use to create a distributed training.
         * @summary Create a distributed training.
         * @param {DistributedCreationRequest} [distributedCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDistributed(distributedCreationRequest?: DistributedCreationRequest, options?: any): AxiosPromise<DistributedWorkload> {
            return localVarFp.createDistributed(distributedCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Use to delete a distributed training by workload id.
         * @summary Delete a distributed training by id.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDistributed(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteDistributed(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a distributed training by workload id.
         * @summary Get distributed training\'s data. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributed(workloadId: string, options?: any): AxiosPromise<DistributedWorkload> {
            return localVarFp.getDistributed(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve distributed training updates based on an update counter.
         * @summary Get distributed training updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributedUpdates(updatesAfter: number, clusterId: string, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.listDistributedUpdates(updatesAfter, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve distributed trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request distributed training updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDistributedUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.requestDistributedUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * Resume a distributed training that was suspended using a workload id.
         * @summary Resume a distributed training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeDistributed(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.resumeDistributed(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspend a distributed training from running using a workload id.
         * @summary Suspend a distributed training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendDistributed(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.suspendDistributed(workloadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DistributedApi - object-oriented interface
 * @export
 * @class DistributedApi
 * @extends {BaseAPI}
 */
export class DistributedApi extends BaseAPI {
    /**
     * Use to create a distributed training.
     * @summary Create a distributed training.
     * @param {DistributedCreationRequest} [distributedCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributedApi
     */
    public createDistributed(distributedCreationRequest?: DistributedCreationRequest, options?: AxiosRequestConfig) {
        return DistributedApiFp(this.configuration).createDistributed(distributedCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Use to delete a distributed training by workload id.
     * @summary Delete a distributed training by id.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributedApi
     */
    public deleteDistributed(workloadId: string, options?: AxiosRequestConfig) {
        return DistributedApiFp(this.configuration).deleteDistributed(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a distributed training by workload id.
     * @summary Get distributed training\'s data. [Experimental]
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributedApi
     */
    public getDistributed(workloadId: string, options?: AxiosRequestConfig) {
        return DistributedApiFp(this.configuration).getDistributed(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve distributed training updates based on an update counter.
     * @summary Get distributed training updates.
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributedApi
     */
    public listDistributedUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig) {
        return DistributedApiFp(this.configuration).listDistributedUpdates(updatesAfter, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve distributed trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
     * @summary Request distributed training updates
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributedApi
     */
    public requestDistributedUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return DistributedApiFp(this.configuration).requestDistributedUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resume a distributed training that was suspended using a workload id.
     * @summary Resume a distributed training.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributedApi
     */
    public resumeDistributed(workloadId: string, options?: AxiosRequestConfig) {
        return DistributedApiFp(this.configuration).resumeDistributed(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suspend a distributed training from running using a workload id.
     * @summary Suspend a distributed training.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DistributedApi
     */
    public suspendDistributed(workloadId: string, options?: AxiosRequestConfig) {
        return DistributedApiFp(this.configuration).suspendDistributed(workloadId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all the revision events using a revision id. Supported for clusters v2.21+.
         * @summary Get revision events by id. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevisionEvents: async (revisionId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('getRevisionEvents', 'revisionId', revisionId)
            const localVarPath = `/api/v1/workloads/inferences/revisions/{revisionId}/events`
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve revision history details, including events, using a revision id. Supported for clusters v2.21+.
         * @summary Get the revision history. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevisionHistory: async (revisionId: string, offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('getRevisionHistory', 'revisionId', revisionId)
            const localVarPath = `/api/v1/workloads/inferences/revisions/{revisionId}/history`
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all the workload events using a workload id.
         * @summary Get the workload events.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadEvents: async (workloadId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkloadEvents', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/{workloadId}/events`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve workload history details, including events, using a workload id.
         * @summary Get the workload history.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadHistory: async (workloadId: string, offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkloadHistory', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/{workloadId}/history`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync events.
         * @param {EventsSyncRequest} [eventsSyncRequest] The events to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEvents: async (eventsSyncRequest?: EventsSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all the revision events using a revision id. Supported for clusters v2.21+.
         * @summary Get revision events by id. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevisionEvents(revisionId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkloadEvents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevisionEvents(revisionId, offset, limit, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve revision history details, including events, using a revision id. Supported for clusters v2.21+.
         * @summary Get the revision history. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevisionHistory(revisionId: string, offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkloadHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevisionHistory(revisionId, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve all the workload events using a workload id.
         * @summary Get the workload events.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloadEvents(workloadId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkloadEvents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloadEvents(workloadId, offset, limit, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve workload history details, including events, using a workload id.
         * @summary Get the workload history.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloadHistory(workloadId: string, offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkloadHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloadHistory(workloadId, offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync events.
         * @param {EventsSyncRequest} [eventsSyncRequest] The events to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncEvents(eventsSyncRequest?: EventsSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncEvents(eventsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * Retrieve all the revision events using a revision id. Supported for clusters v2.21+.
         * @summary Get revision events by id. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevisionEvents(revisionId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options?: any): AxiosPromise<GetWorkloadEvents200Response> {
            return localVarFp.getRevisionEvents(revisionId, offset, limit, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve revision history details, including events, using a revision id. Supported for clusters v2.21+.
         * @summary Get the revision history. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevisionHistory(revisionId: string, offset?: number, limit?: number, options?: any): AxiosPromise<GetWorkloadHistory200Response> {
            return localVarFp.getRevisionHistory(revisionId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all the workload events using a workload id.
         * @summary Get the workload events.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadEvents(workloadId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options?: any): AxiosPromise<GetWorkloadEvents200Response> {
            return localVarFp.getWorkloadEvents(workloadId, offset, limit, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve workload history details, including events, using a workload id.
         * @summary Get the workload history.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadHistory(workloadId: string, offset?: number, limit?: number, options?: any): AxiosPromise<GetWorkloadHistory200Response> {
            return localVarFp.getWorkloadHistory(workloadId, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync events.
         * @param {EventsSyncRequest} [eventsSyncRequest] The events to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEvents(eventsSyncRequest?: EventsSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.syncEvents(eventsSyncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * Retrieve all the revision events using a revision id. Supported for clusters v2.21+.
     * @summary Get revision events by id. [Experimental]
     * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getRevisionEvents(revisionId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getRevisionEvents(revisionId, offset, limit, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve revision history details, including events, using a revision id. Supported for clusters v2.21+.
     * @summary Get the revision history. [Experimental]
     * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getRevisionHistory(revisionId: string, offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getRevisionHistory(revisionId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all the workload events using a workload id.
     * @summary Get the workload events.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getWorkloadEvents(workloadId: string, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getWorkloadEvents(workloadId, offset, limit, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve workload history details, including events, using a workload id.
     * @summary Get the workload history.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getWorkloadHistory(workloadId: string, offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).getWorkloadHistory(workloadId, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync events.
     * @param {EventsSyncRequest} [eventsSyncRequest] The events to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public syncEvents(eventsSyncRequest?: EventsSyncRequest, options?: AxiosRequestConfig) {
        return EventsApiFp(this.configuration).syncEvents(eventsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary health check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: any): AxiosPromise<void> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health(options?: AxiosRequestConfig) {
        return HealthApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InferencesApi - axios parameter creator
 * @export
 */
export const InferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an inference using container related fields.
         * @summary Create an inference.
         * @param {InferenceCreationRequest} [inferenceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInference: async (inferenceCreationRequest?: InferenceCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/inferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferenceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an inference using a workload id.
         * @summary Delete an inference.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInference: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('deleteInference', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/inferences/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve inference details using a workload id.
         * @summary Get inference data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInference: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getInference', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/inferences/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the inference or revision ancestors.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceAncestors: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getInferenceAncestors', 'workloadId', workloadId)
            const localVarPath = `/internal/workloads/inferences/{workloadId}/ancestors`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve inference metrics data by id. Supported from control-plane version 2.18 or later.
         * @summary Get inference metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {Array<InferenceWorkloadMetricType>} metricType Specify which data to request.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceWorkloadMetrics: async (workloadId: string, metricType: Array<InferenceWorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getInferenceWorkloadMetrics', 'workloadId', workloadId)
            // verify required parameter 'metricType' is not null or undefined
            assertParamExists('getInferenceWorkloadMetrics', 'metricType', metricType)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getInferenceWorkloadMetrics', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getInferenceWorkloadMetrics', 'end', end)
            const localVarPath = `/api/v1/workloads/inferences/{workloadId}/metrics`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricType) {
                localVarQueryParameter['metricType'] = metricType.join(COLLECTION_FORMATS.csv);
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (numberOfSamples !== undefined) {
                localVarQueryParameter['numberOfSamples'] = numberOfSamples;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve inference metrics pod\'s data by workload and pod id. Supported from control-plane version 2.18 or later.
         * @summary Get inference pod\'s metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {string} podId The requested pod id.
         * @param {Array<InferencePodMetricType>} metricType Specifies metrics data to request. Inference metrics are only available for inference workloads.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceWorkloadPodMetrics: async (workloadId: string, podId: string, metricType: Array<InferencePodMetricType>, start: string, end: string, numberOfSamples?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getInferenceWorkloadPodMetrics', 'workloadId', workloadId)
            // verify required parameter 'podId' is not null or undefined
            assertParamExists('getInferenceWorkloadPodMetrics', 'podId', podId)
            // verify required parameter 'metricType' is not null or undefined
            assertParamExists('getInferenceWorkloadPodMetrics', 'metricType', metricType)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getInferenceWorkloadPodMetrics', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getInferenceWorkloadPodMetrics', 'end', end)
            const localVarPath = `/api/v1/workloads/inferences/{workloadId}/pods/{podId}/metrics`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)))
                .replace(`{${"podId"}}`, encodeURIComponent(String(podId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricType) {
                localVarQueryParameter['metricType'] = metricType.join(COLLECTION_FORMATS.csv);
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (numberOfSamples !== undefined) {
                localVarQueryParameter['numberOfSamples'] = numberOfSamples;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve inferences that were updated.
         * @summary List inference updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInferencesUpdates: async (updatesAfter: number, clusterId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('listInferencesUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('listInferencesUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/inferences/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve inference workloads that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request inference updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestInferencesUpdates: async (updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('requestInferencesUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('requestInferencesUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/inferences/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the specification of an existing inference workload.
         * @summary Update inference spec. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {InferenceUpdateRequest} [inferenceUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInferenceSpec: async (workloadId: string, inferenceUpdateRequest?: InferenceUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('updateInferenceSpec', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/inferences/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferenceUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InferencesApi - functional programming interface
 * @export
 */
export const InferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an inference using container related fields.
         * @summary Create an inference.
         * @param {InferenceCreationRequest} [inferenceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInference(inferenceCreationRequest?: InferenceCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInference(inferenceCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete an inference using a workload id.
         * @summary Delete an inference.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInference(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInference(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve inference details using a workload id.
         * @summary Get inference data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInference(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInference(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the inference or revision ancestors.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceAncestors(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ancestors>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceAncestors(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve inference metrics data by id. Supported from control-plane version 2.18 or later.
         * @summary Get inference metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {Array<InferenceWorkloadMetricType>} metricType Specify which data to request.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceWorkloadMetrics(workloadId: string, metricType: Array<InferenceWorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceWorkloadMetrics(workloadId, metricType, start, end, numberOfSamples, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve inference metrics pod\'s data by workload and pod id. Supported from control-plane version 2.18 or later.
         * @summary Get inference pod\'s metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {string} podId The requested pod id.
         * @param {Array<InferencePodMetricType>} metricType Specifies metrics data to request. Inference metrics are only available for inference workloads.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceWorkloadPodMetrics(workloadId: string, podId: string, metricType: Array<InferencePodMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceWorkloadPodMetrics(workloadId, podId, metricType, start, end, numberOfSamples, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve inferences that were updated.
         * @summary List inference updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInferencesUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInferencesUpdates(updatesAfter, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve inference workloads that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request inference updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestInferencesUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestInferencesUpdates(updatesAfter, clusterId, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the specification of an existing inference workload.
         * @summary Update inference spec. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {InferenceUpdateRequest} [inferenceUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInferenceSpec(workloadId: string, inferenceUpdateRequest?: InferenceUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInferenceSpec(workloadId, inferenceUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InferencesApi - factory interface
 * @export
 */
export const InferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InferencesApiFp(configuration)
    return {
        /**
         * Create an inference using container related fields.
         * @summary Create an inference.
         * @param {InferenceCreationRequest} [inferenceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInference(inferenceCreationRequest?: InferenceCreationRequest, options?: any): AxiosPromise<Inference> {
            return localVarFp.createInference(inferenceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an inference using a workload id.
         * @summary Delete an inference.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInference(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteInference(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve inference details using a workload id.
         * @summary Get inference data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInference(workloadId: string, options?: any): AxiosPromise<Inference> {
            return localVarFp.getInference(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the inference or revision ancestors.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceAncestors(workloadId: string, options?: any): AxiosPromise<Ancestors> {
            return localVarFp.getInferenceAncestors(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve inference metrics data by id. Supported from control-plane version 2.18 or later.
         * @summary Get inference metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {Array<InferenceWorkloadMetricType>} metricType Specify which data to request.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceWorkloadMetrics(workloadId: string, metricType: Array<InferenceWorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options?: any): AxiosPromise<MetricsResponse> {
            return localVarFp.getInferenceWorkloadMetrics(workloadId, metricType, start, end, numberOfSamples, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve inference metrics pod\'s data by workload and pod id. Supported from control-plane version 2.18 or later.
         * @summary Get inference pod\'s metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {string} podId The requested pod id.
         * @param {Array<InferencePodMetricType>} metricType Specifies metrics data to request. Inference metrics are only available for inference workloads.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceWorkloadPodMetrics(workloadId: string, podId: string, metricType: Array<InferencePodMetricType>, start: string, end: string, numberOfSamples?: number, options?: any): AxiosPromise<MetricsResponse> {
            return localVarFp.getInferenceWorkloadPodMetrics(workloadId, podId, metricType, start, end, numberOfSamples, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve inferences that were updated.
         * @summary List inference updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInferencesUpdates(updatesAfter: number, clusterId: string, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.listInferencesUpdates(updatesAfter, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve inference workloads that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request inference updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestInferencesUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.requestInferencesUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the specification of an existing inference workload.
         * @summary Update inference spec. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {InferenceUpdateRequest} [inferenceUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInferenceSpec(workloadId: string, inferenceUpdateRequest?: InferenceUpdateRequest, options?: any): AxiosPromise<Inference> {
            return localVarFp.updateInferenceSpec(workloadId, inferenceUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InferencesApi - object-oriented interface
 * @export
 * @class InferencesApi
 * @extends {BaseAPI}
 */
export class InferencesApi extends BaseAPI {
    /**
     * Create an inference using container related fields.
     * @summary Create an inference.
     * @param {InferenceCreationRequest} [inferenceCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public createInference(inferenceCreationRequest?: InferenceCreationRequest, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).createInference(inferenceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an inference using a workload id.
     * @summary Delete an inference.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public deleteInference(workloadId: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).deleteInference(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve inference details using a workload id.
     * @summary Get inference data.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getInference(workloadId: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getInference(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the inference or revision ancestors.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getInferenceAncestors(workloadId: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getInferenceAncestors(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve inference metrics data by id. Supported from control-plane version 2.18 or later.
     * @summary Get inference metrics data.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {Array<InferenceWorkloadMetricType>} metricType Specify which data to request.
     * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
     * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
     * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getInferenceWorkloadMetrics(workloadId: string, metricType: Array<InferenceWorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getInferenceWorkloadMetrics(workloadId, metricType, start, end, numberOfSamples, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve inference metrics pod\'s data by workload and pod id. Supported from control-plane version 2.18 or later.
     * @summary Get inference pod\'s metrics data.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {string} podId The requested pod id.
     * @param {Array<InferencePodMetricType>} metricType Specifies metrics data to request. Inference metrics are only available for inference workloads.
     * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
     * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
     * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public getInferenceWorkloadPodMetrics(workloadId: string, podId: string, metricType: Array<InferencePodMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).getInferenceWorkloadPodMetrics(workloadId, podId, metricType, start, end, numberOfSamples, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve inferences that were updated.
     * @summary List inference updates.
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public listInferencesUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).listInferencesUpdates(updatesAfter, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve inference workloads that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
     * @summary Request inference updates
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public requestInferencesUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).requestInferencesUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the specification of an existing inference workload.
     * @summary Update inference spec. [Experimental]
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {InferenceUpdateRequest} [inferenceUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InferencesApi
     */
    public updateInferenceSpec(workloadId: string, inferenceUpdateRequest?: InferenceUpdateRequest, options?: AxiosRequestConfig) {
        return InferencesApiFp(this.configuration).updateInferenceSpec(workloadId, inferenceUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PodGroupsApi - axios parameter creator
 * @export
 */
export const PodGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sync pod groups.
         * @param {PodGroupsSyncRequest} [podGroupsSyncRequest] The pod groups to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPodGroups: async (podGroupsSyncRequest?: PodGroupsSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/podgroups/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(podGroupsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PodGroupsApi - functional programming interface
 * @export
 */
export const PodGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PodGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sync pod groups.
         * @param {PodGroupsSyncRequest} [podGroupsSyncRequest] The pod groups to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPodGroups(podGroupsSyncRequest?: PodGroupsSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPodGroups(podGroupsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PodGroupsApi - factory interface
 * @export
 */
export const PodGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PodGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Sync pod groups.
         * @param {PodGroupsSyncRequest} [podGroupsSyncRequest] The pod groups to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPodGroups(podGroupsSyncRequest?: PodGroupsSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.syncPodGroups(podGroupsSyncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PodGroupsApi - object-oriented interface
 * @export
 * @class PodGroupsApi
 * @extends {BaseAPI}
 */
export class PodGroupsApi extends BaseAPI {
    /**
     * 
     * @summary Sync pod groups.
     * @param {PodGroupsSyncRequest} [podGroupsSyncRequest] The pod groups to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodGroupsApi
     */
    public syncPodGroups(podGroupsSyncRequest?: PodGroupsSyncRequest, options?: AxiosRequestConfig) {
        return PodGroupsApiFp(this.configuration).syncPodGroups(podGroupsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PodsApi - axios parameter creator
 * @export
 */
export const PodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the number of pods from a cluster.
         * @summary Get pods count.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPods: async (deleted?: boolean, filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/pods/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a pod as it does not exist in the cluster anymore.
         * @param {string} podId The requested pod id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePod: async (podId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'podId' is not null or undefined
            assertParamExists('deletePod', 'podId', podId)
            const localVarPath = `/api/v1/workloads/pods/{podId}`
                .replace(`{${"podId"}}`, encodeURIComponent(String(podId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of revision pods by revision id. Supported for clusters v2.21+.
         * @summary Get revision pods by id. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevisionPods: async (revisionId: string, deleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('getRevisionPods', 'revisionId', revisionId)
            const localVarPath = `/api/v1/workloads/inferences/revisions/{revisionId}/pods`
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve pod\'s metrics data for use in analysis applications.
         * @summary Get pod metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {string} podId The requested pod id.
         * @param {Array<PodMetricType>} metricType Specify which metric data to request. Advanced GPU metrics are only supported if the \&#39;Advanced GPU Metrics\&#39; feature flag in the settings is enabled.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadPodMetrics: async (workloadId: string, podId: string, metricType: Array<PodMetricType>, start: string, end: string, numberOfSamples?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkloadPodMetrics', 'workloadId', workloadId)
            // verify required parameter 'podId' is not null or undefined
            assertParamExists('getWorkloadPodMetrics', 'podId', podId)
            // verify required parameter 'metricType' is not null or undefined
            assertParamExists('getWorkloadPodMetrics', 'metricType', metricType)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getWorkloadPodMetrics', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getWorkloadPodMetrics', 'end', end)
            const localVarPath = `/api/v1/workloads/{workloadId}/pods/{podId}/metrics`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)))
                .replace(`{${"podId"}}`, encodeURIComponent(String(podId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricType) {
                localVarQueryParameter['metricType'] = metricType.join(COLLECTION_FORMATS.csv);
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (numberOfSamples !== undefined) {
                localVarQueryParameter['numberOfSamples'] = numberOfSamples;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of workload pods by workload id.
         * @summary Get workload pods by id.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadPods: async (workloadId: string, deleted?: boolean, offset?: number, limit?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkloadPods', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/{workloadId}/pods`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync pods.
         * @param {InternalPodsSyncRequest} [internalPodsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSyncPods: async (internalPodsSyncRequest?: InternalPodsSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/workloads/pods/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalPodsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of pods from a cluster.
         * @summary List pods.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt'} [sortBy] Sort results using a parameter.
         * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {PodVerbosity} [verbosity] response verbosity level. if full, the response includes workloadName and projectName fields. 
         * @param {string} [completed] Return only completed resources when \&#39;true\&#39;, return only non-completed resources when \&#39;false\&#39;. By default, or when empty, returns all resources.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPods: async (deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt', filterBy?: Array<string>, verbosity?: PodVerbosity, completed?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/pods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (verbosity !== undefined) {
                localVarQueryParameter['verbosity'] = verbosity;
            }

            if (completed !== undefined) {
                localVarQueryParameter['completed'] = completed;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync workloads pods.
         * @param {Array<WorkloadPodsSyncRequest>} [workloadPodsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPods: async (workloadPodsSyncRequest?: Array<WorkloadPodsSyncRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/pods/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadPodsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync workloads pods.
         * @param {PodsSyncRequest} [podsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWorkloadsPods: async (podsSyncRequest?: PodsSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/pods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(podsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert a single pod info from the cluster.
         * @param {string} podId The requested pod id.
         * @param {PodSyncFields} podSyncFields The pod info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPod: async (podId: string, podSyncFields: PodSyncFields, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'podId' is not null or undefined
            assertParamExists('upsertPod', 'podId', podId)
            // verify required parameter 'podSyncFields' is not null or undefined
            assertParamExists('upsertPod', 'podSyncFields', podSyncFields)
            const localVarPath = `/api/v1/workloads/pods/{podId}`
                .replace(`{${"podId"}}`, encodeURIComponent(String(podId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(podSyncFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PodsApi - functional programming interface
 * @export
 */
export const PodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PodsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the number of pods from a cluster.
         * @summary Get pods count.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPods(deleted?: boolean, filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountWorkloads200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPods(deleted, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a pod as it does not exist in the cluster anymore.
         * @param {string} podId The requested pod id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePod(podId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePod(podId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of revision pods by revision id. Supported for clusters v2.21+.
         * @summary Get revision pods by id. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevisionPods(revisionId: string, deleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRevisionPods200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevisionPods(revisionId, deleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve pod\'s metrics data for use in analysis applications.
         * @summary Get pod metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {string} podId The requested pod id.
         * @param {Array<PodMetricType>} metricType Specify which metric data to request. Advanced GPU metrics are only supported if the \&#39;Advanced GPU Metrics\&#39; feature flag in the settings is enabled.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloadPodMetrics(workloadId: string, podId: string, metricType: Array<PodMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloadPodMetrics(workloadId, podId, metricType, start, end, numberOfSamples, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of workload pods by workload id.
         * @summary Get workload pods by id.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloadPods(workloadId: string, deleted?: boolean, offset?: number, limit?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPods200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloadPods(workloadId, deleted, offset, limit, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync pods.
         * @param {InternalPodsSyncRequest} [internalPodsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalSyncPods(internalPodsSyncRequest?: InternalPodsSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalSyncPods(internalPodsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of pods from a cluster.
         * @summary List pods.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt'} [sortBy] Sort results using a parameter.
         * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {PodVerbosity} [verbosity] response verbosity level. if full, the response includes workloadName and projectName fields. 
         * @param {string} [completed] Return only completed resources when \&#39;true\&#39;, return only non-completed resources when \&#39;false\&#39;. By default, or when empty, returns all resources.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPods(deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt', filterBy?: Array<string>, verbosity?: PodVerbosity, completed?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPods200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPods(deleted, offset, limit, sortOrder, sortBy, filterBy, verbosity, completed, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync workloads pods.
         * @param {Array<WorkloadPodsSyncRequest>} [workloadPodsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncPods(workloadPodsSyncRequest?: Array<WorkloadPodsSyncRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncPods(workloadPodsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync workloads pods.
         * @param {PodsSyncRequest} [podsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncWorkloadsPods(podsSyncRequest?: PodsSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncWorkloadsPods(podsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upsert a single pod info from the cluster.
         * @param {string} podId The requested pod id.
         * @param {PodSyncFields} podSyncFields The pod info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertPod(podId: string, podSyncFields: PodSyncFields, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertPod(podId, podSyncFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PodsApi - factory interface
 * @export
 */
export const PodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PodsApiFp(configuration)
    return {
        /**
         * Retrieve the number of pods from a cluster.
         * @summary Get pods count.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPods(deleted?: boolean, filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<CountWorkloads200Response> {
            return localVarFp.countPods(deleted, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a pod as it does not exist in the cluster anymore.
         * @param {string} podId The requested pod id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePod(podId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePod(podId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of revision pods by revision id. Supported for clusters v2.21+.
         * @summary Get revision pods by id. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevisionPods(revisionId: string, deleted?: boolean, options?: any): AxiosPromise<GetRevisionPods200Response> {
            return localVarFp.getRevisionPods(revisionId, deleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve pod\'s metrics data for use in analysis applications.
         * @summary Get pod metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {string} podId The requested pod id.
         * @param {Array<PodMetricType>} metricType Specify which metric data to request. Advanced GPU metrics are only supported if the \&#39;Advanced GPU Metrics\&#39; feature flag in the settings is enabled.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadPodMetrics(workloadId: string, podId: string, metricType: Array<PodMetricType>, start: string, end: string, numberOfSamples?: number, options?: any): AxiosPromise<MetricsResponse> {
            return localVarFp.getWorkloadPodMetrics(workloadId, podId, metricType, start, end, numberOfSamples, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of workload pods by workload id.
         * @summary Get workload pods by id.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadPods(workloadId: string, deleted?: boolean, offset?: number, limit?: number, search?: string, options?: any): AxiosPromise<ListPods200Response> {
            return localVarFp.getWorkloadPods(workloadId, deleted, offset, limit, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync pods.
         * @param {InternalPodsSyncRequest} [internalPodsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSyncPods(internalPodsSyncRequest?: InternalPodsSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.internalSyncPods(internalPodsSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of pods from a cluster.
         * @summary List pods.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt'} [sortBy] Sort results using a parameter.
         * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {PodVerbosity} [verbosity] response verbosity level. if full, the response includes workloadName and projectName fields. 
         * @param {string} [completed] Return only completed resources when \&#39;true\&#39;, return only non-completed resources when \&#39;false\&#39;. By default, or when empty, returns all resources.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPods(deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt', filterBy?: Array<string>, verbosity?: PodVerbosity, completed?: string, search?: string, options?: any): AxiosPromise<ListPods200Response> {
            return localVarFp.listPods(deleted, offset, limit, sortOrder, sortBy, filterBy, verbosity, completed, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync workloads pods.
         * @param {Array<WorkloadPodsSyncRequest>} [workloadPodsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncPods(workloadPodsSyncRequest?: Array<WorkloadPodsSyncRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.syncPods(workloadPodsSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync workloads pods.
         * @param {PodsSyncRequest} [podsSyncRequest] The pods to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWorkloadsPods(podsSyncRequest?: PodsSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.syncWorkloadsPods(podsSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert a single pod info from the cluster.
         * @param {string} podId The requested pod id.
         * @param {PodSyncFields} podSyncFields The pod info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertPod(podId: string, podSyncFields: PodSyncFields, options?: any): AxiosPromise<void> {
            return localVarFp.upsertPod(podId, podSyncFields, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PodsApi - object-oriented interface
 * @export
 * @class PodsApi
 * @extends {BaseAPI}
 */
export class PodsApi extends BaseAPI {
    /**
     * Retrieve the number of pods from a cluster.
     * @summary Get pods count.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public countPods(deleted?: boolean, filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).countPods(deleted, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a pod as it does not exist in the cluster anymore.
     * @param {string} podId The requested pod id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public deletePod(podId: string, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).deletePod(podId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of revision pods by revision id. Supported for clusters v2.21+.
     * @summary Get revision pods by id. [Experimental]
     * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public getRevisionPods(revisionId: string, deleted?: boolean, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).getRevisionPods(revisionId, deleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve pod\'s metrics data for use in analysis applications.
     * @summary Get pod metrics data.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {string} podId The requested pod id.
     * @param {Array<PodMetricType>} metricType Specify which metric data to request. Advanced GPU metrics are only supported if the \&#39;Advanced GPU Metrics\&#39; feature flag in the settings is enabled.
     * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
     * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
     * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public getWorkloadPodMetrics(workloadId: string, podId: string, metricType: Array<PodMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).getWorkloadPodMetrics(workloadId, podId, metricType, start, end, numberOfSamples, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of workload pods by workload id.
     * @summary Get workload pods by id.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public getWorkloadPods(workloadId: string, deleted?: boolean, offset?: number, limit?: number, search?: string, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).getWorkloadPods(workloadId, deleted, offset, limit, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync pods.
     * @param {InternalPodsSyncRequest} [internalPodsSyncRequest] The pods to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public internalSyncPods(internalPodsSyncRequest?: InternalPodsSyncRequest, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).internalSyncPods(internalPodsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of pods from a cluster.
     * @summary List pods.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt'} [sortBy] Sort results using a parameter.
     * @param {Array<string>} [filterBy] Filter results using a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contains, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {PodVerbosity} [verbosity] response verbosity level. if full, the response includes workloadName and projectName fields. 
     * @param {string} [completed] Return only completed resources when \&#39;true\&#39;, return only non-completed resources when \&#39;false\&#39;. By default, or when empty, returns all resources.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public listPods(deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'clusterId' | 'workloadId' | 'revisionId' | 'nodeName' | 'currentNodepool' | 'createdAt' | 'completedAt' | 'deletedAt', filterBy?: Array<string>, verbosity?: PodVerbosity, completed?: string, search?: string, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).listPods(deleted, offset, limit, sortOrder, sortBy, filterBy, verbosity, completed, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync workloads pods.
     * @param {Array<WorkloadPodsSyncRequest>} [workloadPodsSyncRequest] The pods to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public syncPods(workloadPodsSyncRequest?: Array<WorkloadPodsSyncRequest>, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).syncPods(workloadPodsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync workloads pods.
     * @param {PodsSyncRequest} [podsSyncRequest] The pods to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public syncWorkloadsPods(podsSyncRequest?: PodsSyncRequest, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).syncWorkloadsPods(podsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert a single pod info from the cluster.
     * @param {string} podId The requested pod id.
     * @param {PodSyncFields} podSyncFields The pod info in the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodsApi
     */
    public upsertPod(podId: string, podSyncFields: PodSyncFields, options?: AxiosRequestConfig) {
        return PodsApiFp(this.configuration).upsertPod(podId, podSyncFields, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RevisionsApi - axios parameter creator
 * @export
 */
export const RevisionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the number of an inference workload revisions from a cluster. Supported for clusters v2.21+.
         * @summary Get inference workload revisions count. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countInferenceWorkloadRevisions: async (workloadId: string, deleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('countInferenceWorkloadRevisions', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/inferences/{workloadId}/revisions/count`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a revision using a revision id.
         * @summary Delete a revision.
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRevision: async (revisionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('deleteRevision', 'revisionId', revisionId)
            const localVarPath = `/api/v1/workloads/inferences/revisions/{revisionId}`
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of inference workload revisions by workload id. Supported for clusters v2.21+.
         * @summary Get inference workload revisions by id. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceWorkloadRevisions: async (workloadId: string, deleted?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getInferenceWorkloadRevisions', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/inferences/{workloadId}/revisions`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve revision details using a revision id. Supported for clusters v2.21+.
         * @summary Get revision data. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevision: async (revisionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revisionId' is not null or undefined
            assertParamExists('getRevision', 'revisionId', revisionId)
            const localVarPath = `/api/v1/workloads/inferences/revisions/{revisionId}`
                .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync revisions.
         * @param {RevisionsSyncRequest} [revisionsSyncRequest] The revisions to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRevisions: async (revisionsSyncRequest?: RevisionsSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/inferences/revisions/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revisionsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RevisionsApi - functional programming interface
 * @export
 */
export const RevisionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RevisionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the number of an inference workload revisions from a cluster. Supported for clusters v2.21+.
         * @summary Get inference workload revisions count. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countInferenceWorkloadRevisions(workloadId: string, deleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountWorkloads200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countInferenceWorkloadRevisions(workloadId, deleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a revision using a revision id.
         * @summary Delete a revision.
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRevision(revisionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRevision(revisionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of inference workload revisions by workload id. Supported for clusters v2.21+.
         * @summary Get inference workload revisions by id. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceWorkloadRevisions(workloadId: string, deleted?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInferenceWorkloadRevisions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceWorkloadRevisions(workloadId, deleted, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve revision details using a revision id. Supported for clusters v2.21+.
         * @summary Get revision data. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevision(revisionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Revision>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevision(revisionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync revisions.
         * @param {RevisionsSyncRequest} [revisionsSyncRequest] The revisions to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncRevisions(revisionsSyncRequest?: RevisionsSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncRevisions(revisionsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RevisionsApi - factory interface
 * @export
 */
export const RevisionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RevisionsApiFp(configuration)
    return {
        /**
         * Retrieve the number of an inference workload revisions from a cluster. Supported for clusters v2.21+.
         * @summary Get inference workload revisions count. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countInferenceWorkloadRevisions(workloadId: string, deleted?: boolean, options?: any): AxiosPromise<CountWorkloads200Response> {
            return localVarFp.countInferenceWorkloadRevisions(workloadId, deleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a revision using a revision id.
         * @summary Delete a revision.
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRevision(revisionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRevision(revisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of inference workload revisions by workload id. Supported for clusters v2.21+.
         * @summary Get inference workload revisions by id. [Experimental]
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceWorkloadRevisions(workloadId: string, deleted?: boolean, options?: any): AxiosPromise<GetInferenceWorkloadRevisions200Response> {
            return localVarFp.getInferenceWorkloadRevisions(workloadId, deleted, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve revision details using a revision id. Supported for clusters v2.21+.
         * @summary Get revision data. [Experimental]
         * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevision(revisionId: string, options?: any): AxiosPromise<Revision> {
            return localVarFp.getRevision(revisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync revisions.
         * @param {RevisionsSyncRequest} [revisionsSyncRequest] The revisions to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncRevisions(revisionsSyncRequest?: RevisionsSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.syncRevisions(revisionsSyncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RevisionsApi - object-oriented interface
 * @export
 * @class RevisionsApi
 * @extends {BaseAPI}
 */
export class RevisionsApi extends BaseAPI {
    /**
     * Retrieve the number of an inference workload revisions from a cluster. Supported for clusters v2.21+.
     * @summary Get inference workload revisions count. [Experimental]
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevisionsApi
     */
    public countInferenceWorkloadRevisions(workloadId: string, deleted?: boolean, options?: AxiosRequestConfig) {
        return RevisionsApiFp(this.configuration).countInferenceWorkloadRevisions(workloadId, deleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a revision using a revision id.
     * @summary Delete a revision.
     * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevisionsApi
     */
    public deleteRevision(revisionId: string, options?: AxiosRequestConfig) {
        return RevisionsApiFp(this.configuration).deleteRevision(revisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of inference workload revisions by workload id. Supported for clusters v2.21+.
     * @summary Get inference workload revisions by id. [Experimental]
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevisionsApi
     */
    public getInferenceWorkloadRevisions(workloadId: string, deleted?: boolean, options?: AxiosRequestConfig) {
        return RevisionsApiFp(this.configuration).getInferenceWorkloadRevisions(workloadId, deleted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve revision details using a revision id. Supported for clusters v2.21+.
     * @summary Get revision data. [Experimental]
     * @param {string} revisionId The  Universally Unique Identifier (UUID) of the revision.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevisionsApi
     */
    public getRevision(revisionId: string, options?: AxiosRequestConfig) {
        return RevisionsApiFp(this.configuration).getRevision(revisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync revisions.
     * @param {RevisionsSyncRequest} [revisionsSyncRequest] The revisions to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RevisionsApi
     */
    public syncRevisions(revisionsSyncRequest?: RevisionsSyncRequest, options?: AxiosRequestConfig) {
        return RevisionsApiFp(this.configuration).syncRevisions(revisionsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrainingsApi - axios parameter creator
 * @export
 */
export const TrainingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a training workload using container related fields.
         * @summary Create a training.
         * @param {TrainingCreationRequest} [trainingCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraining: async (trainingCreationRequest?: TrainingCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a training using a workload id.
         * @summary Delete a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTraining: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('deleteTraining', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/trainings/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve training details using a workload id.
         * @summary Get training data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraining: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getTraining', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/trainings/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve trainings that were updated.
         * @summary List training updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingsUpdates: async (updatesAfter: number, clusterId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('listTrainingsUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('listTrainingsUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/trainings/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request training updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTrainingsUpdates: async (updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('requestTrainingsUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('requestTrainingsUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/trainings/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resume a training that was suspended using a workload id.
         * @summary Resume a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeTraining: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('resumeTraining', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/trainings/{workloadId}/resume`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suspend a training from running using a workload id.
         * @summary Suspend a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendTraining: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('suspendTraining', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/trainings/{workloadId}/suspend`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrainingsApi - functional programming interface
 * @export
 */
export const TrainingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrainingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a training workload using container related fields.
         * @summary Create a training.
         * @param {TrainingCreationRequest} [trainingCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTraining(trainingCreationRequest?: TrainingCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Training>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTraining(trainingCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a training using a workload id.
         * @summary Delete a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTraining(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTraining(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve training details using a workload id.
         * @summary Get training data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTraining(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Training>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTraining(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve trainings that were updated.
         * @summary List training updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrainingsUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrainingsUpdates(updatesAfter, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request training updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestTrainingsUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestTrainingsUpdates(updatesAfter, clusterId, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resume a training that was suspended using a workload id.
         * @summary Resume a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeTraining(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeTraining(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Suspend a training from running using a workload id.
         * @summary Suspend a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendTraining(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendTraining(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrainingsApi - factory interface
 * @export
 */
export const TrainingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrainingsApiFp(configuration)
    return {
        /**
         * Create a training workload using container related fields.
         * @summary Create a training.
         * @param {TrainingCreationRequest} [trainingCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTraining(trainingCreationRequest?: TrainingCreationRequest, options?: any): AxiosPromise<Training> {
            return localVarFp.createTraining(trainingCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a training using a workload id.
         * @summary Delete a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTraining(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteTraining(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve training details using a workload id.
         * @summary Get training data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTraining(workloadId: string, options?: any): AxiosPromise<Training> {
            return localVarFp.getTraining(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve trainings that were updated.
         * @summary List training updates.
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingsUpdates(updatesAfter: number, clusterId: string, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.listTrainingsUpdates(updatesAfter, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request training updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTrainingsUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.requestTrainingsUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * Resume a training that was suspended using a workload id.
         * @summary Resume a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeTraining(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.resumeTraining(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspend a training from running using a workload id.
         * @summary Suspend a training.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendTraining(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.suspendTraining(workloadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrainingsApi - object-oriented interface
 * @export
 * @class TrainingsApi
 * @extends {BaseAPI}
 */
export class TrainingsApi extends BaseAPI {
    /**
     * Create a training workload using container related fields.
     * @summary Create a training.
     * @param {TrainingCreationRequest} [trainingCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public createTraining(trainingCreationRequest?: TrainingCreationRequest, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).createTraining(trainingCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a training using a workload id.
     * @summary Delete a training.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public deleteTraining(workloadId: string, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).deleteTraining(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve training details using a workload id.
     * @summary Get training data.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public getTraining(workloadId: string, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).getTraining(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve trainings that were updated.
     * @summary List training updates.
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public listTrainingsUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).listTrainingsUpdates(updatesAfter, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve trainings that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
     * @summary Request training updates
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public requestTrainingsUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).requestTrainingsUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resume a training that was suspended using a workload id.
     * @summary Resume a training.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public resumeTraining(workloadId: string, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).resumeTraining(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suspend a training from running using a workload id.
     * @summary Suspend a training.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingsApi
     */
    public suspendTraining(workloadId: string, options?: AxiosRequestConfig) {
        return TrainingsApiFp(this.configuration).suspendTraining(workloadId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UnifiedApi - axios parameter creator
 * @export
 */
export const UnifiedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request unified workload and policy information
         * @summary Request unified workload information (internal for UI purposes)
         * @param {UnifiedWorkloadRequest} [unifiedWorkloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnifiedWorkload: async (unifiedWorkloadRequest?: UnifiedWorkloadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/unified`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unifiedWorkloadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnifiedApi - functional programming interface
 * @export
 */
export const UnifiedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnifiedApiAxiosParamCreator(configuration)
    return {
        /**
         * Request unified workload and policy information
         * @summary Request unified workload information (internal for UI purposes)
         * @param {UnifiedWorkloadRequest} [unifiedWorkloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnifiedWorkload(unifiedWorkloadRequest?: UnifiedWorkloadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnifiedWorkload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnifiedWorkload(unifiedWorkloadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnifiedApi - factory interface
 * @export
 */
export const UnifiedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnifiedApiFp(configuration)
    return {
        /**
         * Request unified workload and policy information
         * @summary Request unified workload information (internal for UI purposes)
         * @param {UnifiedWorkloadRequest} [unifiedWorkloadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnifiedWorkload(unifiedWorkloadRequest?: UnifiedWorkloadRequest, options?: any): AxiosPromise<UnifiedWorkload> {
            return localVarFp.getUnifiedWorkload(unifiedWorkloadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnifiedApi - object-oriented interface
 * @export
 * @class UnifiedApi
 * @extends {BaseAPI}
 */
export class UnifiedApi extends BaseAPI {
    /**
     * Request unified workload and policy information
     * @summary Request unified workload information (internal for UI purposes)
     * @param {UnifiedWorkloadRequest} [unifiedWorkloadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnifiedApi
     */
    public getUnifiedWorkload(unifiedWorkloadRequest?: UnifiedWorkloadRequest, options?: AxiosRequestConfig) {
        return UnifiedApiFp(this.configuration).getUnifiedWorkload(unifiedWorkloadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkloadTemplatesApi - axios parameter creator
 * @export
 */
export const WorkloadTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the number of templates.
         * @summary Count templates.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTemplates: async (filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new distributed template.
         * @summary Create a distributed template.
         * @param {DistributedTemplateCreationRequest} [distributedTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDistributedTemplate: async (distributedTemplateCreationRequest?: DistributedTemplateCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/distributed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distributedTemplateCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new inference template.
         * @summary Create a inference template.
         * @param {InferenceTemplateCreationRequest} [inferenceTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInferenceTemplate: async (inferenceTemplateCreationRequest?: InferenceTemplateCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/inferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferenceTemplateCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new training template.
         * @summary Create a training template.
         * @param {TrainingTemplateCreationRequest} [trainingTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrainingTemplate: async (trainingTemplateCreationRequest?: TrainingTemplateCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingTemplateCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new workspace template.
         * @summary Create a workspace template.
         * @param {WorkspaceTemplateCreationRequest} [workspaceTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceTemplate: async (workspaceTemplateCreationRequest?: WorkspaceTemplateCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceTemplateCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a distributed using its id.
         * @summary Delete a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDistributedTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteDistributedTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/distributed/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a inference using its id.
         * @summary Delete a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInferenceTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteInferenceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/inferences/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a training using its id.
         * @summary Delete a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrainingTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteTrainingTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/trainings/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a workspace using its id.
         * @summary Delete a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteWorkspaceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/workspaces/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a distributed template using its id.
         * @summary Get a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributedTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getDistributedTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/distributed/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a inference template using its id.
         * @summary Get a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getInferenceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/inferences/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a training template using its id.
         * @summary Get a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getTrainingTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/trainings/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the details of a workspace template using its id.
         * @summary Get a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplate: async (templateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getWorkspaceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/workspaces/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of distributed templates with details.
         * @summary List distributed templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributedTemplates: async (offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/distributed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of inference templates with details.
         * @summary List inference templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInferenceTemplates: async (offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/inferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of templates with details.
         * @summary List templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of training templates with details.
         * @summary List training templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingTemplates: async (offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of workspace templates with details.
         * @summary List workspace templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspaceTemplates: async (offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/templates/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a distributed template using its id.
         * @summary Patch a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {DistributedTemplatePatchRequest} [distributedTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDistributedTemplate: async (templateId: string, distributedTemplatePatchRequest?: DistributedTemplatePatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('patchDistributedTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/distributed/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distributedTemplatePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a inference template using its id.
         * @summary Patch a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {InferenceTemplatePatchRequest} [inferenceTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInferenceTemplate: async (templateId: string, inferenceTemplatePatchRequest?: InferenceTemplatePatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('patchInferenceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/inferences/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferenceTemplatePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a training template using its id.
         * @summary Patch a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {TrainingTemplatePatchRequest} [trainingTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTrainingTemplate: async (templateId: string, trainingTemplatePatchRequest?: TrainingTemplatePatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('patchTrainingTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/trainings/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingTemplatePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a workspace template using its id.
         * @summary Patch a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {WorkspaceTemplatePatchRequest} [workspaceTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceTemplate: async (templateId: string, workspaceTemplatePatchRequest?: WorkspaceTemplatePatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('patchWorkspaceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/workspaces/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceTemplatePatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a distributed template using its id.
         * @summary Update a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {DistributedTemplateUpdateRequest} [distributedTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDistributedTemplate: async (templateId: string, distributedTemplateUpdateRequest?: DistributedTemplateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateDistributedTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/distributed/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(distributedTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a inference template using its id.
         * @summary Update a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {InferenceTemplateUpdateRequest} [inferenceTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInferenceTemplate: async (templateId: string, inferenceTemplateUpdateRequest?: InferenceTemplateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateInferenceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/inferences/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inferenceTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update a training template using its id.
         * @summary Update a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {TrainingTemplateUpdateRequest} [trainingTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrainingTemplate: async (templateId: string, trainingTemplateUpdateRequest?: TrainingTemplateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateTrainingTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/trainings/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trainingTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update a workspace template using its id.
         * @summary Update a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {WorkspaceTemplateUpdateRequest} [workspaceTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceTemplate: async (templateId: string, workspaceTemplateUpdateRequest?: WorkspaceTemplateUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateWorkspaceTemplate', 'templateId', templateId)
            const localVarPath = `/api/v1/workloads/templates/workspaces/{templateId}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceTemplateUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkloadTemplatesApi - functional programming interface
 * @export
 */
export const WorkloadTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkloadTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the number of templates.
         * @summary Count templates.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countTemplates(filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countTemplates(filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new distributed template.
         * @summary Create a distributed template.
         * @param {DistributedTemplateCreationRequest} [distributedTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDistributedTemplate(distributedTemplateCreationRequest?: DistributedTemplateCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDistributedTemplate(distributedTemplateCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new inference template.
         * @summary Create a inference template.
         * @param {InferenceTemplateCreationRequest} [inferenceTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInferenceTemplate(inferenceTemplateCreationRequest?: InferenceTemplateCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInferenceTemplate(inferenceTemplateCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new training template.
         * @summary Create a training template.
         * @param {TrainingTemplateCreationRequest} [trainingTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrainingTemplate(trainingTemplateCreationRequest?: TrainingTemplateCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrainingTemplate(trainingTemplateCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new workspace template.
         * @summary Create a workspace template.
         * @param {WorkspaceTemplateCreationRequest} [workspaceTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkspaceTemplate(workspaceTemplateCreationRequest?: WorkspaceTemplateCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkspaceTemplate(workspaceTemplateCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a distributed using its id.
         * @summary Delete a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDistributedTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDistributedTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a inference using its id.
         * @summary Delete a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInferenceTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInferenceTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a training using its id.
         * @summary Delete a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrainingTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrainingTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a workspace using its id.
         * @summary Delete a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkspaceTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkspaceTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a distributed template using its id.
         * @summary Get a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistributedTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistributedTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a inference template using its id.
         * @summary Get a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInferenceTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInferenceTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a training template using its id.
         * @summary Get a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrainingTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrainingTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the details of a workspace template using its id.
         * @summary Get a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceTemplate(templateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceTemplate(templateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of distributed templates with details.
         * @summary List distributed templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDistributedTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedTemplatesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDistributedTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of inference templates with details.
         * @summary List inference templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInferenceTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceTemplatesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInferenceTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of templates with details.
         * @summary List templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplatesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of training templates with details.
         * @summary List training templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrainingTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingTemplatesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrainingTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of workspace templates with details.
         * @summary List workspace templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkspaceTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceTemplatesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkspaceTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Patch a distributed template using its id.
         * @summary Patch a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {DistributedTemplatePatchRequest} [distributedTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDistributedTemplate(templateId: string, distributedTemplatePatchRequest?: DistributedTemplatePatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDistributedTemplate(templateId, distributedTemplatePatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Patch a inference template using its id.
         * @summary Patch a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {InferenceTemplatePatchRequest} [inferenceTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchInferenceTemplate(templateId: string, inferenceTemplatePatchRequest?: InferenceTemplatePatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchInferenceTemplate(templateId, inferenceTemplatePatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Patch a training template using its id.
         * @summary Patch a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {TrainingTemplatePatchRequest} [trainingTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTrainingTemplate(templateId: string, trainingTemplatePatchRequest?: TrainingTemplatePatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTrainingTemplate(templateId, trainingTemplatePatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Patch a workspace template using its id.
         * @summary Patch a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {WorkspaceTemplatePatchRequest} [workspaceTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchWorkspaceTemplate(templateId: string, workspaceTemplatePatchRequest?: WorkspaceTemplatePatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchWorkspaceTemplate(templateId, workspaceTemplatePatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a distributed template using its id.
         * @summary Update a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {DistributedTemplateUpdateRequest} [distributedTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDistributedTemplate(templateId: string, distributedTemplateUpdateRequest?: DistributedTemplateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistributedTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDistributedTemplate(templateId, distributedTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a inference template using its id.
         * @summary Update a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {InferenceTemplateUpdateRequest} [inferenceTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInferenceTemplate(templateId: string, inferenceTemplateUpdateRequest?: InferenceTemplateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InferenceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInferenceTemplate(templateId, inferenceTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update a training template using its id.
         * @summary Update a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {TrainingTemplateUpdateRequest} [trainingTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrainingTemplate(templateId: string, trainingTemplateUpdateRequest?: TrainingTemplateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrainingTemplate(templateId, trainingTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update a workspace template using its id.
         * @summary Update a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {WorkspaceTemplateUpdateRequest} [workspaceTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkspaceTemplate(templateId: string, workspaceTemplateUpdateRequest?: WorkspaceTemplateUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkspaceTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkspaceTemplate(templateId, workspaceTemplateUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkloadTemplatesApi - factory interface
 * @export
 */
export const WorkloadTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkloadTemplatesApiFp(configuration)
    return {
        /**
         * Retrieve the number of templates.
         * @summary Count templates.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTemplates(filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<CountResponse> {
            return localVarFp.countTemplates(filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new distributed template.
         * @summary Create a distributed template.
         * @param {DistributedTemplateCreationRequest} [distributedTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDistributedTemplate(distributedTemplateCreationRequest?: DistributedTemplateCreationRequest, options?: any): AxiosPromise<DistributedTemplate> {
            return localVarFp.createDistributedTemplate(distributedTemplateCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new inference template.
         * @summary Create a inference template.
         * @param {InferenceTemplateCreationRequest} [inferenceTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInferenceTemplate(inferenceTemplateCreationRequest?: InferenceTemplateCreationRequest, options?: any): AxiosPromise<InferenceTemplate> {
            return localVarFp.createInferenceTemplate(inferenceTemplateCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new training template.
         * @summary Create a training template.
         * @param {TrainingTemplateCreationRequest} [trainingTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrainingTemplate(trainingTemplateCreationRequest?: TrainingTemplateCreationRequest, options?: any): AxiosPromise<TrainingTemplate> {
            return localVarFp.createTrainingTemplate(trainingTemplateCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new workspace template.
         * @summary Create a workspace template.
         * @param {WorkspaceTemplateCreationRequest} [workspaceTemplateCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspaceTemplate(workspaceTemplateCreationRequest?: WorkspaceTemplateCreationRequest, options?: any): AxiosPromise<WorkspaceTemplate> {
            return localVarFp.createWorkspaceTemplate(workspaceTemplateCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a distributed using its id.
         * @summary Delete a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDistributedTemplate(templateId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDistributedTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a inference using its id.
         * @summary Delete a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInferenceTemplate(templateId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteInferenceTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a training using its id.
         * @summary Delete a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrainingTemplate(templateId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTrainingTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a workspace using its id.
         * @summary Delete a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspaceTemplate(templateId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkspaceTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a distributed template using its id.
         * @summary Get a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistributedTemplate(templateId: string, options?: any): AxiosPromise<DistributedTemplate> {
            return localVarFp.getDistributedTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a inference template using its id.
         * @summary Get a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInferenceTemplate(templateId: string, options?: any): AxiosPromise<InferenceTemplate> {
            return localVarFp.getInferenceTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a training template using its id.
         * @summary Get a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrainingTemplate(templateId: string, options?: any): AxiosPromise<TrainingTemplate> {
            return localVarFp.getTrainingTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the details of a workspace template using its id.
         * @summary Get a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceTemplate(templateId: string, options?: any): AxiosPromise<WorkspaceTemplate> {
            return localVarFp.getWorkspaceTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of distributed templates with details.
         * @summary List distributed templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDistributedTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<DistributedTemplatesListResponse> {
            return localVarFp.listDistributedTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of inference templates with details.
         * @summary List inference templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInferenceTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<InferenceTemplatesListResponse> {
            return localVarFp.listInferenceTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of templates with details.
         * @summary List templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<TemplatesListResponse> {
            return localVarFp.listTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of training templates with details.
         * @summary List training templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrainingTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<TrainingTemplatesListResponse> {
            return localVarFp.listTrainingTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of workspace templates with details.
         * @summary List workspace templates.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspaceTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<WorkspaceTemplatesListResponse> {
            return localVarFp.listWorkspaceTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a distributed template using its id.
         * @summary Patch a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {DistributedTemplatePatchRequest} [distributedTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDistributedTemplate(templateId: string, distributedTemplatePatchRequest?: DistributedTemplatePatchRequest, options?: any): AxiosPromise<DistributedTemplate> {
            return localVarFp.patchDistributedTemplate(templateId, distributedTemplatePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a inference template using its id.
         * @summary Patch a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {InferenceTemplatePatchRequest} [inferenceTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInferenceTemplate(templateId: string, inferenceTemplatePatchRequest?: InferenceTemplatePatchRequest, options?: any): AxiosPromise<InferenceTemplate> {
            return localVarFp.patchInferenceTemplate(templateId, inferenceTemplatePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a training template using its id.
         * @summary Patch a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {TrainingTemplatePatchRequest} [trainingTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTrainingTemplate(templateId: string, trainingTemplatePatchRequest?: TrainingTemplatePatchRequest, options?: any): AxiosPromise<TrainingTemplate> {
            return localVarFp.patchTrainingTemplate(templateId, trainingTemplatePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a workspace template using its id.
         * @summary Patch a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {WorkspaceTemplatePatchRequest} [workspaceTemplatePatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkspaceTemplate(templateId: string, workspaceTemplatePatchRequest?: WorkspaceTemplatePatchRequest, options?: any): AxiosPromise<WorkspaceTemplate> {
            return localVarFp.patchWorkspaceTemplate(templateId, workspaceTemplatePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a distributed template using its id.
         * @summary Update a distributed template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {DistributedTemplateUpdateRequest} [distributedTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDistributedTemplate(templateId: string, distributedTemplateUpdateRequest?: DistributedTemplateUpdateRequest, options?: any): AxiosPromise<DistributedTemplate> {
            return localVarFp.updateDistributedTemplate(templateId, distributedTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a inference template using its id.
         * @summary Update a inference template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {InferenceTemplateUpdateRequest} [inferenceTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInferenceTemplate(templateId: string, inferenceTemplateUpdateRequest?: InferenceTemplateUpdateRequest, options?: any): AxiosPromise<InferenceTemplate> {
            return localVarFp.updateInferenceTemplate(templateId, inferenceTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * update a training template using its id.
         * @summary Update a training template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {TrainingTemplateUpdateRequest} [trainingTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrainingTemplate(templateId: string, trainingTemplateUpdateRequest?: TrainingTemplateUpdateRequest, options?: any): AxiosPromise<TrainingTemplate> {
            return localVarFp.updateTrainingTemplate(templateId, trainingTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * update a workspace template using its id.
         * @summary Update a workspace template.
         * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
         * @param {WorkspaceTemplateUpdateRequest} [workspaceTemplateUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkspaceTemplate(templateId: string, workspaceTemplateUpdateRequest?: WorkspaceTemplateUpdateRequest, options?: any): AxiosPromise<WorkspaceTemplate> {
            return localVarFp.updateWorkspaceTemplate(templateId, workspaceTemplateUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkloadTemplatesApi - object-oriented interface
 * @export
 * @class WorkloadTemplatesApi
 * @extends {BaseAPI}
 */
export class WorkloadTemplatesApi extends BaseAPI {
    /**
     * Retrieve the number of templates.
     * @summary Count templates.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public countTemplates(filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).countTemplates(filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new distributed template.
     * @summary Create a distributed template.
     * @param {DistributedTemplateCreationRequest} [distributedTemplateCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public createDistributedTemplate(distributedTemplateCreationRequest?: DistributedTemplateCreationRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).createDistributedTemplate(distributedTemplateCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new inference template.
     * @summary Create a inference template.
     * @param {InferenceTemplateCreationRequest} [inferenceTemplateCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public createInferenceTemplate(inferenceTemplateCreationRequest?: InferenceTemplateCreationRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).createInferenceTemplate(inferenceTemplateCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new training template.
     * @summary Create a training template.
     * @param {TrainingTemplateCreationRequest} [trainingTemplateCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public createTrainingTemplate(trainingTemplateCreationRequest?: TrainingTemplateCreationRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).createTrainingTemplate(trainingTemplateCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new workspace template.
     * @summary Create a workspace template.
     * @param {WorkspaceTemplateCreationRequest} [workspaceTemplateCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public createWorkspaceTemplate(workspaceTemplateCreationRequest?: WorkspaceTemplateCreationRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).createWorkspaceTemplate(workspaceTemplateCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a distributed using its id.
     * @summary Delete a distributed template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public deleteDistributedTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).deleteDistributedTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a inference using its id.
     * @summary Delete a inference template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public deleteInferenceTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).deleteInferenceTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a training using its id.
     * @summary Delete a training template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public deleteTrainingTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).deleteTrainingTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a workspace using its id.
     * @summary Delete a workspace template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public deleteWorkspaceTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).deleteWorkspaceTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a distributed template using its id.
     * @summary Get a distributed template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public getDistributedTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).getDistributedTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a inference template using its id.
     * @summary Get a inference template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public getInferenceTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).getInferenceTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a training template using its id.
     * @summary Get a training template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public getTrainingTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).getTrainingTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the details of a workspace template using its id.
     * @summary Get a workspace template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public getWorkspaceTemplate(templateId: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).getWorkspaceTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of distributed templates with details.
     * @summary List distributed templates.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public listDistributedTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).listDistributedTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of inference templates with details.
     * @summary List inference templates.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public listInferenceTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).listInferenceTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of templates with details.
     * @summary List templates.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public listTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).listTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of training templates with details.
     * @summary List training templates.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public listTrainingTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).listTrainingTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of workspace templates with details.
     * @summary List workspace templates.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy'} [sortBy] Sort results by parameter.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public listWorkspaceTemplates(offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'name' | 'workloadType' | 'runnable' | 'scopeType' | 'clusterId' | 'projectId' | 'departmentId' | 'createdAt' | 'updatedAt' | 'createdBy' | 'updatedBy', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).listWorkspaceTemplates(offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a distributed template using its id.
     * @summary Patch a distributed template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {DistributedTemplatePatchRequest} [distributedTemplatePatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public patchDistributedTemplate(templateId: string, distributedTemplatePatchRequest?: DistributedTemplatePatchRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).patchDistributedTemplate(templateId, distributedTemplatePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a inference template using its id.
     * @summary Patch a inference template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {InferenceTemplatePatchRequest} [inferenceTemplatePatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public patchInferenceTemplate(templateId: string, inferenceTemplatePatchRequest?: InferenceTemplatePatchRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).patchInferenceTemplate(templateId, inferenceTemplatePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a training template using its id.
     * @summary Patch a training template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {TrainingTemplatePatchRequest} [trainingTemplatePatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public patchTrainingTemplate(templateId: string, trainingTemplatePatchRequest?: TrainingTemplatePatchRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).patchTrainingTemplate(templateId, trainingTemplatePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a workspace template using its id.
     * @summary Patch a workspace template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {WorkspaceTemplatePatchRequest} [workspaceTemplatePatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public patchWorkspaceTemplate(templateId: string, workspaceTemplatePatchRequest?: WorkspaceTemplatePatchRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).patchWorkspaceTemplate(templateId, workspaceTemplatePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a distributed template using its id.
     * @summary Update a distributed template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {DistributedTemplateUpdateRequest} [distributedTemplateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public updateDistributedTemplate(templateId: string, distributedTemplateUpdateRequest?: DistributedTemplateUpdateRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).updateDistributedTemplate(templateId, distributedTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a inference template using its id.
     * @summary Update a inference template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {InferenceTemplateUpdateRequest} [inferenceTemplateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public updateInferenceTemplate(templateId: string, inferenceTemplateUpdateRequest?: InferenceTemplateUpdateRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).updateInferenceTemplate(templateId, inferenceTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update a training template using its id.
     * @summary Update a training template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {TrainingTemplateUpdateRequest} [trainingTemplateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public updateTrainingTemplate(templateId: string, trainingTemplateUpdateRequest?: TrainingTemplateUpdateRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).updateTrainingTemplate(templateId, trainingTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update a workspace template using its id.
     * @summary Update a workspace template.
     * @param {string} templateId The  Universally Unique Identifier (UUID) of the template.
     * @param {WorkspaceTemplateUpdateRequest} [workspaceTemplateUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadTemplatesApi
     */
    public updateWorkspaceTemplate(templateId: string, workspaceTemplateUpdateRequest?: WorkspaceTemplateUpdateRequest, options?: AxiosRequestConfig) {
        return WorkloadTemplatesApiFp(this.configuration).updateWorkspaceTemplate(templateId, workspaceTemplateUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkloadsApi - axios parameter creator
 * @export
 */
export const WorkloadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the number of workloads.
         * @summary Count workloads.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {boolean} [precise] Use this if you want to count the precise amount of workloads, uncached. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkloads: async (deleted?: boolean, filterBy?: Array<string>, search?: string, precise?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (precise !== undefined) {
                localVarQueryParameter['precise'] = precise;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the workload as is does not exist in the cluster anymore.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkload: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('deleteWorkload', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve workload data using a `workloadId`.
         * @summary Get a workload.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkload: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkload', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the workload ancestors.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadAncestors: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkloadAncestors', 'workloadId', workloadId)
            const localVarPath = `/internal/workloads/{workloadId}/ancestors`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves workloads data metrics from the metrics database. Use in reporting and analysis tools.
         * @summary Get workload metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {Array<WorkloadMetricType>} metricType Specify which data to request.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadMetrics: async (workloadId: string, metricType: Array<WorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkloadMetrics', 'workloadId', workloadId)
            // verify required parameter 'metricType' is not null or undefined
            assertParamExists('getWorkloadMetrics', 'metricType', metricType)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('getWorkloadMetrics', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('getWorkloadMetrics', 'end', end)
            const localVarPath = `/api/v1/workloads/{workloadId}/metrics`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (metricType) {
                localVarQueryParameter['metricType'] = metricType.join(COLLECTION_FORMATS.csv);
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }

            if (numberOfSamples !== undefined) {
                localVarQueryParameter['numberOfSamples'] = numberOfSamples;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of active workloads with details.
         * @summary List workloads.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt'} [sortBy] Sort results by a parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloads: async (deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt', filterBy?: Array<string>, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves workload data by telemetry type.
         * @summary Get the workloads telemetry.
         * @param {WorkloadTelemetryType} telemetryType Specifies the telemetry type.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodepoolName] Filter using the nodepool.
         * @param {string} [departmentId] Filter using the department id.
         * @param {Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>} [groupBy] Group workloads by field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadsTelemetry: async (telemetryType: WorkloadTelemetryType, clusterId?: string, nodepoolName?: string, departmentId?: string, groupBy?: Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'telemetryType' is not null or undefined
            assertParamExists('getWorkloadsTelemetry', 'telemetryType', telemetryType)
            const localVarPath = `/api/v1/workloads/telemetry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (nodepoolName !== undefined) {
                localVarQueryParameter['nodepoolName'] = nodepoolName;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (groupBy) {
                localVarQueryParameter['groupBy'] = groupBy.join(COLLECTION_FORMATS.csv);
            }

            if (telemetryType !== undefined) {
                localVarQueryParameter['telemetryType'] = telemetryType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a workload by the control plane.
         * @param {WorkloadCreationFields} workloadCreationFields The workload info in the control plane.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCreateWorkload: async (workloadCreationFields: WorkloadCreationFields, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadCreationFields' is not null or undefined
            assertParamExists('internalCreateWorkload', 'workloadCreationFields', workloadCreationFields)
            const localVarPath = `/internal/workloads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadCreationFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync workloads.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {InternalWorkloadsSyncRequest} [internalWorkloadsSyncRequest] The workloads to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSyncWorkloads: async (filterBy?: Array<string>, internalWorkloadsSyncRequest?: InternalWorkloadsSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/workloads/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalWorkloadsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary patch the workload phase from the client.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {WorkloadPatchFields} workloadPatchFields The workload info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkloadPhase: async (workloadId: string, workloadPatchFields: WorkloadPatchFields, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('patchWorkloadPhase', 'workloadId', workloadId)
            // verify required parameter 'workloadPatchFields' is not null or undefined
            assertParamExists('patchWorkloadPhase', 'workloadPatchFields', workloadPatchFields)
            const localVarPath = `/api/v1/workloads/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadPatchFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync workloads.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {WorkloadsSyncRequest} [workloadsSyncRequest] The workloads to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWorkloads: async (filterBy?: Array<string>, workloadsSyncRequest?: WorkloadsSyncRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterBy) {
                localVarQueryParameter['filterBy'] = filterBy.join(COLLECTION_FORMATS.csv);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadsSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upsert the workload info from the cluster.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {WorkloadSyncFields} workloadSyncFields The workload info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWorkload: async (workloadId: string, workloadSyncFields: WorkloadSyncFields, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('upsertWorkload', 'workloadId', workloadId)
            // verify required parameter 'workloadSyncFields' is not null or undefined
            assertParamExists('upsertWorkload', 'workloadSyncFields', workloadSyncFields)
            const localVarPath = `/api/v1/workloads/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadSyncFields, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkloadsApi - functional programming interface
 * @export
 */
export const WorkloadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkloadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the number of workloads.
         * @summary Count workloads.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {boolean} [precise] Use this if you want to count the precise amount of workloads, uncached. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countWorkloads(deleted?: boolean, filterBy?: Array<string>, search?: string, precise?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountWorkloads200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countWorkloads(deleted, filterBy, search, precise, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete the workload as is does not exist in the cluster anymore.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkload(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkload(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve workload data using a `workloadId`.
         * @summary Get a workload.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkload(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkload(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the workload ancestors.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloadAncestors(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ancestors>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloadAncestors(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves workloads data metrics from the metrics database. Use in reporting and analysis tools.
         * @summary Get workload metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {Array<WorkloadMetricType>} metricType Specify which data to request.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloadMetrics(workloadId: string, metricType: Array<WorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloadMetrics(workloadId, metricType, start, end, numberOfSamples, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of active workloads with details.
         * @summary List workloads.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt'} [sortBy] Sort results by a parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloads(deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkloads200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloads(deleted, offset, limit, sortOrder, sortBy, filterBy, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves workload data by telemetry type.
         * @summary Get the workloads telemetry.
         * @param {WorkloadTelemetryType} telemetryType Specifies the telemetry type.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodepoolName] Filter using the nodepool.
         * @param {string} [departmentId] Filter using the department id.
         * @param {Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>} [groupBy] Group workloads by field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkloadsTelemetry(telemetryType: WorkloadTelemetryType, clusterId?: string, nodepoolName?: string, departmentId?: string, groupBy?: Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TelemetryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkloadsTelemetry(telemetryType, clusterId, nodepoolName, departmentId, groupBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a workload by the control plane.
         * @param {WorkloadCreationFields} workloadCreationFields The workload info in the control plane.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalCreateWorkload(workloadCreationFields: WorkloadCreationFields, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Workload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalCreateWorkload(workloadCreationFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync workloads.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {InternalWorkloadsSyncRequest} [internalWorkloadsSyncRequest] The workloads to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalSyncWorkloads(filterBy?: Array<string>, internalWorkloadsSyncRequest?: InternalWorkloadsSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalSyncWorkloads(filterBy, internalWorkloadsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary patch the workload phase from the client.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {WorkloadPatchFields} workloadPatchFields The workload info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchWorkloadPhase(workloadId: string, workloadPatchFields: WorkloadPatchFields, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchWorkloadPhase(workloadId, workloadPatchFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync workloads.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {WorkloadsSyncRequest} [workloadsSyncRequest] The workloads to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncWorkloads(filterBy?: Array<string>, workloadsSyncRequest?: WorkloadsSyncRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncWorkloads(filterBy, workloadsSyncRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upsert the workload info from the cluster.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {WorkloadSyncFields} workloadSyncFields The workload info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertWorkload(workloadId: string, workloadSyncFields: WorkloadSyncFields, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertWorkload(workloadId, workloadSyncFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkloadsApi - factory interface
 * @export
 */
export const WorkloadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkloadsApiFp(configuration)
    return {
        /**
         * Retrieve the number of workloads.
         * @summary Count workloads.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {boolean} [precise] Use this if you want to count the precise amount of workloads, uncached. Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countWorkloads(deleted?: boolean, filterBy?: Array<string>, search?: string, precise?: boolean, options?: any): AxiosPromise<CountWorkloads200Response> {
            return localVarFp.countWorkloads(deleted, filterBy, search, precise, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the workload as is does not exist in the cluster anymore.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkload(workloadId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteWorkload(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve workload data using a `workloadId`.
         * @summary Get a workload.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkload(workloadId: string, options?: any): AxiosPromise<WorkloadDetailed> {
            return localVarFp.getWorkload(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the workload ancestors.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadAncestors(workloadId: string, options?: any): AxiosPromise<Ancestors> {
            return localVarFp.getWorkloadAncestors(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves workloads data metrics from the metrics database. Use in reporting and analysis tools.
         * @summary Get workload metrics data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {Array<WorkloadMetricType>} metricType Specify which data to request.
         * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
         * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
         * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadMetrics(workloadId: string, metricType: Array<WorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options?: any): AxiosPromise<MetricsResponse> {
            return localVarFp.getWorkloadMetrics(workloadId, metricType, start, end, numberOfSamples, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of active workloads with details.
         * @summary List workloads.
         * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
         * @param {number} [offset] The offset of the first item returned in the collection.
         * @param {number} [limit] The maximum number of entries to return.
         * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
         * @param {'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt'} [sortBy] Sort results by a parameter.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {string} [search] Filter results by a free text search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloads(deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt', filterBy?: Array<string>, search?: string, options?: any): AxiosPromise<GetWorkloads200Response> {
            return localVarFp.getWorkloads(deleted, offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves workload data by telemetry type.
         * @summary Get the workloads telemetry.
         * @param {WorkloadTelemetryType} telemetryType Specifies the telemetry type.
         * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
         * @param {string} [nodepoolName] Filter using the nodepool.
         * @param {string} [departmentId] Filter using the department id.
         * @param {Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>} [groupBy] Group workloads by field.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkloadsTelemetry(telemetryType: WorkloadTelemetryType, clusterId?: string, nodepoolName?: string, departmentId?: string, groupBy?: Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>, options?: any): AxiosPromise<TelemetryResponse> {
            return localVarFp.getWorkloadsTelemetry(telemetryType, clusterId, nodepoolName, departmentId, groupBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a workload by the control plane.
         * @param {WorkloadCreationFields} workloadCreationFields The workload info in the control plane.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCreateWorkload(workloadCreationFields: WorkloadCreationFields, options?: any): AxiosPromise<Workload> {
            return localVarFp.internalCreateWorkload(workloadCreationFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync workloads.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {InternalWorkloadsSyncRequest} [internalWorkloadsSyncRequest] The workloads to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalSyncWorkloads(filterBy?: Array<string>, internalWorkloadsSyncRequest?: InternalWorkloadsSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.internalSyncWorkloads(filterBy, internalWorkloadsSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary patch the workload phase from the client.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {WorkloadPatchFields} workloadPatchFields The workload info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchWorkloadPhase(workloadId: string, workloadPatchFields: WorkloadPatchFields, options?: any): AxiosPromise<void> {
            return localVarFp.patchWorkloadPhase(workloadId, workloadPatchFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync workloads.
         * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
         * @param {WorkloadsSyncRequest} [workloadsSyncRequest] The workloads to sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWorkloads(filterBy?: Array<string>, workloadsSyncRequest?: WorkloadsSyncRequest, options?: any): AxiosPromise<void> {
            return localVarFp.syncWorkloads(filterBy, workloadsSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upsert the workload info from the cluster.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {WorkloadSyncFields} workloadSyncFields The workload info in the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWorkload(workloadId: string, workloadSyncFields: WorkloadSyncFields, options?: any): AxiosPromise<void> {
            return localVarFp.upsertWorkload(workloadId, workloadSyncFields, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkloadsApi - object-oriented interface
 * @export
 * @class WorkloadsApi
 * @extends {BaseAPI}
 */
export class WorkloadsApi extends BaseAPI {
    /**
     * Retrieve the number of workloads.
     * @summary Count workloads.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {boolean} [precise] Use this if you want to count the precise amount of workloads, uncached. Defaults to false.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public countWorkloads(deleted?: boolean, filterBy?: Array<string>, search?: string, precise?: boolean, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).countWorkloads(deleted, filterBy, search, precise, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the workload as is does not exist in the cluster anymore.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public deleteWorkload(workloadId: string, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).deleteWorkload(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve workload data using a `workloadId`.
     * @summary Get a workload.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public getWorkload(workloadId: string, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).getWorkload(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the workload ancestors.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public getWorkloadAncestors(workloadId: string, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).getWorkloadAncestors(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves workloads data metrics from the metrics database. Use in reporting and analysis tools.
     * @summary Get workload metrics data.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {Array<WorkloadMetricType>} metricType Specify which data to request.
     * @param {string} start Start date of time range to fetch data in ISO 8601 timestamp format.
     * @param {string} end End date of time range to fetch data in ISO 8601 timestamp format.
     * @param {number} [numberOfSamples] The number of samples to take in the specified time range.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public getWorkloadMetrics(workloadId: string, metricType: Array<WorkloadMetricType>, start: string, end: string, numberOfSamples?: number, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).getWorkloadMetrics(workloadId, metricType, start, end, numberOfSamples, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of active workloads with details.
     * @summary List workloads.
     * @param {boolean} [deleted] Return only deleted resources when &#x60;true&#x60;.
     * @param {number} [offset] The offset of the first item returned in the collection.
     * @param {number} [limit] The maximum number of entries to return.
     * @param {'asc' | 'desc'} [sortOrder] Sort results in descending or ascending order.
     * @param {'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt'} [sortBy] Sort results by a parameter.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {string} [search] Filter results by a free text search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public getWorkloads(deleted?: boolean, offset?: number, limit?: number, sortOrder?: 'asc' | 'desc', sortBy?: 'type' | 'name' | 'clusterId' | 'projectId' | 'projectName' | 'departmentId' | 'departmentName' | 'createdAt' | 'deletedAt' | 'submittedBy' | 'phase' | 'completedAt' | 'nodepool' | 'distributedFramework' | 'allocatedGPU' | 'idleGpus' | 'idleAllocatedGpus' | 'phaseUpdatedAt', filterBy?: Array<string>, search?: string, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).getWorkloads(deleted, offset, limit, sortOrder, sortBy, filterBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves workload data by telemetry type.
     * @summary Get the workloads telemetry.
     * @param {WorkloadTelemetryType} telemetryType Specifies the telemetry type.
     * @param {string} [clusterId] Filter using the Universally Unique Identifier (UUID) of the cluster.
     * @param {string} [nodepoolName] Filter using the nodepool.
     * @param {string} [departmentId] Filter using the department id.
     * @param {Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>} [groupBy] Group workloads by field.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public getWorkloadsTelemetry(telemetryType: WorkloadTelemetryType, clusterId?: string, nodepoolName?: string, departmentId?: string, groupBy?: Array<'ClusterId' | 'DepartmentId' | 'ProjectId' | 'Type' | 'CurrentNodepools' | 'Phase'>, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).getWorkloadsTelemetry(telemetryType, clusterId, nodepoolName, departmentId, groupBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a workload by the control plane.
     * @param {WorkloadCreationFields} workloadCreationFields The workload info in the control plane.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public internalCreateWorkload(workloadCreationFields: WorkloadCreationFields, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).internalCreateWorkload(workloadCreationFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync workloads.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {InternalWorkloadsSyncRequest} [internalWorkloadsSyncRequest] The workloads to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public internalSyncWorkloads(filterBy?: Array<string>, internalWorkloadsSyncRequest?: InternalWorkloadsSyncRequest, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).internalSyncWorkloads(filterBy, internalWorkloadsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary patch the workload phase from the client.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {WorkloadPatchFields} workloadPatchFields The workload info in the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public patchWorkloadPhase(workloadId: string, workloadPatchFields: WorkloadPatchFields, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).patchWorkloadPhase(workloadId, workloadPatchFields, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync workloads.
     * @param {Array<string>} [filterBy] Filter results by a parameter. Use the format field-name operator value. Operators are &#x60;&#x3D;&#x3D;&#x60; Equals, &#x60;!&#x3D;&#x60; Not equals, &#x60;&lt;&#x3D;&#x60; Less than or equal, &#x60;&gt;&#x3D;&#x60; Greater than or equal, &#x60;&#x3D;@&#x60; contains, &#x60;!@&#x60; Does not contain, &#x60;&#x3D;^&#x60; Starts with and &#x60;&#x3D;$&#x60; Ends with. Dates are in ISO 8601 timestamp format and available for operators &#x60;&#x3D;&#x3D;&#x60;, &#x60;!&#x3D;&#x60;, &#x60;&lt;&#x3D;&#x60; and &#x60;&gt;&#x3D;&#x60;.
     * @param {WorkloadsSyncRequest} [workloadsSyncRequest] The workloads to sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public syncWorkloads(filterBy?: Array<string>, workloadsSyncRequest?: WorkloadsSyncRequest, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).syncWorkloads(filterBy, workloadsSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upsert the workload info from the cluster.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {WorkloadSyncFields} workloadSyncFields The workload info in the cluster.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsApi
     */
    public upsertWorkload(workloadId: string, workloadSyncFields: WorkloadSyncFields, options?: AxiosRequestConfig) {
        return WorkloadsApiFp(this.configuration).upsertWorkload(workloadId, workloadSyncFields, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkloadsBatchApi - axios parameter creator
 * @export
 */
export const WorkloadsBatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Workload batch operations.
         * @param {WorkloadBatch} [workloadBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchWorkloads: async (workloadBatch?: WorkloadBatch, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workloadBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkloadsBatchApi - functional programming interface
 * @export
 */
export const WorkloadsBatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkloadsBatchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Workload batch operations.
         * @param {WorkloadBatch} [workloadBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchWorkloads(workloadBatch?: WorkloadBatch, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchWorkloads(workloadBatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkloadsBatchApi - factory interface
 * @export
 */
export const WorkloadsBatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkloadsBatchApiFp(configuration)
    return {
        /**
         * 
         * @summary Workload batch operations.
         * @param {WorkloadBatch} [workloadBatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchWorkloads(workloadBatch?: WorkloadBatch, options?: any): AxiosPromise<BatchResponse> {
            return localVarFp.batchWorkloads(workloadBatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkloadsBatchApi - object-oriented interface
 * @export
 * @class WorkloadsBatchApi
 * @extends {BaseAPI}
 */
export class WorkloadsBatchApi extends BaseAPI {
    /**
     * 
     * @summary Workload batch operations.
     * @param {WorkloadBatch} [workloadBatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkloadsBatchApi
     */
    public batchWorkloads(workloadBatch?: WorkloadBatch, options?: AxiosRequestConfig) {
        return WorkloadsBatchApiFp(this.configuration).batchWorkloads(workloadBatch, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkspacesApi - axios parameter creator
 * @export
 */
export const WorkspacesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new workspace in a specific project in the cluster.
         * @summary Create a workspace.
         * @param {WorkspaceCreationRequest} [workspaceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspace: async (workspaceCreationRequest?: WorkspaceCreationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/workloads/workspaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workspaceCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a workspace using the workspace id.
         * @summary Delete a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspace: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('deleteWorkspace', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/workspaces/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve workspace details using a workload id.
         * @summary Get workspace data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspace: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('getWorkspace', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/workspaces/{workloadId}`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of workspaces that have updates.
         * @summary List workspaces updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspacesUpdates: async (updatesAfter: number, clusterId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('listWorkspacesUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('listWorkspacesUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/workspaces/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve workspaces that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request workspaces updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestWorkspacesUpdates: async (updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatesAfter' is not null or undefined
            assertParamExists('requestWorkspacesUpdates', 'updatesAfter', updatesAfter)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('requestWorkspacesUpdates', 'clusterId', clusterId)
            const localVarPath = `/api/v1/workloads/workspaces/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updatesAfter !== undefined) {
                localVarQueryParameter['updatesAfter'] = updatesAfter;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clusterSyncReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resume the workspace operation using the workspace id.
         * @summary Resume a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeWorkspace: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('resumeWorkspace', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/workspaces/{workloadId}/resume`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suspend a workspace using the workspace id.
         * @summary Suspend a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendWorkspace: async (workloadId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workloadId' is not null or undefined
            assertParamExists('suspendWorkspace', 'workloadId', workloadId)
            const localVarPath = `/api/v1/workloads/workspaces/{workloadId}/suspend`
                .replace(`{${"workloadId"}}`, encodeURIComponent(String(workloadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkspacesApi - functional programming interface
 * @export
 */
export const WorkspacesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkspacesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new workspace in a specific project in the cluster.
         * @summary Create a workspace.
         * @param {WorkspaceCreationRequest} [workspaceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWorkspace(workspaceCreationRequest?: WorkspaceCreationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Workspace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWorkspace(workspaceCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a workspace using the workspace id.
         * @summary Delete a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWorkspace(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWorkspace(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve workspace details using a workload id.
         * @summary Get workspace data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspace(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Workspace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspace(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a list of workspaces that have updates.
         * @summary List workspaces updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWorkspacesUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWorkspacesUpdates(updatesAfter, clusterId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve workspaces that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request workspaces updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestWorkspacesUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkloadsSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestWorkspacesUpdates(updatesAfter, clusterId, clusterSyncReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Resume the workspace operation using the workspace id.
         * @summary Resume a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeWorkspace(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeWorkspace(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Suspend a workspace using the workspace id.
         * @summary Suspend a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suspendWorkspace(workloadId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HttpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suspendWorkspace(workloadId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkspacesApi - factory interface
 * @export
 */
export const WorkspacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkspacesApiFp(configuration)
    return {
        /**
         * Create a new workspace in a specific project in the cluster.
         * @summary Create a workspace.
         * @param {WorkspaceCreationRequest} [workspaceCreationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWorkspace(workspaceCreationRequest?: WorkspaceCreationRequest, options?: any): AxiosPromise<Workspace> {
            return localVarFp.createWorkspace(workspaceCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a workspace using the workspace id.
         * @summary Delete a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWorkspace(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.deleteWorkspace(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve workspace details using a workload id.
         * @summary Get workspace data.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspace(workloadId: string, options?: any): AxiosPromise<Workspace> {
            return localVarFp.getWorkspace(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of workspaces that have updates.
         * @summary List workspaces updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkspacesUpdates(updatesAfter: number, clusterId: string, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.listWorkspacesUpdates(updatesAfter, clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve workspaces that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
         * @summary Request workspaces updates
         * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
         * @param {string} clusterId The id of the cluster
         * @param {ClusterSyncReport} [clusterSyncReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestWorkspacesUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: any): AxiosPromise<WorkloadsSyncResponse> {
            return localVarFp.requestWorkspacesUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(axios, basePath));
        },
        /**
         * Resume the workspace operation using the workspace id.
         * @summary Resume a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeWorkspace(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.resumeWorkspace(workloadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspend a workspace using the workspace id.
         * @summary Suspend a workspace.
         * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendWorkspace(workloadId: string, options?: any): AxiosPromise<HttpResponse> {
            return localVarFp.suspendWorkspace(workloadId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkspacesApi - object-oriented interface
 * @export
 * @class WorkspacesApi
 * @extends {BaseAPI}
 */
export class WorkspacesApi extends BaseAPI {
    /**
     * Create a new workspace in a specific project in the cluster.
     * @summary Create a workspace.
     * @param {WorkspaceCreationRequest} [workspaceCreationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public createWorkspace(workspaceCreationRequest?: WorkspaceCreationRequest, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).createWorkspace(workspaceCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a workspace using the workspace id.
     * @summary Delete a workspace.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public deleteWorkspace(workloadId: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).deleteWorkspace(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve workspace details using a workload id.
     * @summary Get workspace data.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public getWorkspace(workloadId: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).getWorkspace(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of workspaces that have updates.
     * @summary List workspaces updates
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public listWorkspacesUpdates(updatesAfter: number, clusterId: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).listWorkspacesUpdates(updatesAfter, clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve workspaces that were updated in the control plane, and reports about success/failures in applying previous updates at the cluster
     * @summary Request workspaces updates
     * @param {number} updatesAfter list only data with update counter greater than the provided value. for example updatesAfter&#x3D;5 should fetch data with updates counter 6 and above.
     * @param {string} clusterId The id of the cluster
     * @param {ClusterSyncReport} [clusterSyncReport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public requestWorkspacesUpdates(updatesAfter: number, clusterId: string, clusterSyncReport?: ClusterSyncReport, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).requestWorkspacesUpdates(updatesAfter, clusterId, clusterSyncReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resume the workspace operation using the workspace id.
     * @summary Resume a workspace.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public resumeWorkspace(workloadId: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).resumeWorkspace(workloadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suspend a workspace using the workspace id.
     * @summary Suspend a workspace.
     * @param {string} workloadId The  Universally Unique Identifier (UUID) of the workload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    public suspendWorkspace(workloadId: string, options?: AxiosRequestConfig) {
        return WorkspacesApiFp(this.configuration).suspendWorkspace(workloadId, options).then((request) => request(this.axios, this.basePath));
    }
}


